export default {
	"last_service_charge_invoice_date": {
		"en": "Last service charge invoice date",
		"ar": "تاريخ آخر فاتورة رسوم خدمات"
	},
	"Paid_Amount_Label": {
		"en": "Paid Amount (AED)",
		"ar": "المبلغ المدفوع (درهم)"
	},
	"explore_building": {
		"en": "Explore the Building",
		"ar": "إكتشف المبنى"
	},
	"Connecting_Minds_and_Creating_the_Future": {
		"en": "1 October 2021 – 31 March 2022",
		"ar": "1 أكتوبر 2021 - 31 مارس 2022"
	},
	"property_type": {
		"en": "Property Type",
		"ar": "نوع العقار"
	},
	"update_personal_info_via_trustee": {
		"en": "Update Personal Info via Trustee Office",
		"ar": "تحديث البيانات الشخصية بواسطة مراكز أمناء الخدمات العقارية"
	},
	"form_validate_dewa_number": {
		"en": "Please enter a valid dewa number",
		"ar": "يرجى إدخال رقم ديوا المحمول صحيح"
	},
	"support_email": {
		"en": "info@dubailand.gov.ae",
		"ar": "info@dubailand.gov.ae"
	},
	"login_as_individual": {
		"ar": "تسجيل الدخول كفرد",
		"en": "Login as an Individual"
	},
	"date-of-evaluation": {
		"en": "Date of Valuation",
		"ar": "تاريخ التثمين"
	},
	"contract_amount": {
		"en": "Contract Amount",
		"ar": "قيمة العقد"
	},
	"values_are_in_aed": {
		"en": "Per Sq. Mt/Ft Value displayed below is in AED",
		"ar": "لكل متر مربع، قدم مربع القيمة معروضة أدناه بالدرهم الإماراتي"
	},
	"Emirate_label": {
		"en": "Emirate",
		"ar": "الإمارة"
	},
	"is_free_hold": {
		"en": "Is Free Hold?",
		"ar": "هو عقد حر؟"
	},
	"home_proceed_to_payment": {
		"en": "Proceed to Payment",
		"ar": "متابعة للدفع"
	},
	"one_acc_desc": {
		"en": "Now you don’t need to login into different applications. Access your frequently used websites and services with just one login.",
		"ar": "الآن لست بحاجة إلى تسجيل الدخول إلى تطبيقات مختلفة. قم بالوصول إلى مواقع الويب والخدمات المستخدمة بكثرة بتسجيل دخول واحد فقط."
	},
	"passport": {
		"en": "Passport",
		"ar": "جواز السفر"
	},
	"access_anywhere": {
		"en": "Access Anywhere",
		"ar": "إمكانيّة الوصول من أي مكان"
	},
	"developer_id": {
		"en": "Developer Id",
		"ar": "معرف المطور"
	},
	"download_title_deed_certificate": {
		"en": "Download Title Deed Certificate",
		"ar": "تحميل شهادة الملكية"
	},
	"emirati-program-currently-employed": {
		"en": "Are you currently Employed",
		"ar": "هل أنت موظف حالياً"
	},
	"Umm_al_Quwain_Option_label": {
		"en": "Umm al-Quwain",
		"ar": "أم القوين"
	},
	"file size mb": {
		"en": "mb",
		"ar": "ميجابايت"
	},
	"LetsContinueOurEXCELLENCEJOURNEY": {
		"en": "Lets Continue our\u003Cbr/\u003E EXCELLENCE JOURNEY",
		"ar": "لنكمل رحلة التميز"
	},
	"RI-calculaor-result": {
		"en": "Rental Index Calculator Result",
		"ar": "تفاصيل التغيير المقترح"
	},
	"home_training_exam": {
		"en": "Training Courses and Exams",
		"ar": "الدورات التدريبية و الاختبارات"
	},
	"Upload_pledge_file": {
		"en": "Upload",
		"ar": "حفظ"
	},
	"save_fail": {
		"en": "Error",
		"ar": "خطأ"
	},
	"site_best_view_and_last_update": {
		"en": "This site is best viewed on latest versions of  Chrome / Firefox / Edge - Resolution 1920x1080\u003Cbr /\u003E\nSite was last updated on",
		"ar": "أفضل عرض لهذا الموقع على أحدث إصدارات Chrome / Firefox / Edge - Resolution 1920x1080\u003Cbr /\u003E  تم آخر تحديث للموقع في"
	},
	"Home_Land_Status_Proceed": {
		"en": "Proceed to Property Status",
		"ar": "انتقل إلى الإستعلام عن حالة عقار"
	},
	"search_within": {
		"en": "Search within",
		"ar": "البحث من خلال"
	},
	"tenant": {
		"en": "Tenant",
		"ar": "مستأجر"
	},
	"form_validate_procedure_number": {
		"en": "Please enter a valid procedure number",
		"ar": "يرجى إدخال رقم الاجراء صحيح"
	},
	"no": {
		"en": "No",
		"ar": "لا"
	},
	"expo_description_text": {
		"en": "Join the making of a new world at the greatest showcase of human brilliance and achievement",
		"ar": " شارك في صنع عالم جديد، في أكبر معرض للذكاء والإنجاز البشري"
	},
	"Home_Service_Charge_Index": {
		"en": "Inquiry about Services fees indicator",
		"ar": "الإستعلام عن مؤشر رسوم الخدمات"
	},
	"golden-cube": {
		"en": "Golden Cube",
		"ar": "جولدن كيــــــــــوب"
	},
	"supplier_submit_msg": {
		"en": "Your request has been sent successfully.",
		"ar": "تم ارسال طلبك بنجاح."
	},
	"license_end_date": {
		"en": "License End Date",
		"ar": "تاريخ انتهاء الترخيص"
	},
	"escrow_service_desc": {
		"en": "This service allows clients to search for escrow agents certified by Dubai Land Department.\n                                        This service is provided by the Real Estate Trust Account Development  Department - Escrow Account Section on the Department's website.",
		"ar": "تتيح هذه الخدمة للعملاء البحث عن وكلاء الضمان المعتمدين من دائرة الأراضي والأملاك في دبي. يتم توفير هذه الخدمة من قبل تسجيل المطورين في ادارة حسابات ضمان النطوير العقاري."
	},
	"gifts": {
		"en": "Gifts",
		"ar": "هبات"
	},
	"Home_Title_Deed_Verification_text": {
		"en": "This service allows customers to verify their title-deed from Dubai Land . The Title Deed verification will show key property and ownership details held by the Land Registry such as property description, owner information and property status.",
		"ar": "هذه الخدمة تتيح للعملاء التحقيق من عقد الملكية من هيئه دبي للاراضي. تحقيق عقد الملكية سيوضح تفاصيل العقار و المالك المسجلة مثل وثف العقار و بيانات الشخص بالاضاه الى حالة العقار"
	},
	"form_validate_contract_number": {
		"en": "Please enter a valid contract number",
		"ar": "يرجى إدخال رقم العقد المحمول صحيح"
	},
	"and": {
		"en": "and",
		"ar": "و"
	},
	"no_result_found_label": {
		"en": "No Result Found",
		"ar": "لم يتم العثور على نتائج"
	},
	"SearchBy_Project_Name_Label": {
		"ar": "بحث المشروع بالا سم / برقم المشروع",
		"en": "Search by Project Name / Project Number"
	},
	"more-sales-percentages": {
		"en": "Sales Percentage",
		"ar": "نسبة المبيعات"
	},
	"owner_committee_terms_val_14": {
		"en": "RERA has the right to accept or reject any application or cancel any Committee membership at any time without declaring  the reason.",
		"ar": "يحق للمؤسسة قبول أو رفض اي طلب مقدم أو الغاء اي عضوية في أي وقت دون الأخطار بالأسباب."
	},
	"home_banner_Download_Ejari_Contract": {
		"en": "Download\u003Cbr/\u003E Ejari Certificate",
		"ar": "تحميل شهادة \u003Cbr/\u003E تسجيل عقد ايجار"
	},
	"rental_index_type": {
		"en": "Rental Index Type",
		"ar": "نوع الأيجار"
	},
	"home_banner_Registration_Trustees": {
		"en": "Registration Trustees",
		"ar": "أمين التسجيل العقاري"
	},
	"home_Real_Estate_Services_at_your_fingertips": {
		"en": "Real Estate Services at your fingertips",
		"ar": "خدمات العقارات في متناول يدك"
	},
	"survey_description": {
		"en": "Measuring opinions about the Corporate Communications Department’s services for 2021",
		"ar": " قياس رأي أنشطة إدارة الاتصال المؤسسي  لدى دائرة الأراضي والأملاك في دبي 2021"
	},
	"continue": {
		"en": "Continue",
		"ar": "استمر"
	},
	"rt_registration_next_step": {
		"en": "You can track the status of your request in \"My Requests\".",
		"ar": "يمكنك تتبع حالة طلبك في \"طلباتي\"."
	},
	"home_mosher_index_title": {
		"en": "Mo’asher Sales Price Index",
		"ar": "مؤشر البيع الرسمي"
	},
	"broker_training_FAQs_Q6": {
		"en": "\u003Cp class=\"fw-bold\"\u003E\n                                    Q. I am not able to attend the training, how can I reschedule it?\n                                \u003C/p\u003E\n                                \u003Cp\u003E\n                                    \u003Cb\u003E A.\u003C/b\u003E You can send email to support@dubailand.gov.ae to reschedule your course.\n                                \u003C/p\u003E",
		"ar": "\u003Cp class=\"fw-bold\"\u003E\n                                    Q. لا أستطيع حضور التدريب، كيف يمكنني إعادة جدولته؟\n                                \u003C/p\u003E\n                                \u003Cp\u003E\n                                    \u003Cb\u003E A.\u003C/b\u003E بإمكانك إرسال بريد إلكتروني إلى support@dubailand.gov.ae لإعادة جدولة دورتك.\n                                \u003C/p\u003E"
	},
	"work_days": {
		"en": "Working days",
		"ar": "ايام العمل"
	},
	"rt_upload_and_submit": {
		"en": "Upload & Submit",
		"ar": "تحميل وإرسال"
	},
	"Customer_Happiness_Charter_description": {
		"en": "The objective of the customer happiness charter is to guarantee an outstanding customer experience and continually improve it.",
		"ar": "الهدف من ميثاق سعادة المتعاملين هو ضمان تجربة متميزة لهم، وتحسينها باستمرار."
	},
	"contract_value": {
		"en": "Contract Value",
		"ar": "قيمة العقد"
	},
	"Locate Us": {
		"en": "Locate Us",
		"ar": "اعثر على موقعنا"
	},
	"profile": {
		"en": "Profile",
		"ar": "الملف الشخصي"
	},
	"register_tenant_info": {
		"en": "You are not registered as a tenant. Please register to continue.",
		"ar": "أنت غير مسجل كمستأجر. يرجى التسجيل للمتابعة."
	},
	"PropertyTrustee_title": {
		"en": "Real Estate Service Trustee Centres",
		"ar": "مراكز أمناء الخدمات العقارية"
	},
	"request_add_text": {
		"en": "Make a request to become a Committee Member",
		"ar": "قدم طلبًا لتصبح عضوًا في اللجنة"
	},
	"sso_app_desc_dsr": {
		"en": "Allowing property developers to submit their procedure requests online and manage them according to their priorities.",
		"ar": "السماح للمطورين بتقديم طلبات الإجراءات الخاصة بهم عبر الإنترنت وإدارتها وفقًا لأولوياتهم."
	},
	"about_us_organization": {
		"en": "About Us & Organization info",
		"ar": "معلومات عن دائرة الاراضي والاملاك"
	},
	"Qualification and Training Services": {
		"en": "Qualification and Training Services",
		"ar": "خدمات التدريب و التأهيل"
	},
	"role_based_label2": {
		"en": "Now you can access all your services based on your Role",
		"ar": "الآن يمكنك الوصول إلى جميع خدماتك بناءً على دورك"
	},
	"Project_Number_Label": {
		"en": "Project Number",
		"ar": "رقم المشروع"
	},
	"building_name": {
		"en": "Building Name",
		"ar": "اسم المبنى"
	},
	"registrationTrusteeOfficeTiming": {
		"en": "The official working hours of the real estate registration trustees centers start at 9:00 am until 2:30 pm, from Monday to Thursday On Friday from 9:00 am to 12:00 pm",
		"ar": "الدوام الرسمي لمراكز أمناء التسجيل العقاري يبدأ في الساعة 9:00 صباحاً وحتى 2:30 ظهراً من الاثنين الى الخميس\nيوم الجمعة من الساعة 9:00 صباحا وحتى الساعة  12:00 ظهرا"
	},
	"broker_training_FAQs_Q3": {
		"ar": "\u003Cp class=\"fw-bold\"\u003E\n                                    Q. هل سأحصل على شهادة؟\n                                \u003C/p\u003E\n                                \u003Cp\u003E\n                                    \u003Cb\u003E A.\u003C/b\u003E نعم، ستحصل على شهادة عند إكمال الدورة التدريبية\n                                \u003C/p\u003E",
		"en": "\u003Cp class=\"fw-bold\"\u003E\n                                    Q. Will I get the certificate?\n                                \u003C/p\u003E\n                                \u003Cp\u003E\n                                    \u003Cb\u003E A.\u003C/b\u003E Yes, you will be receiving the course of completion certificate.\n                                \u003C/p\u003E"
	},
	"view_article": {
		"en": "View Full Article",
		"ar": "شاهد المقال"
	},
	"properties": {
		"en": "Properties",
		"ar": "عقار"
	},
	"RDC tooltip": {
		"en": "Rental Dispute Center",
		"ar": "مركز فض النزاعات الايجارية"
	},
	"Mollak": {
		"en": "Mollak",
		"ar": "مُلاك"
	},
	"dld_account_coming_soon": {
		"en": "Coming Soon",
		"ar": "قريبا"
	},
	"login_ind_pro": {
		"en": "Proceed to Login as an Individual",
		"ar": "الشروع في تسجيل الدخول كفرد"
	},
	"project_status_under_reviewing": {
		"en": "Under Reviewing",
		"ar": "قيد المراجعة"
	},
	"site_plan_browser": {
		"en": "Site Plan (Opens in browser)",
		"ar": "عرض الخارطة"
	},
	"nearest_mall": {
		"en": "Nearest Mall",
		"ar": "أقرب مول"
	},
	"nationality_ar": {
		"en": "Nationality (Arabic)",
		"ar": "الجنسية (بالعربية)"
	},
	"signup": {
		"en": "Signup",
		"ar": "التسجيل"
	},
	"rvs_complaint_note_3": {
		"en": "Any disputes or complaints of transactions older than six months are not considered",
		"ar": "لا يتم النظرفي أي نزاعات أو شكاوى للمعاملات التي مضى عليها أكثر من ستة أشهر"
	},
	"comp_sub_service": {
		"en": "Sub Service",
		"ar": "الخدمة الفرعية"
	},
	"my_dashboard": {
		"en": "My Dashboard",
		"ar": "لوحة التحكم الخاصة بي"
	},
	"entered": {
		"en": "Entered",
		"ar": "مدخل"
	},
	"h_Connect_with_Us": {
		"en": "Follow Us on \u003Cbr/\u003ESocial Media",
		"ar": "تابعنا على قنوات \u003Cbr/\u003E التواصل الاجتماعي "
	},
	"total_lands": {
		"en": "Total Lands",
		"ar": "مجموع الأراضي"
	},
	"real_estate_violations": {
		"en": "Real Estate Violations",
		"ar": "المخالفات العقارية"
	},
	"Partnership": {
		"en": "Partnership",
		"ar": "الشراكات المؤسسية"
	},
	"custom_range": {
		"en": "Custom Range",
		"ar": "فترة زمنية"
	},
	"Is_the_property_blocked": {
		"en": "Is the property blocked?",
		"ar": "هل العقار محجوز؟"
	},
	"project_transactions": {
		"en": "Project Transactions",
		"ar": "المشروعات العقارية"
	},
	"complaint_against_Service": {
		"en": "Complaint Against Service",
		"ar": "شكوى على خدمة"
	},
	"form_validate_mun_sub_number": {
		"en": "Please enter a valid municipality sub number",
		"ar": "يرجى إدخال الرقم الفرعي المحمول صحيح"
	},
	"registration_and_property_trustees": {
		"en": "Registration and Property Trustees",
		"ar": "امين التسجيل و الامين العقارى"
	},
	"my_complaints": {
		"en": "My Complaints",
		"ar": "شكاوي"
	},
	"partnershipRealEstatePartnersDescription": {
		"en": "This category includes partners in the real estate sector as they are relevant stakeholders to develop Dubai's real estate market through projects, which are identified by the department",
		"ar": "هم الشركاء العاملين و المعنيين ذوي العلاقة بتطوير سوق دبي العقاري من خلال المشاريع التى يتم تحديدها من قبل الدائرة"
	},
	"map_exception_reason": {
		"en": "Exception Reason",
		"ar": "سبب الاستثناء"
	},
	"more-budget-label1": {
		"en": "How much are you planning to invest?",
		"ar": "ما المبلغ الذي تخطط لاستثماره؟"
	},
	"rented": {
		"en": "Rented",
		"ar": "مؤجرة"
	},
	"home_anti_money_laundering": {
		"en": "Anti-Money \u003Cbr/\u003ELaundering (AML)",
		"ar": "ضوابط مواجهة\u003Cbr/\u003E غسل الأموال"
	},
	"tabu_file_exceed_size": {
		"en": "Selected file exceeds the maximum allowed size of 2MB",
		"ar": "يتجاوز حجم الملف المحدد الحد الأقصى المسموح به وهو 2 ميغابايت"
	},
	"Dubai Municipality": {
		"en": "Dubai Municipality",
		"ar": "بلدية دبي"
	},
	"cu_Working_hours_text": {
		"en": "\u003Cspan style=\"display:inline-flex;\"\u003EMonday till Thursday from 7:30 am until 3:30 pm, Friday 7:30 am till 12:00 pm",
		"ar": "\u003Cspan style=\"display:inline-flex;\"\u003Eمن الاثنين إلى الخميس من 7:30 صباحًا حتى 3:30 مساءً ، الجمعة 7:30 صباحًا حتى 12:00 مساءً"
	},
	"company_certificate": {
		"en": "International Standards Certificates",
		"ar": "شهادات المعايير العالمية"
	},
	"Management_Message": {
		"en": "Management’s Message",
		"ar": "كلمة الأدارة"
	},
	"complaints_handling_process_steps3_title": {
		"en": "Complaint Administrator will review and inform the customer on the resolution",
		"ar": "يقوم المسؤول عن الشكوى بمراجعة وتقييم الشكوى ومن ثمّ تزويد المتعامل بإجراءات حلّها"
	},
	"cppi-view-the-report": {
		"en": "View the Report",
		"ar": "للإطلاع علي التقرير"
	},
	"modal_weather_content": {
		"en": "In accordance with the government's directive, all DLD employees will be working remotely on, 2nd and 3rd of May, due to the forecasted weather conditions.",
		"ar": "نظراً للأحوال الجوية السائدة في الدولة، نعلمكم بأن كافة موظفينا يعملون عن بعد اليوم، الخميس والجمعة 02 - 03 مايو ."
	},
	"enter_project_min_5_chars": {
		"en": "Minimum 2 characters of the project name",
		"ar": " ادخال 2 احرف او اكثر من اسم المشروع "
	},
	"contract_end_date": {
		"en": "Contract End Date",
		"ar": "تاريخ انتهاء العقد"
	},
	"cppi-CORI": {
		"en": "Commercial, Office and Retail Indices",
		"ar": "Commercial, Office and Retail Indices"
	},
	"Emirates_NBD_Account_Non_UAE_Residents": {
		"en": "Emirates NBD Bank Account for\u003Cbr /\u003ENon-UAE Residents",
		"ar": "حساب بنك الإمارات دبي الوطني لغير المقيمين في دولة الإمارات"
	},
	"repr_name": {
		"en": "Company legal representative",
		"ar": "الممثل القانونى للشركة"
	},
	"auction_noti_msg_1": {
		"en": "Building in Al Muteena for Sale, 196 Sq. Metres – Reserved Price AED 3,300,000",
		"ar": ".مبنى في المطينه للبيع ، 196 متر مربع - السعر الأساسي 3،300،000 درهم"
	},
	"user_name": {
		"en": "Username",
		"ar": "اسم المستخدم"
	},
	"most_popular_services": {
		"ar": "الأكثر استخداماً",
		"en": "Most Popular Services"
	},
	"One_Bedroom_Option": {
		"en": "One Bedroom Set",
		"ar": "غرفة نوم واحدة مجموعة"
	},
	"we_have_sent_pass_code_to_your_registered_mobile_number": {
		"en": "We have sent a passcode to your registered mobile number",
		"ar": "لقد أرسلنا رمز مرور إلى رقم هاتفك الجوال"
	},
	"copy_download_url": {
		"en": "Copy Download URL",
		"ar": "نسخ رابط التحميل"
	},
	"total_mortgaged": {
		"en": "Total Mortgaged",
		"ar": "إجمالي الرهونات"
	},
	"balcony_area": {
		"en": "Balcony Area",
		"ar": "مساحة البلكونة"
	},
	"sso_app_desc_mollak": {
		"en": "Regulate jointly owned properties, service charges, and monitor the payment of service charges.",
		"ar": "تنظيم العقارات ذات الملكية المشتركة ورسوم الخدمات ومراقبة دفع رسوم الخدمات."
	},
	"verdict_date": {
		"en": "Verdict Date",
		"ar": "تاريخ الحكم"
	},
	"E_EXECUTIVE_WRITE_MATURE": {
		"en": "e-Execution Writ can be issued for this case. You can proceed and register your enforcement case immediately.",
		"ar": "سيتم إصدار الصيغة التنفيذية إلكترونياُ عند تسجيل ملف التنفيذ"
	},
	"residential": {
		"en": "Residential",
		"ar": "سكني"
	},
	"e_g_number": {
		"ar": "e.g. 123",
		"en": "e.g. 123"
	},
	"broker_information_text": {
		"en": "Broker Information",
		"ar": "معلومات الوسيط"
	},
	"partnershipIPO": {
		"en": "International Partners or Organizations",
		"ar": "الشركاء الدوليين"
	},
	"form_validate_complain_category": {
		"en": "Please select the complain category ",
		"ar": "يرجى إختيار نوع الشكوى"
	},
	"rt_party_eid_passport": {
		"en": "Please enter either Emirates ID or Passport & Nationality.",
		"ar": "الرجاء إدخال رقم الهوية أو رقم جواز السفر والجنسية."
	},
	"case_year": {
		"en": "Case Year",
		"ar": "السنة"
	},
	"full-name-placeholder": {
		"en": "Please enter your full name ",
		"ar": "يرجى إدخال اسمك الكامل "
	},
	"Licensed_Brokers_And_Developers": {
		"en": "Licensed Brokers\u003Cbr /\u003E And Developers",
		"ar": "الوسطاء والمطورين المرخصين"
	},
	"Re-Shield-Submit-Label": {
		"en": "Proceed",
		"ar": "متابعة"
	},
	"less": {
		"en": "less",
		"ar": "اقل"
	},
	"notice_delivery_date_msg": {
		"en": "In order to continue, 30 days must pass from notice delivery date",
		"ar": "يجب أن يمر 30 يوما على الأقل من تاريخ تسليم الإخطار العدلي"
	},
	"auth_bad_conduct": {
		"en": "There's enforcement cases against the authority with the below license number",
		"ar": "يوجد دعاوي تنفيذ ضد الهيئة صاحبة الرخصة ادناه"
	},
	"banner-introducing-support-ticket-process": {
		"en": "Introducing Our New Support Ticket Process",
		"ar": "تقديم عملية إنشاء طلبات الدعم الفني الجديدة"
	},
	"detailed_report_disclaimer": {
		"en": "The detailed report is available for the period of one month only",
		"ar": "التقرير التفصيلي متاح لمدة شهر واحد فقط"
	},
	"RI-no-increase": {
		"en": "No Increase",
		"ar": "لا توجد زيادة"
	},
	"rented_properties": {
		"en": "Rented Properties",
		"ar": "العقارات المؤجرة"
	},
	"Home_RDC_Pay_Fees_Deposits_proceed": {
		"en": "RDC - Pay Fees or Deposits",
		"ar": "مركز فض المنازعات الإيجارية - ادفع مستحقاتك الان"
	},
	"project_information": {
		"en": "Project Information",
		"ar": "معلومات المشروع"
	},
	"invalid_license_number": {
		"en": "Invalid license number",
		"ar": "Invalid license number"
	},
	"Re-Shield-Content2": {
		"en": "Before we proceed, lets gather some information to know you better",
		"ar": "قبل أن نكمل، نرجو إدخال بعض المعلومات لتساعدنا في التعرف عليك."
	},
	"wrong_uae_id": {
		"en": "UAE ID is not valid",
		"ar": "رقم الهوية غير صحيح"
	},
	"form_validate_client_name": {
		"en": "Please enter a client name",
		"ar": "يرجى إختيار اسم العميل"
	},
	"login_via": {
		"en": "Sign in via",
		"ar": "دخول النظام عن طريق"
	},
	"DREI tooltip": {
		"en": "Dubai Real Estate Institute",
		"ar": "معهد دبي العقاري"
	},
	"existing_properties": {
		"en": "Existing Properties",
		"ar": "العقارات المنجزه"
	},
	"view_all": {
		"en": "View All",
		"ar": "عرض الكل"
	},
	"more-project": {
		"en": "Project",
		"ar": "المشروع"
	},
	"confidentiality": {
		"ar": "Confidentiality",
		"en": "Confidentiality"
	},
	"error_desc": {
		"en": "\u003Cb\u003EOops..\u003C/b\u003E the page you were looking for is no longer available. We've been informed about it so we will try to fix it right away. \u003Cbr /\u003EIn the mean time why not take a look at the links below to browse  through our website.",
		"ar": "\u003Cb\u003E عفوًا .. \u003C/ b\u003E الصفحة التي كنت تبحث عنها غير موجودة. لقد تم إبلاغنا بذلك ، لذا سنحاول إصلاحها على الفور. \u003Cbr /\u003E في الوقت نفسه ،يمكنك ان تلقي نظرة على الروابط أدناه لتصفح موقعنا."
	},
	"sso_app_desc_eQuery": {
		"en": "Government query system which provides information about owners, properties and associated transactions.",
		"ar": "نظام إستعلام حكومي يوفر بيانات عن الملاك و العقارات و الإجراءات المرتبطة"
	},
	"trustee_centres_description": {
		"en": "This service allows customers to search for the sites of Registration Trustees and Property Trustee Centres providing the services of the Real Estate Transaction Services such as registration of sale and mortgage.",
		"ar": "تتيح هذه الخدمة للمتعاملين البحث عن مواقع أمناء التسجيل، ومراكز أمناء الخدمات العقارية، التي تقدم خدمات التصرفات العقارية، مثل تسجيل البيع والرهن."
	},
	"Completion_Certificate": {
		"en": "\u003Cspan\u003ECompletion Certificate\u003C/span\u003E\n\u003Cspan\u003EEarn an certificate upon completion\u003C/span\u003E",
		"ar": "\u003Cspan\u003Eشهادة إتمام\u003C/span\u003E\n\u003Cspan\u003Eاحصل على شهادة عند إتمام الدورة \u003C/span\u003E"
	},
	"banner-emirati-program-tech-assist": {
		"en": "For any technical assistance, please contact our support team at nb-support@dubailand.gov.ae",
		"ar": "لطلب المساعدة الفنية يمكن الاتصال بفريق الدعم الفني على البريد الالكتروني nb-support@dubailand.gov.ae"
	},
	"Re-Shield-Answer": {
		"en": "Answer:",
		"ar": "جواب:"
	},
	"agree_extra_fee": {
		"en": "I agree to pay the extra amount required (355 AED per Sqft)",
		"ar": "أوافق على دفع المبلغ الإضافي المطلوب (355 درهمًا لكل قدم مربع)"
	},
	"more-home": {
		"en": "Home",
		"ar": "المنزل"
	},
	"home_banner_webinar_date": {
		"en": "Wednesday 25/11/2020",
		"ar": "الأربعاء 25/11/2020"
	},
	"CaseOwner": {
		"en": "From",
		"ar": "من"
	},
	"home_Complaint": {
		"en": "Complaint",
		"ar": "الشكاوى"
	},
	"title_deed_not_found": {
		"en": "Invalid title deed",
		"ar": "سند الملكية غير صالح"
	},
	"other_partner": {
		"en": "Other\u003Cbr /\u003E Partners",
		"ar": "الشركاء الآخرون"
	},
	"more-personal-information": {
		"en": " Personal Information",
		"ar": " المبلغ المستحق للإنجاز"
	},
	"Register_and_Renew_Ejari_Contract": {
		"en": "Register and Renew\u003Cbr/\u003EEjari Contract",
		"ar": "تسجيل وتجديد عقد الإيجار"
	},
	"modal_Announcement_title": {
		"en": "Dubai Real Estate Broker Program",
		"ar": "برنامج دبي للوسيط العقاري"
	},
	"valuator_number": {
		"en": "Valuator Number",
		"ar": "رقم المقيم"
	},
	"updates": {
		"en": "Updates",
		"ar": "تحديثـات"
	},
	"add_project_t": {
		"en": "Please click on \"Add Project\"",
		"ar": "من فضلك اضغط علي \"إضافة مشروع\""
	},
	"case_type": {
		"en": "Case Type",
		"ar": "نوع الدعوى"
	},
	"connect_to_us": {
		"en": "Connect with Us",
		"ar": "تواصل معنا"
	},
	"transaction_number": {
		"en": "Transaction Number",
		"ar": "رقم المعاملة"
	},
	"rt_office_transaction_requests": {
		"en": "RT Office Transaction Requests",
		"ar": "طلبات مكتب أمين التسجيل العقاري"
	},
	"is_lease_hold": {
		"en": "Is Lease Hold",
		"ar": "هو مستأجر"
	},
	"home_banner_webinar_time": {
		"en": "11:00 AM to 1:00 PM",
		"ar": "11:00 AM to 1:00 PM"
	},
	"project_unit_section": {
		"en": "3 - Project / Unit Details",
		"ar": "3 - بيانات المشروع / الوحدة"
	},
	"oqood_system_info": {
		"en": "Oqood System to manage Off-plan properties for developers.",
		"ar": "نظام عقود لإدارة العقارات على الخارطة للمطورين."
	},
	"budget_label": {
		"en": "Budget",
		"ar": "Budget"
	},
	"owner_committee_terms_val_1": {
		"en": "Act honestly and fairly in performing their duties and must not unfairly or unreasonably disclose information held by the Jointly Owned Property, including information about any Owner or Occupier. All information is confidential and proprietary and reserved with the Owners only.",
		"ar": "التصرف بنزاهة وإنصاف لدى تنفيذ واجباته ويجب عليه عدم الكشف عن أي المعلومات التي تخص العقار المشترك، بما في ذلك المعلومات عن مالك أو شاغل أية وحدة. جميع المعلومات سرية والملكية محفوظة مع جهة الملاك فقط."
	},
	"ownersassocioations": {
		"en": "Owners Association",
		"ar": "جمعية الملاك"
	},
	"Re-Shield-Label": {
		"en": "Re-Shield",
		"ar": "الدرع العقاري"
	},
	"Reports": {
		"en": "Reports",
		"ar": "تقارير"
	},
	"register_a_complaint": {
		"en": "Register a Real Estate Complaint",
		"ar": "تسجيل شكوى عقارية"
	},
	"form_validate_bedroom": {
		"en": "Please select the bedrooms",
		"ar": "يرجى اختيار الغرف"
	},
	"delivery_information": {
		"en": "Delivery Information",
		"ar": "معلومات التوصيل"
	},
	"confirmation": {
		"en": "Confirmation",
		"ar": "تأكيد"
	},
	"view_service_description": {
		"en": "View",
		"ar": "عرض"
	},
	"View_All_Sales_Price_Report": {
		"en": "View Reports",
		"ar": "عرض التقرير"
	},
	"your_name": {
		"en": "Your Name",
		"ar": "اسمك"
	},
	"vault_enter_your_personal_details": {
		"en": "Enter your Personal Details",
		"ar": "أدخل بياناتك الشخصية."
	},
	"e_g_bank_address": {
		"en": "e.g. 26 B Street Dubai",
		"ar": "e.g. 26 B Street Dubai"
	},
	"documents": {
		"en": "Documents",
		"ar": "المستندات"
	},
	"Apartment": {
		"en": "Apartment",
		"ar": "وحدة سكنية"
	},
	"vid_date": {
		"en": "Date",
		"ar": "التاريخ"
	},
	"rental_amount_from": {
		"en": "Rental Amount From",
		"ar": "مبلغ الإيجار من"
	},
	"Real Estate Price index for 3rd quarter": {
		"en": "Real Estate Price index for 3rd quarter",
		"ar": "المؤشر لأسعار العقارات للربع الثالث"
	},
	"attach_approve": {
		"en": "I Approve and confirm access to all the attachments",
		"ar": "أوافق وأؤكد الوصول إلى جميع المرفقات"
	},
	"Developer_Number": {
		"en": "Developer Number",
		"ar": "رقم المطور"
	},
	"total_properties": {
		"en": "Total properties",
		"ar": "مجموع العقارات"
	},
	"property_income_value": {
		"en": "Property Income Value",
		"ar": "قيمة دخل العقار"
	},
	"form_validate_email_address": {
		"en": "Please enter a valid email address",
		"ar": "يرجى إدخال بريدك الالكتروني صحيح"
	},
	"my_properties": {
		"en": "My Properties",
		"ar": "عقاراتي"
	},
	"trade_license_number": {
		"en": "Trade License Number",
		"ar": "رقم الرخصة التجارية"
	},
	"total_property_worth_words": {
		"en": "Total Property Worth (Words)",
		"ar": "إجمالي قيمة الممتلكات (كلمات)"
	},
	"Commercial_text": {
		"en": "Commercial",
		"ar": "تجاري"
	},
	"rt_party_docs": {
		"en": "Please add at least one document.",
		"ar": "يرجى إضافة وثيقة واحدة على الأقل."
	},
	"Trakheesi": {
		"en": "Trakheesi",
		"ar": "تراخيصي"
	},
	"confirm_logout": {
		"en": "Are you sure you want to logout ?",
		"ar": "هل أنت متأكد من تسجيل الخروج ؟"
	},
	"form_validate_card_type": {
		"en": "Please select the card type",
		"ar": " يرجى إختيار نوع البطاقة"
	},
	"sq_mt": {
		"en": "Sq.Mt",
		"ar": "متر مربع"
	},
	"project_type_infrastucture": {
		"en": "Infrastructure",
		"ar": "بنية التحتية"
	},
	"allow_brokers_contact": {
		"en": "I Would like brokers to get in touch with me for property sale or rent!",
		"ar": "أرغب في أن يتواصل معي الوسطاء لبيع أو تأجير العقارات!"
	},
	"License_Expiry_Date_Text": {
		"en": "License Expiry Date",
		"ar": "تاريخ انتهاء الترخيص"
	},
	"Home_contractF_proceed": {
		"en": "Download Contract",
		"ar": "تحميل العقد"
	},
	"search_company_license_number": {
		"en": "Search Company / License Number",
		"ar": "البحث عن شركة / رقم الرخصة"
	},
	"Dubai Police": {
		"en": "Dubai Police",
		"ar": "شرطة دبي"
	},
	"home_RVS_Complaint": {
		"en": "RVS Complaints",
		"ar": "شكاوي المخالفات العقارية"
	},
	"Home_Registration_Trustee_text": {
		"en": "This service allows clients to search for the location of Registration Trustees offices",
		"ar": "هذه الخدمة تتيح للعملاء للبحث عن  موقع مكاتب التسجيل الموثوق منها التي تقدم خدمات التسجيل"
	},
	"Unified_Contract_Label": {
		"en": "Unified Contracts",
		"ar": "العقود الموحدة"
	},
	"home_license_circulars": {
		"en": "License \u003Cbr/\u003ECirculars",
		"ar": "التعاميم\u003Cbr/\u003E العقارية"
	},
	"tenant_service": {
		"en": "Tenant\u003Cbr /\u003EServices",
		"ar": "خدمات \u003Cbr /\u003E المستأجر"
	},
	"grid": {
		"en": "Grid",
		"ar": "جدول"
	},
	"DREI": {
		"en": "DREI",
		"ar": "معهد دبي العقاري"
	},
	"how_to_register": {
		"en": "How to Register ?",
		"ar": "كيف أسجل؟"
	},
	"emirati-lets-validate": {
		"en": "Let's validate your Information",
		"ar": "دعونا نتحقق من صحة المعلومات الخاصة بك"
	},
	"search_for": {
		"en": "Search for",
		"ar": "البحث عن"
	},
	"username_password": {
		"en": "Username/Password",
		"ar": "اسم المستخدم/كلمة المرور"
	},
	"add_owner_t": {
		"en": "Please click on \"Add Owner\"",
		"ar": "من فضلك اضغط علي \"اضافة مالك\""
	},
	"receive_complaint_through_04_portal": {
		"en": "Receive the complaint\u003Cbr /\u003E through \"04\" Portal",
		"ar": "تلقّي الشكوى عبر المنصّة \u003Cbr/\u003Eالرقميّة الموحّدة 04"
	},
	"preferred_user_name": {
		"en": "Preferred User Name",
		"ar": "اسم المستخدم المفضل"
	},
	"By_Area_Option": {
		"en": "By Area",
		"ar": "حسب المنطقة"
	},
	"rental_valuation": {
		"ar": "التقييم\u003Cbr/\u003E الإيجاري",
		"en": "Rental\u003Cbr/\u003E\nValuation"
	},
	"filter_by_area": {
		"en": "Filter by Area",
		"ar": "تصفية حسب المنطقة"
	},
	"Keywords": {
		"en": "Keywords",
		"ar": "كلمات البحث"
	},
	"training_and_program_desc": {
		"en": "Earn certifications through our courses by taking the exam. We have flexible, convenient options for taking exams so you can select what works best for you.",
		"ar": "احصل على الشهادات من خلال دوراتنا عن طريق اجتياز الامتحان. لدينا خيارات مرنة ومريحة لاجتياز الامتحانات حتى تتمكن من اختيار ما يناسبك."
	},
	"home_dubai_rest_title": {
		"en": "Dubai REST Application is now on Huawei App Gallery too !",
		"ar": "تطبيق دبي ريست الان في متجر هواوي للتطبيقات أيضًا."
	},
	"yes_logout": {
		"en": "Yes, Logout",
		"ar": "نعم، تسجيل الخروج"
	},
	"nav_downloads": {
		"en": "Downloads",
		"ar": "تحميل الوثائق"
	},
	"start_date": {
		"en": "Start Date",
		"ar": "تاريخ البدء"
	},
	"Licensed_Brokers_And_Developers_description": {
		"en": "This service allows customers to search for real estate brokers licensed by the Real Estate Regulatory Agency in Dubai as well as Approved Developers within Dubai",
		"ar": "تتيح هذه الخدمة للمتعاملين البحث عن الوسطاء العقاريين المرخصين من قبل مؤسسة التنظيم العقاري في دبي، وكذلك المطورين المعتمدين داخل دبي"
	},
	"land_num_label": {
		"en": "Land Number",
		"ar": "رقم الأرض"
	},
	"choose_more_than_one_file": {
		"en": "You can choose more than one file",
		"ar": "يمكنك اختيار أكثر من ملف"
	},
	"procedures": {
		"en": "Procedures",
		"ar": "الإجراءات"
	},
	"current_investments": {
		"en": "Current Investments",
		"ar": "الاستثمارات الحالية"
	},
	"awareness-24-7": {
		"en": "24/7 Awareness",
		"ar": "24/7 توعية"
	},
	"close": {
		"en": "Close",
		"ar": "إغلاق"
	},
	"owner_committee_terms_val_6": {
		"en": "The members of the Owners Committee shall not interfere in the affairs of the management and operation of the Jointly Owned Property.",
		"ar": "عدم تدخل أعضاء لجنة الملاك في شؤون إدارة وتشغيل العقار المشترك"
	},
	"form_validate_box_Number": {
		"en": "Please enter a valid P.O.Box Number",
		"ar": "يرجى إدخال رقم صندوق البريد صحيح"
	},
	"crm-sub-service": {
		"en": "Sub Service",
		"ar": "الخدمة الفرعية"
	},
	"owner_committee_terms_val_3": {
		"en": "Sustain from imposing on the Management Company contracting with any third party entity to provide goods and services for the Jointly Owned Property, which entity is related to any of the Committee members.",
		"ar": "عدم الفرض على جهة الإدارة بالتعاقد مع أي شركة مزودة للبضائع أو لأي خدمة من الخدمات الخاصة بالعقار المشتركة ترتبط صلة مع أحد أعضاء لجنة الملاك."
	},
	"area_label": {
		"en": "Area",
		"ar": "المنطقة"
	},
	"mortgage": {
		"en": "Mortgage",
		"ar": "الرهن"
	},
	"contract_end_date_label": {
		"en": "Contract End Date",
		"ar": "تاريخ انتهاء العقد"
	},
	"login_as_owner": {
		"en": "Sign in as owner / Tenant",
		"ar": "الدخول كمالك / مستأجر"
	},
	"vault_verify_mobile_email": {
		"en": "We have sent an OTP to the following Number and Email Address",
		"ar": "لقد أرسلنا الرمز التعريفي إلى الرقم وعنوان البريد الإلكتروني التاليين"
	},
	"home_rental_service": {
		"ar": "خدمات \u003Cbr\u003E التأجير العقاري",
		"en": "Real Estate\u003Cbr\u003E Rental Services"
	},
	"invalid_captcha": {
		"en": "Invalid captcha",
		"ar": "كلمة التحقق غير صحيح"
	},
	"defendant_type": {
		"en": "Defendant Type",
		"ar": "صفة المشتكى علية"
	},
	"rental_calculator_label": {
		"en": "Rental\u003Cbr/\u003E Index",
		"ar": "الحاسبة \u003Cbr/\u003E الإيجارية"
	},
	"project_name": {
		"en": "Project Name",
		"ar": "اسم المشروع"
	},
	"Home_Project_Status": {
		"en": "Project Status",
		"ar": "تابع حالة مشروعك (مشروعي)"
	},
	"you_can_find_your_emirates": {
		"en": "You can find your Emirates ID number on the front side of the card, labeled as ID Number and starting with 784",
		"ar": "يمكنك العثور على رقم الهوية الإماراتية الخاص بك على الجانب الأمامي من البطاقة، المسمى برقم الهوية والذي يبدئ بـ 784"
	},
	"one_account_for_all": {
		"en": "One Account for All",
		"ar": "حساب واحد للجميع"
	},
	"ranking_details": {
		"en": "Ranking Details",
		"ar": "تفاصيل الترتيب"
	},
	"Support_at_Land_Department": {
		"en": "Support at Land Department",
		"ar": "الدعم في أراضي دبي"
	},
	"Mobile_text": {
		"en": "Mobile",
		"ar": "رقم الجوال"
	},
	"owner_account_desc": {
		"en": "Account owner can view their portfolio, perform property services etc.",
		"ar": "مالك الحساب يمكنه مشاهدة محفظته, وأداء خدمات العقارات وما إلى ذلك."
	},
	"login_to_dubai_broker_app": {
		"en": "Login to Dubai Broker application",
		"ar": "تسجيل الدخول لتطبيق وسطاء دبي"
	},
	"Register_and_Renew_Ejari_Contract_title": {
		"en": "Register and Renew Ejari Contract",
		"ar": "تسجيل وتجديد عقد الإيجار"
	},
	"home_Connect_with_Us": {
		"en": "Connect with Us",
		"ar": "اتصل بنا"
	},
	"permits": {
		"en": "Permits",
		"ar": "تصريح"
	},
	"modify_search": {
		"en": "Modify Search",
		"ar": "تعديل البحث"
	},
	"rental_show_details": {
		"en": "Display Result",
		"ar": "عرض النتائج"
	},
	"load_more": {
		"en": "Load More",
		"ar": "تحميل المزيد"
	},
	"Sharjah_Option_label": {
		"en": "Sharjah",
		"ar": "الشارقة"
	},
	"dld_rvs_Report_Malicious_Calls_description": {
		"en": "Application to report calls and notifications against marketing or promoting  services through direct contact or annoying  investors and customers.",
		"ar": "نظام لتلقي التبليغات ضد الشركات التي تقوم بالتسويق او الترويج لخدماتها عن طريق الاتصال المباشر وازعاج المستثمرين والمتعاملين"
	},
	"all_service_text": {
		"en": "All Services",
		"ar": "كل الخدمات"
	},
	"home_leasing_brokerage_agreement": {
		"en": "Leasing Brokerage \u003Cbr/\u003EAgreement",
		"ar": "اتفاقية وساطة\u003Cbr/\u003E في التأجير"
	},
	"branch_name": {
		"en": "Branch Name",
		"ar": "اسم الفرع"
	},
	"home_Education_title": {
		"en": "Dubai Real Estate Institute Courses",
		"ar": "دورات تدريبية لمعهد دبي للعقارات عبر الانترنت"
	},
	"green_list": {
		"en": "Green List",
		"ar": "القائمة الخضراء"
	},
	"project_status": {
		"en": "Project Status",
		"ar": "حالة المشروع"
	},
	"Voice Navigation": {
		"en": "Voice Navigation",
		"ar": "التنقل بالصوت"
	},
	"Attendee": {
		"ar": "مشارك",
		"en": "Attendee"
	},
	"banner-closer-destinations-seamless-services": {
		"en": "Closer Destinations for Seamless Services",
		"ar": "مواقــع متعـــــددة لخدمــــــــــــــات أقرب إليـــــك"
	},
	"golden_visa_retiree_text": {
		"en": "This service allows a retiree owning a property the purchase value of which is equal to or more than 1 million AED at the time of purchase.",
		"ar": "تتيح هذه الخدمة للمستثمر العقاري المتقاعد الذي يملك عقار تساوي او تزيد قيمته الشرائية عن مليون درهم وقت الشراء"
	},
	"judicial_warning": {
		"en": "Judicial Warning",
		"ar": "صورة عن الإنذار العدلي"
	},
	"choose_file": {
		"en": "Choose file",
		"ar": "اختر الملف"
	},
	"license_expiry_date": {
		"en": "License Expiry Date",
		"ar": "تاريخ انتهاء الترخيص"
	},
	"form_validate_passport_number": {
		"en": "Please enter passport number",
		"ar": "يرجى إدخال رقم جواز السفر"
	},
	"my_dld": {
		"en": "My DLD",
		"ar": "حسابي"
	},
	"form_validate_number_of_room": {
		"en": "Please enter the number of rooms",
		"ar": "يرجى اختيار عدد الغرف"
	},
	"SurveyCompanies": {
		"en": "Accredited\u003Cbr/\u003E Surveying Companies",
		"ar": "شركات المساحة المعتمدة"
	},
	"rvs_docs_validation": {
		"en": "Please attach all documents supporting the transaction",
		"ar": "يرجى ارفاق جميع المستندات الداعمة للمعاملة"
	},
	"view_all_notifications": {
		"en": "View All Notifications",
		"ar": "عرض جميع الإشعارات"
	},
	"form_validate_state_name": {
		"en": "Please enter the state name",
		"ar": "يرجى إدخال الإمارة"
	},
	"percent_completed": {
		"en": "Completed (%)",
		"ar": "منجز (٪)"
	},
	"footer_dld_support_text": {
		"en": "Raise a \u003Cbr /\u003ESupport Ticket",
		"ar": "تقديم\u003Cbr /\u003E تذكرة دعم"
	},
	"cu_view_Email_list": {
		"en": "View Email List",
		"ar": "يمكنك عرض القائمة عبر الرابط أدناه"
	},
	"form_validate_complain_description": {
		"en": "Please enter the complain description",
		"ar": "يرجى إدخال تفاصيل الشكوى"
	},
	"Filter_By_label": {
		"en": "Filter By",
		"ar": "مصنف بواسطة"
	},
	"retech_desc_notif": {
		"en": "Notification utility is to send bulk business notifications via Email and SMS.",
		"ar": "Notification utility is to send bulk business notifications via Email and SMS."
	},
	"Sale_Brokers_option": {
		"en": "Sale Brokers",
		"ar": "وسطاء البيع"
	},
	"not_applicable": {
		"en": "Not Available",
		"ar": "غير متاح"
	},
	"blocking_reason_msg": {
		"en": "Please refer to the authority ",
		"ar": "يرجى مراجعة الجهة المعنية"
	},
	"Registration": {
		"en": "Sign up",
		"ar": "تسجيل"
	},
	"propertyAuction_description": {
		"en": "Dubai Real Estate Market (eMart) allows to search for properties listed for auction, communicate with landlords, brokers and management companies and also complete sale transactions online.",
		"ar": "يسمح سوق دبي العقاري (eMart) بالبحث عن العقارات المدرجة في المزاد ، والتواصل مع الملاك والوسطاء وشركات الإدارة وأيضًا إكمال معاملات البيع إلكترونيا."
	},
	"exclusive_agency_held_by_supplier": {
		"en": "Exclusive agencies held by the supplier, if any",
		"ar": "الوكالات الحصرِيّة التي بحوزة المُورِّد، إن وجِدت."
	},
	"support_label": {
		"en": "Support",
		"ar": "للمساعدة"
	},
	"form_validate_title_deed_number": {
		"en": "Please enter a valid title deed number",
		"ar": "يرجى إدخال رقم شهادة الملكية صحيح"
	},
	"proceed": {
		"en": "Proceed",
		"ar": "تقدم"
	},
	"minimum_password_length_eight": {
		"en": "Minimum 8 character long",
		"ar": "8 أحرف على الأقل"
	},
	"acc_desc_label": {
		"en": "Message",
		"ar": "رسالة"
	},
	"by_name": {
		"en": "Search By Name",
		"ar": "باستخدام الاسم"
	},
	"SurveyCompanies_title": {
		"en": "Certified Survey Companies",
		"ar": "شركات المساحة المعتمدة"
	},
	"Home_contractF_text": {
		"en": "This contract to be used as template for sale transactions that is direct between owner and buyer and does not include broker.",
		"ar": "يستخدم هذا العقد كنموذج لمعاملات البيع التي تكون مباشرة بين المالك والمشتري ولا تشمل الوسيط العقاري."
	},
	"Emirates Integrated Telecommunications Company (du)": {
		"en": "Emirates Integrated Telecommunications Company (du)",
		"ar": "شركة الإمارات للاتصالات (دو)"
	},
	"general_fund": {
		"en": "General Fund",
		"ar": "التمويل العام"
	},
	"dld_rvs_Report_Malicious_Calls": {
		"en": "Report Malicious Calls",
		"ar": "التبليغ عن المكالمات المزعجة"
	},
	"not_paid_tabu_req": {
		"en": "This request already exists in the status of \"Pending for payment\". Please check \"My Requests\"",
		"ar": "هذا الطلب موجود بالفعل في حالة \"قيد الدفع\". يرجى التحقق من \"طلباتي\""
	},
	"po_box": {
		"en": "P.O Box",
		"ar": "صندوق البريد"
	},
	"reg_date": {
		"en": "Registration Date",
		"ar": "تاريخ تقديم الطلب"
	},
	"dash_ejari_properties_title": {
		"en": "Leased Properties",
		"ar": "العقارات المؤجرة"
	},
	"service_procedures": {
		"en": "Service Procedures",
		"ar": "إجراءات الخدمة"
	},
	"total-search-result-found": {
		"en": "Total search result found",
		"ar": "إجمالي النتائج التي تم العثور عليها "
	},
	"estimated_investment_amount": {
		"en": "Estimated Investment Amount",
		"ar": "قيمة الإستثمار"
	},
	"Developer_Details": {
		"en": "Developer Details",
		"ar": "تفاصيل المطور"
	},
	"dev_cycle": {
		"en": "Real Estate Developers Journey",
		"ar": "رحلة المطور العقاري في إمارة دبي"
	},
	"h_how_do_i": {
		"en": "How do I?",
		"ar": "كيف أفعل؟"
	},
	"working_hours": {
		"en": "working hours are from",
		"ar": "اوقات العمل"
	},
	"frequently_asked_questions": {
		"en": "Frequently \u003Cbr/\u003EAsked Questions",
		"ar": "الأسئلة\u003Cbr/\u003E الاكثر تكراراً"
	},
	"site_plan": {
		"en": "Site Plan",
		"ar": "طلب اصدار خارطة"
	},
	"service_channels": {
		"en": "Service Channels",
		"ar": "قنوات تقديم الخدمة"
	},
	"form_validate_job_title": {
		"en": "Please enter the job title",
		"ar": "يرجى إدخال المسمى وظيفي "
	},
	"comp_proc_type": {
		"en": "Procedure Type",
		"ar": "نوع الاجراء"
	},
	"owner_committee_terms_val_5": {
		"en": "Otherwise behave in any manner which  unreasonably affects or is likely to unreasonably affect a person’s lawful use and enjoyment of a Unit or the Common Areas.",
		"ar": "عدم التصرف بأية طريقة تؤثر على الاستخدام والتمتع القانوني لأي شخص بأية وحدة أو المناطق العقار المشترك."
	},
	"invalid_eid": {
		"en": "Invalid Emirates ID",
		"ar": "رقم الهوية غير صحيح"
	},
	"register_as": {
		"en": "Sign up as",
		"ar": "التسجيل"
	},
	"verify": {
		"en": "Verify",
		"ar": "تحقق"
	},
	"your_invested_capital": {
		"en": "Your invested capital",
		"ar": "رأس المال المستثمر"
	},
	"vault_create_folder": {
		"en": "Create Folder",
		"ar": "أنشئ مجلد"
	},
	"please_select_service_chanel": {
		"en": "Please select service channel",
		"ar": "الرجاء تحديد قناة الخدمة"
	},
	"Details_label": {
		"ar": "تفاصيل",
		"en": "Details"
	},
	"edit": {
		"en": "Edit",
		"ar": "تحرير"
	},
	"view_profile_manage_portfolio": {
		"en": "View your Portfolio & Manage your Profile",
		"ar": "عرض محفظتك وإدارة ملف التعريف الخاص بك"
	},
	"news_popular_label": {
		"en": "Popular",
		"ar": "الاكثر قراءة"
	},
	"trakheesi_system_info": {
		"en": "Trakheesi system to manage licenses, Cards and Permits.",
		"ar": "نظام تراخيصي لإدارة التراخيص والبطاقات والتصاريح."
	},
	"al-manara-center": {
		"en": "Al Manara Center",
		"ar": "مركـــــــــزالمنــــــــــــــارة"
	},
	"banner_noqodi_title_text": {
		"en": "For Noqodi Support, please complete the form available at the link below.",
		"ar": "لتلقي الدعم من نقودي، يرجى ملء النموذج المتاح في الرابط أدناه"
	},
	"find_contact_number": {
		"en": "Where can I find Ejari Contract Number?",
		"ar": "أين يمكن ان أجد رقم عقد ايجاري؟"
	},
	"activity_type": {
		"en": "Activities Type",
		"ar": "نوع الأنشطة"
	},
	"accessibility_label": {
		"en": "Accessibility",
		"ar": "إمكانية الوصول"
	},
	"fees_info": {
		"en": "Fees Info",
		"ar": "بيانات الرسوم"
	},
	"e_g_swift_code": {
		"en": "e.g. ADCBAEAA060",
		"ar": "e.g. ADCBAEAA060"
	},
	"Consultancies": {
		"en": "Consultancies",
		"ar": "الأستشارات"
	},
	"nav_favorites_text": {
		"en": "Favorites",
		"ar": "مفضلتي"
	},
	"form_validate_account_number": {
		"en": "Please enter a valid bank account number",
		"ar": "يرجى إدخال رقم الحساب المصرفي صحيح"
	},
	"floors": {
		"en": "Floors",
		"ar": "طوابق"
	},
	"propertyAuction": {
		"en": "Property\u003Cbr /\u003EAuction",
		"ar": "المزاد\u003Cbr/\u003E العقاري"
	},
	"update_photo": {
		"en": "Update Photo",
		"ar": "تحديث الصورة"
	},
	"select_area_compare": {
		"en": "Please select a maximum of 5 records to compare",
		"ar": "يرجى تحديد 5 سجلات كحد أقصى للمقارنة"
	},
	"rental_status": {
		"en": "Rental Status",
		"ar": "حالة الإيجار"
	},
	"escrow_account": {
		"en": "Escrow Account Number",
		"ar": "حساب الضمان"
	},
	"role_page_head": {
		"en": "We have listed all the services offered by Land Department. Choose your role to find your service",
		"ar": "لقد قمنا بإدراج جميع الخدمات التي تقدمها دائرة الأراضي والأملاك. اختر دورك للعثور على خدمتك"
	},
	"trade_license_expiry": {
		"en": "Trade License Date of Expiry",
		"ar": "تاريخ انتهاء الرخصة التجارية"
	},
	"common_area": {
		"en": "Common Area",
		"ar": "المساحة المشتركة"
	},
	"course_quick_registration": {
		"en": "\u003Cspan\u003EQuick Registration\u003C/span\u003E\n\u003Cspan\u003ESimple and easy enrollment process\u003C/span\u003E",
		"ar": "\u003Cspan\u003Eتسجيل سريع \u003C/span\u003E\n\u003Cspan\u003Eعملية تسجيل بسيطة وسهلة \u003C/span\u003E"
	},
	"Innovation_Fee": {
		"ar": "رسوم الابتكار",
		"en": "Innovation Fee"
	},
	"copyright_dld": {
		"en": "Copyright © 2024 Dubai Land Department - All Right Reserved",
		"ar": "حقوق النشر © 2024 دائرة الأراضي والأملاك في دبي - جميع الحقوق محفوظة"
	},
	"select_area": {
		"en": "Please select an area on the map to view details",
		"ar": "من فضلك اختار المنطقة علي الخريطة لعرض التفاصيل"
	},
	"owner_committee_terms": {
		"en": "Owners Committee members must be committed to understanding their role as a member of the Owners’ Committee and must understand the rules by which it operates.",
		"ar": "يجب على أعضاء لجنة الملاك الحرص على فهم دور لجنة الملاك والقواعد التي تعمل بموجبها."
	},
	"broker_training_FAQs_Q2": {
		"en": "\u003Cp class=\"fw-bold\"\u003E\n                                    Q. Can I apply for the training if my visa is not under the company?\n                                \u003C/p\u003E\n                                \u003Cp\u003E\n                                    \u003Cb\u003E A.\u003C/b\u003E You can still apply for the training even if the visa is not under the company.\n                                \u003C/p\u003E",
		"ar": "\u003Cp class=\"fw-bold\"\u003E\n                                    Q. هل يمكنني التقدم للحصول على التدريب إذا لم تكن تأشيرتي تابعة للشركة؟\n                                \u003C/p\u003E\n                                \u003Cp\u003E\n                                    \u003Cb\u003E A.\u003C/b\u003E بإمكانك التقدم للحصول على التدريب حتى لو لم تكن التأشيرة تابعة للشركة\n                                \u003C/p\u003E"
	},
	"sale_First": {
		"en": ": First",
		"ar": "الأول: "
	},
	"msg_please_enter_three_or_more_charactor": {
		"en": "Please enter 2 or more characters / numbers to search within brokers, Offices, Mobile number, Area and ORN",
		"ar": "الرجاء إدخال 2 أحرف / أرقام أو أكثر للبحث داخل الوسطاء والمكاتب ورقم الهاتف المحمول والمنطقة و رقم المكتب"
	},
	"month": {
		"en": "Month",
		"ar": "شهر"
	},
	"full_name": {
		"en": "Full Name",
		"ar": "الأسم بالكامل"
	},
	"ejari_contract_information": {
		"en": "Ejari Contract Information",
		"ar": "معلومات عقد إيجاري"
	},
	"total_transactions": {
		"en": "Total Transactions",
		"ar": "إجمالي المعاملات"
	},
	"auction_noti_msg_2": {
		"en": "Land in Al Dhagaya for Sale, 173 Sq. Metres – Reserved Price AED 2,060,000",
		"ar": "ارض في الضغاية للبيع مساحة 173 متر مربع - السعر الأساسي 2،060،000 درهم"
	},
	"home_banner_Download_Ejari_Contract_text": {
		"en": "Now you can download Ejari Contract by entering your Contract Number",
		"ar": "يمكنك الان تحميل عقد ايجاري عن طريق رقم التواصل"
	},
	"more-reason": {
		"en": "Reason",
		"ar": "السبب"
	},
	"completion_date": {
		"en": "Completion Date",
		"ar": "موعد الإكمال"
	},
	"cu_Important_Email_link": {
		"en": "Important Emails",
		"ar": "قائمة أسماء مدراء الإدارات الهامة"
	},
	"swift_code": {
		"en": "Swift code",
		"ar": "كود السويفت"
	},
	"party_information": {
		"en": "Party Information",
		"ar": "بيانات الطرف"
	},
	"dev_calc_note": {
		"en": "The above number is an approximate number as per the information provided by you to provide an overview of the development cycle and doesn’t represent the exact time,\n                    fees and involved entities.",
		"ar": "الرقم أعلاه هو رقم تقريبي وفقًا للمعلومات التي قدمتها لتقديم نظرة عامة على دورة التطوير ولا يمثل الوقت المحدد ،\n                     الرسوم والجهات المعنية."
	},
	"confirm_new_password": {
		"en": "Confirm New Password",
		"ar": "تأكيد كلمة المرور"
	},
	"please_enter_the_otp_receive": {
		"en": "Please enter the OTP received on",
		"ar": "من فضلك ادخل كود النحقق"
	},
	"rental_map_label": {
		"en": "Please select an area on the map to view details",
		"ar": "من فضلك اختار المنطقة علي الخريطة لعرض التفاصيل"
	},
	"under_auditing": {
		"en": "Under Auditing",
		"ar": "قيد المراجعة"
	},
	"dewa_outstanding": {
		"ar": "مبالغ ديوا المستحقة",
		"en": "DEWA Outstanding Amount"
	},
	"english_language": {
		"ar": "اللغة الإنجليزية",
		"en": "English Language"
	},
	"welcome_live_chat_text": {
		"en": "\u003Cb\u003EWelcome to Live Chat\u003C/b\u003E\u003Cbr /\u003E\nWe are here to support all your Inquiries. Let’s have a chat to understand your concern.",
		"ar": "\u003Cb\u003Eاهلا بكم في الدردشه الفوريه \u003C/b\u003E\u003Cbr /\u003E\nنحن هنا لتقديم الدعم عن جميع استفساراتك، دعنا نساعدك لفهم طلبك."
	},
	"cu_submit_query_description": {
		"en": "To submit your query, please send an email to info@dubailand.gov.ae with your full name and mobile number with details.",
		"ar": "لإرسال استفسارك، يرجى إرسال بريد إلكتروني إلى  info@dubailand.gov.ae مع ذكر اسمك الكامل ورقم الهاتف المتحرك مع التفاصيل "
	},
	"Download_Ejari_Certificate": {
		"ar": "تحميل شهادة تسجيل عقد ايجار",
		"en": "Download Ejari Certificate"
	},
	"banner-emirati-program-description": {
		"en": "This service is only for UAE nationals and who do not hold a broker license.",
		"ar": "هذة الخدمة متاحة فقط لمواطنين دولة الامارات وليس لديهم بطاقة وسيط عقارى"
	},
	"more-welcome-message": {
		"en": "Welcome to the beginning of your investor journey in Dubai.",
		"ar": " مرحبًا بك في بداية رحلتك الاستثمارية في دبي."
	},
	"upload_files": {
		"en": "Upload Files",
		"ar": "تحميل الملفات"
	},
	"dewa-number": {
		"en": "DEWA (Premise No.)",
		"ar": "رقم العقار (ديوا)"
	},
	"per_sqmt_value": {
		"en": "Per Sq.Mt value",
		"ar": "القيمة بالمتر المربع"
	},
	"update_your_personal_information_with_ICP": {
		"ar": "تعديل\u003Cbr/\u003E البيانات الشخصية ",
		"en": "Update your \u003Cbr/\u003EPersonal Information with ICP"
	},
	"pwd_label": {
		"en": "Password",
		"ar": "كلمة الدخول"
	},
	"real_estate_office_registration_certificate": {
		"en": "Real Estate Office Registration Certificate",
		"ar": "شهادة تسجيل مكتب عقاري"
	},
	"license_issue_date": {
		"en": "License Issue Date",
		"ar": "تاريخ إصدار الترخيص"
	},
	"partnershipDLDSEjariDescription": {
		"en": "Ejari aims to ensure customers to get the service of registration leases in multiple locations in Dubai as these offices are authorized to regulate the management of relations between the parties in the process of leasing and property management, and to provide a secure environment encouraging for those wishing to enter the field of investors or beneficiaries of the tenants.",
		"ar": "تهدف هذه الشراكة في ضمان حصول العملاء على خدمة تسجيل عقود الإيجار بشكل متميز في مواقع متعددة على مستوى أمارة دبي وتم دراسة المكاتب المخولة لتقديم هذه الخدمة ومواقعها على خارطة أمارة دبي وتنظم هذه الخدمة تأجير وإدارة العقارات لإرتقاء بمستوى هذا القطاع الهام وتنظم إدارة العلاقات بين أطراف المعادلة في  عمليه تأجير وإدارة العقارات ولتوفير بيئة آمنه مشجعة للراغبين في دخول هذا المجال من مستثمرين أو مستفيدين من مستأجرين."
	},
	"building": {
		"en": "Building",
		"ar": "مبنى"
	},
	"write_call_send_message": {
		"en": "Write, Call or send a message",
		"ar": "اتصل, او ارسل لنا مشكلتك"
	},
	"zone": {
		"en": "Zone",
		"ar": "القطاع"
	},
	"home_general_service": {
		"ar": "خدمات \u003Cbr\u003E عامة",
		"en": "General\u003Cbr\u003E Services"
	},
	"submission_date": {
		"en": "Submission Date",
		"ar": "تاريخ التقديم"
	},
	"Select_Date": {
		"en": "Select Date",
		"ar": "تحديد التاريخ"
	},
	"otp_received_mobile": {
		"en": "OTP received on mobile",
		"ar": "تم استلام OTP على الهاتف المحمول"
	},
	"card_dash_ejari_properties_title": {
		"en": "Property/ies that is/are owned by a lessor or landlord and rented to a lessee or tenant who receives...",
		"ar": "العقارات المملوكة لممالك  او مؤجر و مؤجرة لمستأجر يملك....."
	},
	"calculate_total": {
		"en": "Calculate Total",
		"ar": "حساب المجموع"
	},
	"complain_type": {
		"en": "Complain Type",
		"ar": "نوع الشكوى"
	},
	"work_hours": {
		"en": "Working hours",
		"ar": "اوقات العمل"
	},
	"are_you_sure_you_want_to_delete_this_folder": {
		"en": "Are you sure you want to delete this folder?",
		"ar": "هل أنت متأكد أنك تريد حذف هذا المجلد؟"
	},
	"owners_or_tenants": {
		"en": "Owner / Tenant",
		"ar": "المالك / المستأجر"
	},
	"project_type": {
		"en": "Project Type",
		"ar": "نوع المشروع"
	},
	"Inquiry on Leaser": {
		"en": "Inquiry on Leaser",
		"ar": "الاستفسار عن المؤجر"
	},
	"blocking_authority": {
		"en": "Blocking Authority",
		"ar": "الجهة"
	},
	"enbd_description_text": {
		"en": "Please go through the details which contains necessary information to open an Account with Emirates NBD",
		"ar": "رجى الاطلاع على التفاصيل التي تحتوي على المعلومات الضرورية، لفتح حساب مع بنك الإمارات دبي الوطني."
	},
	"Home_Registration_Trustee": {
		"en": "Real Estate\u003Cbr/\u003E Registrar Centers",
		"ar": "مراكز أمناء التسجيل العقاري"
	},
	"passport_issue": {
		"en": "Passport Issue Date",
		"ar": "تاريخ اصدار الجواز"
	},
	"job_title": {
		"en": "Job Title",
		"ar": "المسمى الوظيفي"
	},
	"not_reg": {
		"en": "Not Registered Yet ?",
		"ar": "لم تسجل بعد ؟"
	},
	"license_type": {
		"en": "License Type",
		"ar": "نوع الرخصة"
	},
	"form_validate_built_up_area": {
		"en": "Please enter built up area",
		"ar": "يرجى إختيار المساحة المبنية"
	},
	"nav_notification": {
		"en": "Notifications",
		"ar": " إشعارات"
	},
	"aed": {
		"en": "AED",
		"ar": "درهم"
	},
	"smart_judge_msg": {
		"en": "Hello, I am your Virtual Judge..How can I help you ?",
		"ar": "مرحبًا ، أنا القاضي الافتراضي .. كيف يمكنني مساعدتك؟"
	},
	"home_DLD_Vault_Proceed": {
		"en": "Proceed",
		"ar": "تقدم"
	},
	"land_area": {
		"en": "Area",
		"ar": "المساحة"
	},
	"role_srvcs_txt": {
		"en": "Individual or entity in possession of title for land, building, or other item. The owner may be responsible for paying taxes in relation to the property.",
		"ar": "فرد أو كيان يمتلك حق ملكية الأرض أو البناء أو أي عنصر آخر. قد يكون المالك مسؤولاً عن دفع الضرائب المتعلقة بالعقار."
	},
	"more-reset": {
		"en": "Reset",
		"ar": "إعادة الضبط"
	},
	"CertifiedAuditors_description": {
		"ar": " اطلع على إدارة الضمان أو المدققين الماليين المعتمدين لدى دائرة الأراضي والأملاك",
		"en": "View all the Escrow Department or Jointly Owned Property Auditors certified by Dubai Land Department"
	},
	"Previous_Progress": {
		"en": "Previous Inspection",
		"ar": "نسبة الأنجاز السابقة"
	},
	"as_a_business_user_you_will_have": {
		"en": "As a Business User, you will have access to the following systems",
		"ar": "بصفتك مستخدم أعمال، ستتمكن من الوصول إلى الأنظمة التالية"
	},
	"valuation_offices": {
		"en": "Valuation Offices",
		"ar": "مكاتب التقييم"
	},
	"nearest_landmark": {
		"en": "Nearest Landmark",
		"ar": "أقرب معلم"
	},
	"more-email": {
		"en": "Email *",
		"ar": "البريد الإلكتروني*"
	},
	"single_participant": {
		"en": "We have found a single owner matching your search criteria.",
		"ar": ".لقد وجدنا مالكا واحدًا يطابق معايير البحث الخاصة بك"
	},
	"note_field_star_required": {
		"en": "Note: All fields marked with asterisk (*) are mandatory",
		"ar": "ملاحظة: جميع الحقول التي تحمل علامة النجمة (*) إلزامية"
	},
	"registration_success": {
		"en": "Registration success",
		"ar": "تمت عملية التسجيل بنجاح"
	},
	"property_number": {
		"en": "Property Number",
		"ar": "رقم العقار"
	},
	"building_function": {
		"en": "Building Function",
		"ar": "Building Function"
	},
	"balcony_area_calculation": {
		"en": "Invoices issued after 2019 balcony area calculation is at rate 0.25% of suit area, and prior doesn’t include balcony value.",
		"ar": "تحسب مساحة الشرفة بنسبة 0.25% من المساحة الصافية للفواتير الصادرة بعد عام 2019 اما الفواتير الصادرة قبل ذلك فلا تتضمن مساحة الشرفة."
	},
	"Twelve Months Ago": {
		"en": "12 Months Ago",
		"ar": "منذ 12 شهر"
	},
	"extra_fee_agree_2": {
		"en": "I agree to pay the extra amount required (160 AED per Sqft)",
		"ar": "أوافق على دفع المبلغ الإضافي المطلوب (160 درهم لكل قدم مربع)"
	},
	"NewOfficeTimingsTxt1": {
		"en": "Based on the directives of the UAE Government, our new working hours will be as follows:",
		"ar": "بناءً على توجيهات حكومة دولة الإمارات العربية المتحدة ، ستكون ساعات العمل الجديدة على النحو التالي:"
	},
	"home_GO_PAPERLESS": {
		"en": "GO PAPERLESS!!",
		"ar": "اذهب بدون ورق !!"
	},
	"media_centre": {
		"en": "Media Centre",
		"ar": "المركز الإعلامي"
	},
	"home_Frequently_Used_Services": {
		"en": "Frequently Used Services",
		"ar": "الخدمات الأكثر استخداماً"
	},
	"share_this_page": {
		"en": "Share this page",
		"ar": "مشاركة الخدمة"
	},
	"send": {
		"en": "Send",
		"ar": "إرسـال"
	},
	"master_project": {
		"en": "Master Project",
		"ar": "مشروع رئيسي"
	},
	"data_source": {
		"en": "Data Source",
		"ar": "مصدر البيانات"
	},
	"form_validate_license_number": {
		"en": "Please enter a valid license number",
		"ar": "يرجى إدخال رقم الرخصة صحيح"
	},
	"land_sub_number": {
		"en": "Land Sub Number",
		"ar": "رقم الأرض الفرعي"
	},
	"proceed_aggrements": {
		"en": "By clicking \"Proceed\" I agree to Dubai Land Department's Terms of Service and Privacy Policy.",
		"ar": "بالنقر فوق \"متابعة\"، أوافق على شروط الخدمة وسياسة الخصوصية الخاصة بدائرة الأراضي والأملاك في دبي."
	},
	"real_estate_transactions_at_Land_Department": {
		"en": "Real Estate Transactions\u003Cbr/\u003Eat Land Department",
		"ar": "التصرفات العقارية في دائرة الأراضي والأملاك"
	},
	"Procedure_No_Label": {
		"en": "Procedure No",
		"ar": "رقم الإجراء"
	},
	"english": {
		"en": "English",
		"ar": "انجليزي"
	},
	"home_form_downloads": {
		"en": "Forms and\u003Cbr\u003E Downloads",
		"ar": "النماذج"
	},
	"time": {
		"en": "Time",
		"ar": "الوقت المستغرق"
	},
	"dep_name_ar": {
		"en": "Entity name (In Arabic)",
		"ar": "اسم الادارة (باللغة العربية)"
	},
	"View_All_Our_Partners": {
		"en": "View All Our Partners",
		"ar": "عرض جميع شركائنا"
	},
	"preferred_language": {
		"en": "Preferred Language",
		"ar": "اللغة المفضلة"
	},
	"Next_Inspection": {
		"en": "Next Inspection",
		"ar": "الفحص التالي"
	},
	"Reserved Fund": {
		"en": "Reserved Fund",
		"ar": "التمويل المخصص"
	},
	"green_list_info": {
		"en": "Using this service system will share your mobile number and email with brokers so that they can contact you for the sale/lease of your properties.",
		"ar": "باستخدام هذه الخدمة سيعمل التطبيق على مشاركة رقم هاتفك الجوال وبريدك الإلكتروني مع الوسطاء حتى يتمكنوا من الاتصال بك لبيع/تأجير عقاراتك."
	},
	"CertifiedAuditors": {
		"en": "Approved financial\u003Cbr/\u003E (accounts) auditors",
		"ar": "المدققين الماليين المعتمدين"
	},
	"address1": {
		"en": "Address 1",
		"ar": "العنوان 1"
	},
	"Gross Rental Yield Index": {
		"en": "Gross Rental Yield Index",
		"ar": "مؤشر إجمالي عائد الإيجار"
	},
	"Percentage Change": {
		"en": "Percentage Change",
		"ar": "التغير"
	},
	"property_net_income": {
		"en": "Net Income",
		"ar": "صافي الدخل"
	},
	"Home_RDC_Register_your_Case": {
		"en": "RDC - Register your Case",
		"ar": "مركز فض المنازعات الإيجارية - تسجيل الدعوي"
	},
	"request_sent_successfully": {
		"en": "Your request has been sent successfully. You will be notified via Email/SMS",
		"ar": "تم ارسال طلبك بنجاح. سيتم إخطارك عبر البريد الإلكتروني / الرسائل القصيرة"
	},
	"Smart_Contract": {
		"en": "Smart Contract",
		"ar": "Smart Contract"
	},
	"property_information": {
		"en": "Property Information",
		"ar": "معلومات الممتلكات"
	},
	"gender": {
		"en": "Gender",
		"ar": "الجنس"
	},
	"Directorate General of Civil Defense Dubai (DCD)": {
		"en": "Directorate General of Civil Defense Dubai (DCD)",
		"ar": "المديرية العامة للدفاع المدني دبي (DCD)"
	},
	"learn_more": {
		"en": "Learn More",
		"ar": "تعلم المزيد"
	},
	"webinar_registration_success_msg": {
		"en": "Thank you for showing your interest in attending the Real Estate Sector Performance Annual Report 2020 Webinar. We have sent you the webinar details on your mentioned email address. Looking forward to see you virtually at the event !!",
		"ar": "شكرا لاظهاركم الاهتمام في حضور المؤتمر الالكتروني لتقرير الاداء السنوي لقطاع العقارات.لقد ارسلنا اليكم بيانات المؤتمرالالكتروني على بريدكم الالكتروني\nنتطلع لرؤيتكم في الحدث الافتراضي"
	},
	"invalid_otp": {
		"en": "Invalid OTP",
		"ar": "الرقم السري غير صحيح"
	},
	"building_details": {
		"en": "Building Details",
		"ar": "تفاصيل البناء"
	},
	"we_have_sent_otp_to_your_mobile": {
		"en": "Dear customer, we have sent an OTP to your mobile number.",
		"ar": "عزيزي العميل ، لقد أرسلنا رمز التحقق إلى رقم هاتفك المحمول."
	},
	"update_sso_profile_warning": {
		"en": "If you have logged-in using Emirates Id, then all the user profiles associated with the Emirates Id will be updated with new phone/email.\nIf you are intended to update specific user profile, then logout from emirates Id login and login with an username.",
		"ar": "يرجى العلم بأنه في حاله استخدام الهويه لتسجيل الدخول في النظام فان جميع بيانات المستخدمين المربوطين بهذه الهوية سيتم تحديثها بالهاتف و البريد الالكتروني الجديد.\nفيحالة الرغبة في تحديث بيانات مستخدم محدد يرجى الخروج و الدخول عن طريق اسم المستخدم و كلمة المرور"
	},
	"contact_mollak": {
		"en": "04-2030254",
		"ar": "04-2030254"
	},
	"LandCountType": {
		"en": "Lands Count",
		"ar": "عدد قطع الأرضي"
	},
	"form_validate_complainant_name": {
		"en": "Please enter the complainant name",
		"ar": "يرجى إدخال المشتكى الاسم "
	},
	"enter_uae_phone_number": {
		"en": "Please enter only UAE mobile number",
		"ar": "من فضلك ادخل رقم الجوال الاماراتى فقط"
	},
	"dld_complain": {
		"en": "Dubai Land Department\u003Cbr\u003E\n                            Services Complaint",
		"ar": "دائرة الأراضي والأملاك \u003Cbr/\u003E\nخدمات الشكاوي"
	},
	"you_have_successfully_logedout": {
		"en": "You have logged out successfully.",
		"ar": "لقد قمت بتسجيل الخروج بنجاح."
	},
	"no_access_to_app": {
		"en": "You do not have access to this application",
		"ar": "ليس لديك حق الوصول إلى هذا التطبيق"
	},
	"moasher_yearly": {
		"en": "Y",
		"ar": "Y"
	},
	"send_email": {
		"ar": "أرسل بريد إلكتروني",
		"en": "Send an email"
	},
	"broker_training_FAQs_Q1": {
		"ar": " \u003Cp class=\"fw-bold\"\u003E\n                                    Q. هل يتمّ التدريب باللغة العربيّة أم الإنجليزيّة؟ \n                                \u003C/p\u003E\n                                \u003Cp\u003E\n                                    \u003Cb\u003E A.\u003C/b\u003E  التدريب يُعقد فقط باللغة الإنجليزيّة\n                                \u003C/p\u003E",
		"en": " \u003Cp class=\"fw-bold\"\u003E\n                                    Q. Is the training conducted in English or Arabic?\n                                \u003C/p\u003E\n                                \u003Cp\u003E\n                                    \u003Cb\u003E A.\u003C/b\u003E The training is conducted only in English.\n                                \u003C/p\u003E"
	},
	"search-index-by": {
		"en": "Search Index by",
		"ar": "البحث عن الفهرس"
	},
	"Property_Classification_Label": {
		"en": "Property Classification",
		"ar": "تصنيف العقار"
	},
	"Register_and_Renew_Ejari_Contract_description": {
		"ar": "تتيح هذه الخدمة للمتعامل القيام بتسجيل أو تجديد عقد الإيجار في إمارة دبي.",
		"en": "This service allows customers to apply to register or renew Ejari contracts in Dubai."
	},
	"form_validate_makani_number": {
		"en": "Please enter a valid makani number",
		"ar": "يرجى إدخال رقم مكاني صحيح"
	},
	"view_siteplan": {
		"en": "View Site Plan",
		"ar": "عرض خارطة الموقع"
	},
	"person": {
		"en": "Person",
		"ar": "فرد"
	},
	"tell_us_more": {
		"en": "Tell us more",
		"ar": "أخبرنا المزيد"
	},
	"project_status_under_cancellation_notification": {
		"en": "Under Cancellation Notification",
		"ar": "تحت إشعار الإلغاء"
	},
	"complainant_details_section": {
		"en": "1 - Complainant Details",
		"ar": "1 - بيانات المشتكى"
	},
	"partnershipDLDSRTDescription": {
		"en": "Real estate registration trustee centres provide all real estate registration and licensing services from buying and selling, and all other real estate transactions to Dubai Land Department, through one window, and according to the highest international standards.",
		"ar": "تقدم مراكز أمناء التسجيل العقاري كافة خدمات التسجيل والترخيص العقاري من بيع وشراء، وكافة التصرفات العقارية الأخرى لدائرة الأراضي والأملاك في دبي، عبر نافذة واحدة، ووفق أعلى المعايير العالمية."
	},
	"project_transactions_details": {
		"en": "Project Transaction Details",
		"ar": "تفاصيل المشروعات العقارية"
	},
	"contact_customer_verify_information": {
		"en": "Contact the customer and\u003Cbr /\u003E verify the information provided",
		"ar": "الاتصال بالمتعامل والتأكد \u003Cbr/\u003Eمن كافة المعلومات"
	},
	"e_g_Abc": {
		"ar": "e.g. Car Washing",
		"en": "e.g. Car Washing"
	},
	"download": {
		"en": "Download",
		"ar": "تحميل"
	},
	"purchase_date": {
		"en": "Purchase Date",
		"ar": "تاريخ البيع"
	},
	"claimant_defendant_email_same_msg": {
		"en": "Claimant and Defendant email should not be the same.",
		"ar": "البريد الالكتروني للمشتكى و المشتكي يجب ان تكون مختلف"
	},
	"investorprofile_desc": {
		"en": "An advanced tool powered by artificial intelligence that explores investors' behaviors, desires, and trends, and offers predictive insights and planning for real estate market scenarios.",
		"ar": "أداة متطورة مدعومة بالذكاء الاصطناعي تستكشف سلوك المستثمرين ورغباتهم واتجاهاتهم و تقدم رؤى تنبؤية وتخطيط لسيناريوهات السوق العقاري"
	},
	"form_validate_municipality_number": {
		"en": "Please enter a valid municipality number",
		"ar": "يرجى إدخال رقم البلدية صحيح"
	},
	"verify_your_personal_details": {
		"en": "Verify your Personal Details",
		"ar": "تحقق من التفاصيل الشخصية الخاصة بك"
	},
	"Address_label": {
		"en": "Address",
		"ar": "عنوان"
	},
	"property_use": {
		"en": "Usage",
		"ar": "الاستخدام"
	},
	"apply": {
		"en": "Apply",
		"ar": "تطبيق"
	},
	"emirati-program-pvt-org": {
		"en": "Private Organization",
		"ar": "مؤسسة خاصة"
	},
	"DueAmountforCompletion": {
		"en": "Due Amount for Completion",
		"ar": "المبلغ المتبقي للاكتمال"
	},
	"Watch_Video": {
		"en": "Watch Video",
		"ar": "شاهد الفيديو"
	},
	"invalid_emirateid": {
		"en": "Invalid Emirates ID",
		"ar": "رقم الهوية غير صحيح"
	},
	"valuator_information": {
		"en": "Valuator Information",
		"ar": "معلومات المقيم"
	},
	"Department of Tourism and Commerce Marketing Authority": {
		"en": "Department of Tourism and Commerce Marketing Authority",
		"ar": "دائرة السياحة وهيئة التسويق التجاري"
	},
	"land_label": {
		"en": "Land",
		"ar": "ارض"
	},
	"Project_Name_Label": {
		"en": "Project Name",
		"ar": "اسم المشروع"
	},
	"integrate_your_apps_with_systems": {
		"en": "API-enabled ecosystems are at the forefront of the digital era and changing the digital business landscape at a rapid pace. Elevate your customer experience by integrating your apps with DLD systems like Ejari, Mollak, and Trakheesi.",
		"ar": "تحتل النظم البيئية التي تدعم واجهة برمجة التطبيقات موقع الصدارة في العصر الرقمي وتغير مشهد الأعمال الرقمية بوتيرة سريعة. ارتقِ بتجربة عملائك من خلال دمج تطبيقاتك مع أنظمة دائرة الأراضي والأملاك في دبي مثل إيجاري وملاك وتراخيصي."
	},
	"click_login_pp": {
		"en": "By clicking \"Login\" I agree to Dubai Land  Department's |Terms of Service| and |Privacy Policy|.",
		"ar": "بالضغط على \"تسجيل الدخول\" أوافق على |الشروط والأحكام| و |سياسة الخصوصية| في دائرة الأراضي والأملاك بدبي"
	},
	"no_of_floors": {
		"en": "Number of floors",
		"ar": "عدد الطوابق"
	},
	"suit_area": {
		"en": "Suite Area",
		"ar": "المساحة الداخلية"
	},
	"accept_terms": {
		"en": "Please accept the terms and conditions",
		"ar": "الرجاء الموافقة علي الشروط والأحكام"
	},
	"commer_label": {
		"en": "Commercial",
		"ar": "تجاري"
	},
	"total_fees": {
		"en": "Total Fees",
		"ar": "مجموع الرسوم"
	},
	"separated_from": {
		"en": "Separated From",
		"ar": "انفصل عن"
	},
	"card_number": {
		"en": "Card Number",
		"ar": "رقم البطاقة"
	},
	"title_deed_overview": {
		"en": "This service allows customers to verify their title-deed from the Real Estate Regulatory Agency.The service is provided by the Real Estate Relations Regulatory Department.",
		"ar": "تتيح هذه الخدمة للمتعاملين التأكد من شهادة المليكة من مؤسسة التنظيم العقاري.تتوفير هذه الخدمة من قبل  ادارة تنظيم العلاقات العقارية"
	},
	"Title Deed Services": {
		"en": "Title Deed Services",
		"ar": "خدمات بيانات الملكية العقارية"
	},
	"company_license": {
		"en": "Company Name / License Number",
		"ar": "اسم الشركة / رقم الرخصة"
	},
	"passcode_desc2": {
		"en": "Now you don’t need to enter different OTP each time you access the application. The passcode will be valid for approx. 1 month. We will send you a new passcode, once the old one expires.",
		"ar": "الان انت لا تحتاج لادخال كلمه مرور للمره الواحده كل مرة تحتاج الدخول للتطبيقات حيث انك الان سوف تستخدم رمز المرور لمده شهر تقريبا و سنرسل لك رمز مرور جديد في حالة انتهاء الرمز المروري"
	},
	"rera": {
		"en": "RERA",
		"ar": "مؤسسة التنظيم العقاري"
	},
	"permission_request_sent": {
		"en": "Permission Request Successfully Sent",
		"ar": "تم ارسال طلب الاذن بنجاح"
	},
	"Home_Service_Charge_Index_proceed": {
		"en": "Calculate Service Charge Index",
		"ar": "احسب مؤشر رسوم الخدمات"
	},
	"order_status": {
		"en": "Request Status",
		"ar": "حالة الطلب"
	},
	"mortgages": {
		"en": "Mortgages",
		"ar": "الرهون العقارية"
	},
	"rate_sq_ft": {
		"en": "Rate (AED/Sq.Ft)",
		"ar": "المعدل (درهم / قدم مربع)"
	},
	"studio_option": {
		"en": "Studio",
		"ar": "الاستوديو"
	},
	"management_company_text": {
		"en": "Management Company",
		"ar": "شركة الإدارة"
	},
	"new_current_pwd_same": {
		"en": "New Password is same as current password",
		"ar": "كلمة المرور الجديدة هي نفسها كلمة المرور الحالية"
	},
	"Approved_Real_Estate_Developers": {
		"en": "Approved Real Estate Developers",
		"ar": "المطورين العقاريين المعتمدين"
	},
	"area_square": {
		"en": "Area (Sq.Ft)",
		"ar": "المساحة (قدم مربع)"
	},
	"office_number": {
		"en": "Office Number",
		"ar": "رقم المكتب"
	},
	"rental_transactions": {
		"en": "Rent Transactions",
		"ar": "عقود الإيجار"
	},
	"completed_projects": {
		"en": "Completed Projects",
		"ar": "المشاريع المكتملة"
	},
	"CertifiedAuditors_title": {
		"en": "Certified Auditors",
		"ar": "المدققين الماليين"
	},
	"rt_specify_rent_value": {
		"en": "Specify the Rent Value",
		"ar": "حدد قيمة الإيجار"
	},
	"find_right_training_course_certificate_for_you": {
		"en": "Find the Official\u003Cbr /\u003E\nTraining Courses & Certifications\u003Cbr /\u003E\nfor you",
		"ar": "ابحث عن الدورات التدريبية و الشهادات الرسمية المناسبة لك"
	},
	"content_label": {
		"en": "Content",
		"ar": "المحتوى"
	},
	"welcome": {
		"en": "Welcome",
		"ar": "مرحبا"
	},
	"pricing_option": {
		"en": "Pricing Option",
		"ar": "خيارات الأسعار"
	},
	"accessRentalIndexFromDubaiRestStep2": {
		"en": "\u003Cstrong\u003EStep 2\u003C/strong\u003E\u003Cbr /\u003E\n                                Point your camera to this QR code which will open the App",
		"ar": " \u003Cstrong\u003Eالخطوة 2\u003C/strong\u003E\u003Cbr /\u003E\n                                وجه الكاميرا إلى رمز الاستجابة السريعة (QR) لفتح التطبيق"
	},
	"more-birth-date": {
		"en": "Birth Date *",
		"ar": "تاريخ الميلاد*"
	},
	"complaints_handling_process_steps": {
		"en": "Complaints Handling Process in 3 Steps",
		"ar": "آلية معالجة الشكوى عبر 3 خطوات"
	},
	"sale_type": {
		"en": "Sale Type",
		"ar": "نوع البيع"
	},
	"licenses": {
		"en": "Licenses",
		"ar": "التراخيص"
	},
	"broker_id": {
		"en": "Broker Id",
		"ar": "معرف الوسيط"
	},
	"webinar_register": {
		"en": "Register",
		"ar": "التسجيل"
	},
	"contract_number": {
		"en": "Ejari Contract Number",
		"ar": "رقم عقد ايجاري"
	},
	"parent_property_id": {
		"en": "Parent Property Id",
		"ar": "معرف ملكية الوالدين"
	},
	"dep_name_en": {
		"en": "Entity Name (in English)",
		"ar": "اسم الادارة (بالانجليزية)"
	},
	"disagree": {
		"en": "Disagree",
		"ar": "تعارض"
	},
	"Transaction_Failed": {
		"en": "Transaction Failed",
		"ar": "المعاملة فشلت"
	},
	"VillaCountType": {
		"en": "Villa Count",
		"ar": "عدد الفيلات"
	},
	"building_label": {
		"en": "Building / Villa",
		"ar": "مبنى / فيلا"
	},
	"more-property-detail": {
		"en": "Property Detail",
		"ar": "تفاصيل الملكية"
	},
	"land_number": {
		"en": "Land Number",
		"ar": "رقم الأرض"
	},
	"service_form": {
		"en": "Service Form",
		"ar": "نموذج الخدمة"
	},
	"home_real_estate_legislation": {
		"en": "Real Estate \u003Cbr/\u003ELegislation",
		"ar": "التشريعات\u003Cbr/\u003E العقارية"
	},
	"real_estate_data_availability": {
		"en": "\u003Cdiv\u003EFor previous year data kindly visit \u003Ca href=\"https://www.dubaipulse.gov.ae/organisation/dld\" class=\"text-decoration-underline mx-1\"\u003EDubai Pulse\u003C/a\u003E, an initiative by Digital Dubai\u003C/div\u003E",
		"ar": "\u003Cdiv\u003Eلمعرفة بيانات العام الماضي ، يرجى زيارة \u003Ca href=\"https://www.dubaipulse.gov.ae/organisation/dld\" class=\"text-decoration-underline mx-1\"\u003Eدبي بالس\u003C/a\u003E، وهي مبادرة من دبي الرقمية\u003C/div\u003E"
	},
	"reg_a_business_user": {
		"en": "a Business User",
		"ar": "مستخدم الأعمال"
	},
	"stages": {
		"en": "Stages",
		"ar": "المراحل"
	},
	"user_access": {
		"en": "User Access",
		"ar": "دخول المستخدم"
	},
	"home_video_content": {
		"en": "The opening film of Dubai Land Department at the Urban Thinkers Campus - Dubai Land Department plays a vital role by providing services to the real estate sector. It is imperative we keep abreast of smart technology developments, ensure compatibility with government directives and the wider vision of our esteemed leadership",
		"ar": "يلعب الفيلم الافتتاحي لدائرة الأراضي والأملاك دورًا حيويًا من خلال تقديم الخدمات لقطاع العقارات. من الضروري أن نواكب التطورات التكنولوجية الذكية ، ونضمن التوافق مع التوجيهات الحكومية والرؤية الأوسع لقيادتنا الموقرة"
	},
	"started": {
		"en": "Started",
		"ar": "بدأ"
	},
	"Webinar_Registration": {
		"en": "Webinar Registration",
		"ar": "Webinar Registration"
	},
	"Lets_Get_Started": {
		"en": "Let's Get Started",
		"ar": "هيا نبدأ"
	},
	"banner_noqodi_title": {
		"en": "Noqodi Payment Support",
		"ar": "دعم خدمة نقودي"
	},
	"home_Education": {
		"en": "Education",
		"ar": "التعليم"
	},
	"office_details": {
		"en": "Office Details",
		"ar": "تفاصيل المكتب"
	},
	"buy_property": {
		"en": "Buy \u003Cbr/\u003EProperty",
		"ar": "شراء\u003Cbr/\u003E عقارات"
	},
	"paid": {
		"en": "Paid",
		"ar": "مدفوع"
	},
	"Real Estate Speculation Index": {
		"en": "Real Estate Speculation Index",
		"ar": "مؤشر المضاربة العقارية"
	},
	"form_validate_gross_floor_area": {
		"en": "Please enter a gross floor area",
		"ar": "يرجى إختيار المساحة الإجمالية "
	},
	"broker_transactions_details": {
		"en": "Broker Details",
		"ar": "معاملات الوسطاء العقاريين"
	},
	"home_DLD_provides_outstanding_services": {
		"en": "DLD provides outstanding services to all its customers and develops the necessary legislation to propel the real estate sector in Dubai by organising and promoting real estate investment, and spreading industry knowledge.",
		"ar": "تقدّم الدائرة خدمات متميزة لجميع المتعاملين في القطاع العقاري، وتوفر خدمة متكاملة، إلى جانب تطوير التشريعات اللازمة، بما يضمن تنظيم القطاع العقاري، وتشجيع وإدارة الاستثمار فيه، بالإضافة إلى نشر المعرفة والثقافة العقارية"
	},
	"minimum_password_special": {
		"en": "One Special Character (!, @, #, $, %, ^, &, or * )",
		"ar": "حرف واحد (!, @, #, $, %, ^, &, or * )"
	},
	"fees": {
		"en": "Fees",
		"ar": "الرسوم"
	},
	"unit": {
		"en": "Unit",
		"ar": "وحدة سكنية"
	},
	"bus_account_desc": {
		"en": "Account owner will have access to Trakheesi,RVS, RDC, Ejari, Mollak, Oqood etc.",
		"ar": "صاحب الحساب يمكنه الوصول إلى Trakheesi و RVS و RDC و Ejari و Mollak و Oqood وما الي ذلك."
	},
	"home_annual_report_title": {
		"en": "Annual Report: Real Estate Sector",
		"ar": "التقرير السنوي: قطاع العقارات"
	},
	"rent_price_index": {
		"en": "Rental Price Index 2019",
		"ar": "مؤشر أسعار الإيجارات 2019"
	},
	"personal_details": {
		"en": "Personal Details",
		"ar": "المعلومات الشخصية"
	},
	"form_validate_license_source": {
		"en": "Please enter a valid license source",
		"ar": "يرجى إدخال مصدر الرخصة صحيح"
	},
	"home_Share_Your_Feedback": {
		"en": "Share Your Feedback",
		"ar": "شارك تعليقاتك"
	},
	"Search_Text_label": {
		"en": "Search by Name",
		"ar": "البحث عن طريق الإسم"
	},
	"tittle_deed": {
		"en": "Title Deed Certificate Information",
		"ar": "معلومات شهادة الملكية"
	},
	"my_apps": {
		"en": "My Apps",
		"ar": "تطبيقاتي"
	},
	"more-project-list-label": {
		"en": "Following is the list of projects based on your interest. you can use the left panel filters to modify your interest.",
		"ar": " فيما يلي قائمة المشاريع التي تناسب اهتماماتك. يمكنك استخدام فلتر اللوحة اليمنى لتعديل اهتمامك."
	},
	"apply_for_service": {
		"en": "Proceed to Service",
		"ar": "انتقل إلى الخدمة"
	},
	"unit_transactions_details": {
		"en": "Unit Details",
		"ar": "معاملات الوحدات"
	},
	"go_to_account": {
		"en": "Go to Account",
		"ar": "اذهب إلى الحساب"
	},
	"your_details": {
		"en": "Your Details",
		"ar": "بياناتك"
	},
	"form_validate_license_issuer": {
		"en": "Please select the license issuer",
		"ar": "يرجى إختيار مصدر الرخصة"
	},
	"emirati-program-detail-msg": {
		"en": "Dubai Land Department will get in touch with you regarding the next steps. Details will be sent to your registered email address",
		"ar": "ستتواصل معك دائرة الأراضي والأملاك في دبي بخصوص الخطوات التالية. سيتم إرسال التفاصيل إلى عنوان بريدك الإلكتروني المسجل"
	},
	"cppi-text1": {
		"en": "Dubai Commercial\u003Cbr /\u003E Property Price Index\u003Cbr /\u003E (CPPI)",
		"ar": "مؤشر أسعار بيع العقارات\u003Cbr /\u003E\n            التجارية في إمارة دبي"
	},
	"rooms": {
		"en": "Room(s)",
		"ar": "الغرف"
	},
	"please_confirm_payment": {
		"en": "Please Confirm the payment",
		"ar": "يرجى تأكيد الدفع"
	},
	"reopen": {
		"en": "Re-Open",
		"ar": "إعادة الفتح"
	},
	"rt_upload_documents_and_submit": {
		"en": "Upload documents & Submit",
		"ar": "تحميل المستندات وإرسال  الطلب"
	},
	"propertyAuction_description_banner": {
		"en": "eMart is an online portal, specially designed for real estate professionals to list their properties for auction in Dubai.",
		"ar": "سوق دبي العقاري الإلكتروني هو بوابة الكترونية لعرض العقارات للبيع من خلال المزادات الإلكترونية في إمارة دبي."
	},
	"uae_pass_desc2": {
		"en": "By downloading the app and creating an account on UAE Pass, the user will have a single digital identity across both local and federal government entities, in addition to various other service providers.",
		"ar": "عن طريق تنزيل التطبيق وإنشاء حساب على UAE Pass ، سيكون للمستخدم هوية رقمية واحدة عبر كل من الجهات الحكومية المحلية والاتحادية ، بالإضافة إلى العديد من مقدمي الخدمات الآخرين."
	},
	"developer_name": {
		"en": "Developer Name",
		"ar": "اسم المطور"
	},
	"home_Integrate_with_our_api": {
		"en": "Integrate with \u003Cbr/\u003Eour APIs",
		"ar": "ربط مع API\u003Cbr/\u003E الخاص بنا"
	},
	"bannerSurveyLink": {
		"en": "https://forms.office.com/Pages/ResponsePage.aspx?id=1oMzOeFJNUe4Isabhql6-Ejsr67vdYVOkiBbMW-tutRUM01SMVFNTkU4UDVTMjRaWVJHMjg1UzM2MC4u&lang=en",
		"ar": "https://forms.office.com/Pages/ResponsePage.aspx?id=1oMzOeFJNUe4Isabhql6-Ejsr67vdYVOkiBbMW-tutRUM01SMVFNTkU4UDVTMjRaWVJHMjg1UzM2MC4u&lang=ar"
	},
	"title": {
		"en": "Title",
		"ar": "اللقب"
	},
	"home_Manage_Your_Co_occupants_title": {
		"en": "Manage Your Co-occupants",
		"ar": "إدارة بيانات القاطنين"
	},
	"complain_submitted": {
		"en": "Complaint Submitted",
		"ar": "تم ارسال الشكوى"
	},
	"home_service_name_update": {
		"en": "Service Name Updates",
		"ar": "تعديل أسماء الخدمات"
	},
	"account_manager_details": {
		"en": "Account Manager Details",
		"ar": "تفاصيل مدير الحساب"
	},
	"request_reason": {
		"en": "Request Reason",
		"ar": "سبب الطلب"
	},
	"scan_the_qr_code_to_share_the_page": {
		"en": "Scan the QR Code to share the page",
		"ar": "امسح رمز الاستجابة السريعة لمشاركة الصفحة"
	},
	"Awards": {
		"en": "Awards",
		"ar": "الجوائز"
	},
	"license_source": {
		"en": "License Source",
		"ar": "مصدر الرخصة"
	},
	"e_g_emirates_id": {
		"en": "e.g. 784-xxxx-xxxxxxx-x",
		"ar": "e.g. 784-xxxx-xxxxxxx-x"
	},
	"Course_PDF": {
		"ar": "ملف PDF للدورة",
		"en": "Course_PDF"
	},
	"form_validate_enter_company_type": {
		"en": "Please enter company type",
		"ar": "Please enter company type"
	},
	"form_validate_project_name": {
		"en": "Please enter a project name",
		"ar": "يرجى إختيار اسم المشروع "
	},
	"smart_judge": {
		"en": "Virtual Judge",
		"ar": "القاضي الافتراضي"
	},
	"landmark": {
		"en": "Landmark",
		"ar": "المعالم الرئيسية"
	},
	"loss_certificate": {
		"en": "Loss Certificate",
		"ar": "طلب إصدار ملكية بدل فاقد"
	},
	"region": {
		"en": "Region",
		"ar": "المنطقة"
	},
	"parking_allocation_type": {
		"en": "Parking Allocatin Type",
		"ar": "نوع تخصيص مواقف السيارات"
	},
	"home_financial_service": {
		"ar": "المؤسسات \u003Cbr/\u003Eالمالية",
		"en": "Financial\u003Cbr /\u003E Institutions"
	},
	"title_deed": {
		"en": "Title Deed",
		"ar": "شهادة ملكية عقار"
	},
	"Service Channel": {
		"en": "Service Channel",
		"ar": "قنوات تقديم الخدمة"
	},
	"home_knowledge_bank_title": {
		"en": "Real Estate \u003Cbr/\u003EKnowledge Bank",
		"ar": "بنك المعرفة\u003Cbr/\u003E العقاري"
	},
	"Broker": {
		"en": "Broker",
		"ar": "وسيط"
	},
	"mobile": {
		"en": "Mobile No.",
		"ar": "رقم المحمول"
	},
	"owner_committee_terms_val_11": {
		"en": "Owners Committee and the member must abide by the dates of scheduled meetings according to the Law, provided that the meetings are held during official working hours of the Management Companies.",
		"ar": "تلتزم لجنة ملاك والأعضاء بمواعيد الاجتماعات المقررة حسب القانون، على أن تعقد الاجتماعات خلال ساعات العمل الرسمية لشركات الإدارة."
	},
	"Jointly-Owned Property Services": {
		"en": "Jointly-Owned Property Services",
		"ar": "خدمات العقارات ذات الملكية المشتركة"
	},
	"under-review": {
		"en": "Under Process",
		"ar": "قيد الإجراء"
	},
	"real_estate_transactions": {
		"en": "Real Estate Transactions",
		"ar": "التصرفات العقارية"
	},
	"projects_info": {
		"en": "Enter minimum 2 characters of the project name to view the details",
		"ar": "الرجاء إدخال 2 أحرف أو أكثر من اسم المشروع لعرض التفاصيل"
	},
	"classification": {
		"en": "Classification",
		"ar": "Classification"
	},
	"form_validate_area": {
		"en": "Please select an area",
		"ar": "يرجى إختيار المنطقة"
	},
	"vault_new_folder": {
		"en": "New folder",
		"ar": "ملف جديد"
	},
	"login_desc": {
		"en": "We have created separate roles based on your profile to give you a customized and seamless experience",
		"ar": "لقد أنشأنا أدوارًا منفصلة بناءً على ملفك الشخصي لمنحك تجربة مخصصة وسلسة"
	},
	"issue-details": {
		"en": "Issue Details",
		"ar": "تفاصيل المشكلة"
	},
	"confirm_delete": {
		"en": "Are you sure you want to remove this file?",
		"ar": "هل أنت متأكد أنك تريد إزالة هذا الملف؟"
	},
	"Home_Registration_Trustee_title": {
		"en": "Real Estate Registration Trustee Centres",
		"ar": "مراكز أمناء التسجيل العقاري"
	},
	"transaction_As_of_today": {
		"en": "As of today",
		"ar": "تصرفات اليوم"
	},
	"forgot_username_question": {
		"en": "Forgot Username ?",
		"ar": "نسيت اسم المستخدم"
	},
	"evaluation_value_sqMter": {
		"en": "Area Size (Sq.Mt)",
		"ar": "مساحة المنطقة (متر مربع)"
	},
	"methodology_html": {
		"en": "\u003Cspan\u003E\n                                    Index\n                                \u003C/span\u003E\n                                \u003Cspan\u003EMethodology\u003C/span\u003E",
		"ar": "\u003Cspan\u003E\n                                    منهجية\n                                \u003C/span\u003E\n                                \u003Cspan\u003Eحساب المؤشر\u003C/span\u003E"
	},
	"current_password": {
		"en": "Current Password",
		"ar": "كلمة المرور الحالية"
	},
	"building_number": {
		"en": "Building Number",
		"ar": "رقم المبنى"
	},
	"industrial": {
		"en": "Industrial",
		"ar": "صناعي"
	},
	"view": {
		"en": "View Details",
		"ar": "التفاصيل"
	},
	"Download_Summary_report": {
		"en": "Download Transactions Summary Report 2015-2021",
		"ar": "تحميل تقرير ملخص المعاملات 2015-2021"
	},
	"bank_acc_num": {
		"en": "Bank account number",
		"ar": "رقم الحساب المصرفي"
	},
	"view_all_favorites": {
		"en": "View all Favorites",
		"ar": "عرض كل المفضلة"
	},
	"vault_create_new_folder": {
		"en": "Create New Folder",
		"ar": "إنشاء مجلد جديد"
	},
	"Complaints": {
		"en": "Complaints & Suggestions",
		"ar": "الشكاوي والاقتراحات"
	},
	"how_do_i": {
		"en": "How do I?",
		"ar": "كيف أفعل؟"
	},
	"usage": {
		"en": "Usage",
		"ar": "الإستخدامات"
	},
	"whistle_policy": {
		"en": "Whistleblowing policy",
		"ar": "سياسة الإبلاغ"
	},
	"non_contractual_complaint_msg_1": {
		"en": "\u003Cli\u003EThe real estate violations system is concerned with  violations committed by real estate companies and in the event that the complaint is not within the competence of the RERA the complaint will be closed.\u003C/li\u003E\n                    \u003Cli\u003E\n                        The complaint must be registered by the person concerned or authorized by power of attorney.\n                    \u003C/li\u003E\n                    \u003Cli\u003E\n                        It must be confirmed that the data entered in the system is correct in order to avoid closing the complaint, for example (choosing the name of the company correctly and the type of complaint ).\n                    \u003C/li\u003E",
		"ar": "\u003Cli\u003Eنظام المخالفات العقاري معني بالنظر في المخالفات العقارية المرتكبة من قبل الشركات العقارية وفي حال ان الشكوى ليست من اختصاص مؤسسة التنظيم العقاري سوف يتم اغلاق الشكوى \u003C/li\u003E\n                    \u003Cli\u003E\n                      يجب تسجيل الشكوى من صاحب العلاقة أو شخص مؤكل بوكالة قانونية .\n                    \u003C/li\u003E\n                    \u003Cli\u003E\n                      يجب التأكد من صحة البيانات المدخلة في النظام تفاديا لاغلاق الشكوى مثال (  اختيار اسم الشركة بشكل صحيح و ونوع الشكوى )\n                    \u003C/li\u003E"
	},
	"form_validate_complainer_name": {
		"en": "Please enter a complainer name",
		"ar": "يرجى إختيار اسم المشتكى "
	},
	"get_access": {
		"en": "Login",
		"ar": "تسجيل الدخول"
	},
	"area": {
		"en": "Area",
		"ar": "المنطقة"
	},
	"general_conditions_of_services": {
		"ar": "General Conditions of Services",
		"en": "General Conditions of Services"
	},
	"otp_received_email": {
		"en": "OTP Received on Email",
		"ar": "تم استلام OTP على البريد الإلكتروني"
	},
	"your_mobile": {
		"en": "Your Mobile",
		"ar": "رقم الهاتف المحمول"
	},
	"form_validate_card_number": {
		"en": "Please enter a valid card number",
		"ar": "يرجى إدخال رقم البطاقة صحيح"
	},
	"download_excel": {
		"en": "Download Excel",
		"ar": "تحميل اكسيل"
	},
	"monthly": {
		"en": "Monthly",
		"ar": "شهرياً"
	},
	"reg_an_individual": {
		"ar": "الفرد",
		"en": "an Individual"
	},
	"ip-error-message": {
		"en": "Unable to verify the identity",
		"ar": "فشل عملية التحقق من الهوية"
	},
	"grand_parent_property_id": {
		"en": "Grand Parent PRoperty Id",
		"ar": "معرف ملكية الوالد"
	},
	"ElectronicComplain": {
		"en": " e Complaint logo",
		"ar": "الشكاوى الإلكترونية"
	},
	"no_application_found": {
		"en": "No Application found",
		"ar": "لم يتم العثور على التطبيق"
	},
	"height": {
		"ar": "ارتفاع",
		"en": "Height"
	},
	"more-completion-percentage": {
		"en": "Completion Percentage",
		"ar": "نسبة الإنجاز"
	},
	"chat_with_us": {
		"en": "Chat with Us",
		"ar": "تواصل معنا "
	},
	"service_directory_icon_label": {
		"en": "This icon designates links that are opened outside the current window",
		"ar": "يحدد هذا الرمز الروابط التي يتم فتحها خارج النافذة الحالية"
	},
	"registration_type": {
		"en": "Registration type",
		"ar": "نوع التسجيل"
	},
	"home_Manage_Your_Co_occupants_text": {
		"en": "All Dubai residents can now add their family members against their Ejari Contract.",
		"ar": "يمكن لجميع المقيمين في دبي الآن إضافة أفراد عائلاتهم مقابل عقد إيجاري. "
	},
	"pro_login": {
		"en": "Proceed to Login as a Business User",
		"ar": "تابع تسجيل الدخول كمستخدم تجاري"
	},
	"select_app_to_register": {
		"en": "Select the Application for which you want to Register",
		"ar": "حدد التطبيق الذي تريد التسجيل فيه"
	},
	"by_company": {
		"en": "Search For Company",
		"ar": "البحث عن شركة"
	},
	"Real Estate Price index for 1st quarter": {
		"en": "Real Estate Price index for 1st quarter",
		"ar": "المؤشر لأسعار العقارات للربع الأول"
	},
	"status": {
		"en": "Status",
		"ar": "الحالة"
	},
	"improve_our_service_msg": {
		"en": "We use this feedback to improve our services and provide a better experience for our users.",
		"ar": "We use this feedback to improve our services and provide a better experience for our users."
	},
	"as_a_business_user_you_can": {
		"en": "As a business user, you can",
		"ar": "كمستخدم تجاري، يمكنك القيام بـ"
	},
	"personal_information": {
		"en": "Personal Information",
		"ar": "المعلومات الشخصية"
	},
	"share_percentage": {
		"en": "Share Percentage",
		"ar": "نسبة السهم"
	},
	"no_notification_msg": {
		"en": "Currently there are no new notifications from Land Department",
		"ar": "لا توجد حالياً إشعارات جديدة من أراضي دبي"
	},
	"government_authority": {
		"en": "Government Authority",
		"ar": "مؤسسة حكومية"
	},
	"msg_twitter": {
		"en": "Message us on Twitter. We will contact you back shortly.",
		"ar": "سنقوم بالأتصال بك قريباً."
	},
	"points": {
		"en": "Points",
		"ar": "النقاط"
	},
	"View_Happiness_Charter": {
		"en": "View Happiness Charter",
		"ar": "عرض ميثاق السعادة"
	},
	"home_tenancy_guide": {
		"en": "Tenancy \u003Cbr/\u003EGuide",
		"ar": "دليل\u003Cbr/\u003E الإيجارات"
	},
	"female": {
		"en": "Female",
		"ar": "أنثى"
	},
	"property_status_inquiry_text": {
		"en": "Inquire about the status of a property by entering the property-related data such as the area and land number.",
		"ar": "للمتعامل الاستعلام عن حالة العقار من خلال ادخال بيانات تخص العقار مثل المنطقة, ورقم الأرض."
	},
	"developer": {
		"en": "Developer",
		"ar": "المطور"
	},
	"no_of_units": {
		"en": "No of Units",
		"ar": "عدد الوحدات"
	},
	"working_day_two": {
		"en": "3 working days",
		"ar": "3 أيام عمل"
	},
	"total_points": {
		"en": "Total Point",
		"ar": "مجموع النقاط"
	},
	"View_All_Entities": {
		"en": "View All Entities",
		"ar": "عرض جميع الجهات"
	},
	"cu_submit_query": {
		"en": "Submit your Query",
		"ar": "ارسل استفسارك"
	},
	"Designation": {
		"en": "Designation",
		"ar": "المسمى الوظيفي"
	},
	"partnershipDLDSPDescription": {
		"en": "This category includes partners that are associated with a direct link, procedures and services with the department",
		"ar": "شركاء الخدمة وهم الشركاء الذين يرتبطون بارتباط مباشر ووثيق باجراءات وخدمات الدائرة بالتزام"
	},
	"emirati-program-request-success-msg": {
		"en": "Request for Dubai Real Estate Brokers Program Submitted Successfully",
		"ar": "تم تقديم طلب ببرنامج دبي للوسيط العقاري بنجاح"
	},
	"send_message": {
		"en": "Send Message",
		"ar": "أرسل رسالة"
	},
	"back": {
		"en": "Back",
		"ar": "الرجوع"
	},
	"Where_can_I_find_Emirates_ID_Number": {
		"en": "Where can I find Emirates ID Number?",
		"ar": "أين أجد رقم الهوية الإماراتية؟"
	},
	"Search_for_Participant": {
		"en": "Search For Participant",
		"ar": "البحث عن ملاك العقارات"
	},
	"land_rest": {
		"en": "Restrained",
		"ar": "مقيد"
	},
	"choose_label": {
		"en": "Choose",
		"ar": "اختار"
	},
	"phone_number": {
		"en": "Phone Number",
		"ar": "رقم الهاتف"
	},
	"raise-support-request": {
		"en": "Raise a Support Request",
		"ar": "تقديم طلب دعم "
	},
	"rt_specify_procedure_value": {
		"en": "Specify the Procedure Value",
		"ar": "حدد قيمة الإجراء"
	},
	"login_as_business_user": {
		"ar": "تسجيل الدخول كمستخدم أعمال",
		"en": "Login as Business User"
	},
	"dld_account_dashboard": {
		"en": "DLD Account Dashboard",
		"ar": "لوحة تحكم حساب دائرة الأراضي والأملاك"
	},
	"quick_actions": {
		"en": "Quick Actions",
		"ar": "عمليات سريعة"
	},
	"email_us": {
		"en": "Email Us",
		"ar": "راسلنا"
	},
	"offices": {
		"en": "Offices",
		"ar": "مكاتب"
	},
	"updated-on": {
		"en": "Updated On",
		"ar": "تاريخ التحديث"
	},
	"titledeed_text": {
		"en": "Understand your Certificate",
		"ar": "افهم شهادتك"
	},
	"choose_files": {
		"en": "Choose Files",
		"ar": "اختر الملفات"
	},
	"home_Connect_with_Us_title": {
		"en": "Get in touch with Us",
		"ar": "تواصل معنا"
	},
	"create_user_password": {
		"en": "Create username and password",
		"ar": "تسجيل اسم مستخدم و كلمة مرور"
	},
	"my_profile": {
		"en": "My Profile",
		"ar": "ملفي"
	},
	"filter_by": {
		"en": "Filter By",
		"ar": "البحث"
	},
	"home_Academic_Courses": {
		"en": "Academic Courses",
		"ar": "الدورات التدريبة الاكاديمية"
	},
	"rental_calculator_laws": {
		"en": "Rental Calculator Laws",
		"ar": "قوانين الحاسبة الايجارية"
	},
	"quick_links_label": {
		"en": "Quick Links",
		"ar": "روابط سريعة"
	},
	"introStep1": {
		"en": "\u003Ch5 class='font-weight-bold'\u003EWelcome to Dubai Land Department Website\u003C/h5\u003E\u003Cp\u003ELet us guide you quickly through our website so it enhances your experience from now on.\u003C/p\u003E",
		"ar": "\u003Ch5 class='font-weight-bold'\u003Eمرحبا بكم في موقع دائرة الأراضي و الأملاك في دبي \u003C/h5\u003E\u003Cp\u003Eدعنا نرشدك بسرعة حول الموقع الخاص بنا حتى يتسنى لنا تحسين خبرتك في التعامل بدءا من الان\u003C/p\u003E"
	},
	"service_residency_status": {
		"en": "Residency Status",
		"ar": "حالة الاقامة"
	},
	"Bank_Name": {
		"ar": "اسم البنك",
		"en": "Bank Name"
	},
	"CourtCasesCount": {
		"en": "Court Cases Count",
		"ar": "عدد القضايا"
	},
	"working_days": {
		"en": "working hours are from Sunday to Thursday, starting from 7:30 am to 2:30 pm",
		"ar": "اوقات العمل من الأحد الى الخميس من الساعة 7:30 صباحا حتى 2:30 مساءا"
	},
	"Upload_Signed_Page_Label": {
		"en": "Upload SPA",
		"ar": "رفع اتفاقية البيع والشراء"
	},
	"Your_request_has_been_submitted_successfully": {
		"ar": "تم تقديم طلبك بنجاح",
		"en": "Your request has been submitted successfully."
	},
	"Mortgage tooltip": {
		"en": "Mortgage Services",
		"ar": "خدمات الرهن العقارى"
	},
	"supplier_registration": {
		"en": "Supplier Registration",
		"ar": "تسجيل الموردين"
	},
	"cu_Social_Media_text": {
		"en": "Do follow us to get frequent updates about Land Department and its initiatives.",
		"ar": "تابعنا للحصول على أخر التحديثات حول دائرة الأراضي ومبادراتها."
	},
	"share_label": {
		"en": "Share",
		"ar": "مشاركة"
	},
	"royal": {
		"en": "Royal",
		"ar": "الملكية"
	},
	"Six Months Ago": {
		"en": "6 Months Ago",
		"ar": "منذ 6 أشهر"
	},
	"non_contractual_complaint_title": {
		"en": "Terms and Conditions",
		"ar": "الشروط والاحكام"
	},
	"form_validate_property_type": {
		"en": "Please select the property type",
		"ar": "يرجى إختيار نوع العقار"
	},
	"owner_user_guide": {
		"en": "Owner User Guide",
		"ar": "دليل الملاك"
	},
	"land_ownership_status": {
		"en": "Ownership Status",
		"ar": "حالة الملكية"
	},
	"procedure_year": {
		"en": "Procedure Year",
		"ar": "سنة الاجراء"
	},
	"no_of_bed_rooms": {
		"en": "No. Of Rooms",
		"ar": "عدد الغرف"
	},
	"login_as_individual_via": {
		"en": "Login as an Individual via",
		"ar": "تسجيل الدخول كفرد"
	},
	"login_to_your_account": {
		"en": "Login to your Account",
		"ar": "تسجيل الدخول إلى حسابك"
	},
	"Customer_Happiness_Charter_link": {
		"en": "https://dubailand.gov.ae/media/tptiyzst/customer_happiness_charter_en_page-0001.jpg",
		"ar": "https://dubailand.gov.ae/media/fybfz301/customer_happiness_charter_ar-1-_page-0001.jpg"
	},
	"owner_committee_reg": {
		"en": "Owner Committee Registration",
		"ar": "تسجيل لجنة ملاك"
	},
	"text": {
		"en": "Title",
		"ar": "الاسم"
	},
	"download_as_csv": {
		"en": "Download as CSV",
		"ar": "حمل البيانات csv"
	},
	"auction_noti_msg_1_1": {
		"en": "Building in Al Baraha for Sale, 407 Sq. Metres – Reserved Price AED 13,300,000",
		"ar": ".مبنى في البراحة للبيع ، مساحة 407 متر مربع - السعر الأساسي 13،300،000 درهم"
	},
	"disable_green_list": {
		"en": "Your information will be removed from the green list.",
		"ar": "ستتم إزالة معلوماتك من القائمة الخضراء."
	},
	"yes": {
		"en": "Yes",
		"ar": "نعم"
	},
	"form_validate_valuator_name": {
		"en": "Please enter a valid valuator name",
		"ar": "يرجى إدخال إسم المقيم صحيح"
	},
	"property_id": {
		"en": "Property ID",
		"ar": "رقم العقار"
	},
	"room_count": {
		"en": "Room Count",
		"ar": "عدد الغرف"
	},
	"overview_label": {
		"en": "Overview",
		"ar": "نظرة عامة"
	},
	"msg_training_not_required": {
		"en": "If you do not want to attend the training session. please select option \"Training not required\".",
		"ar": "إذا كنت لا ترغب في حضور جلسة التدريب. الرجاء تحديد الخيار \"التدريب غير مطلوب\"."
	},
	"participant_number": {
		"en": "Participant Number",
		"ar": "رقم المالك"
	},
	"Home_RDC_Pay_Fees_Deposits": {
		"en": "Pay Fees \u003Cbr/\u003Eand Deposits",
		"ar": "خدمة ادفع \u003Cbr/\u003Eمستحقاتك الان"
	},
	"oqood_and_survey": {
		"en": "Oqood and Survey",
		"ar": "عقود و المسح العقارى"
	},
	"complainer_name": {
		"en": "Complainer Name",
		"ar": "المشتكى"
	},
	"user_information": {
		"en": "User Information",
		"ar": "معلومات المستخدم"
	},
	"Offices_Option": {
		"en": "Offices",
		"ar": "مكاتب"
	},
	"form_validate_title_deed_year": {
		"en": "Please enter a valid title deed year",
		"ar": "يرجى إدخال سنة شهادة الملكية صحيح"
	},
	"request_date": {
		"en": "Request Date",
		"ar": "تاريخ انشاء الطلب"
	},
	"year_text": {
		"en": "Year",
		"ar": "السنة"
	},
	"Group_A_Option": {
		"en": "Group A",
		"ar": "المجموعة أ"
	},
	"Real_Estate_Development_Portal": {
		"en": "Real Estate Development Portal",
		"ar": "دليل التطوير العقاري"
	},
	"find_us": {
		"en": "Find Us Now",
		"ar": "تواصل معنا"
	},
	"more-due-amount-for-completion": {
		"en": "Due Amount for Completion",
		"ar": "المعلومات الشخصية"
	},
	"inspection_photos": {
		"en": "Inspection Photos",
		"ar": "صور الفحص"
	},
	"more-selectCategory-label": {
		"en": "Select property category",
		"ar": "اختر فئة العقار"
	},
	"service_information": {
		"en": "Service Information",
		"ar": "معلومات عن الخدمة"
	},
	"owner_committee_terms_val_10": {
		"en": "Neither Committee members, Jointly Owned Property nor Management Companies are permitted to use any form of media ( including internet, radio, paper, telephone, digital media or any other form of media) for the purpose of discussing or complaining about private issues relating to the Jointly Owned Property, any Committee Member or any dispute relating to the Jointly Owned Property.",
		"ar": "لا يجوز لأي عضو لجنة الملاك للعقار المشترك و جهة الإدارة استخدام الأجهزة الإعلامية المسموعة أو المكتوبة أو المرئية لأسباب دعائية أو لعرض موضوعات خاصة باللجنة أو أحد أعضائها أو خلاف ذلك من الأمور الخاصة بلجنة الملاك. كما لا يجوز أن يشارك أو عمل أي تجمع مع ملاك، من خلال شبكات التواصل الاجتماعي، سواء إليكتروني أو شخصي، بأي شكل من الأشكال ولأي سبب كان."
	},
	"e_g_no_of_rooms": {
		"ar": "e.g. 2",
		"en": "e.g. 2"
	},
	"Collapse_all": {
		"en": "Collapse All",
		"ar": "إغلاق الكل"
	},
	"submit_label": {
		"en": "Submit",
		"ar": "إرسل"
	},
	"contract_law": {
		"en": "Contract Law",
		"ar": "قانون التعاقد"
	},
	"login_via_uae_pass_text_m": {
		"en": "Starting 1/1/2024, login via UAE PASS only for Oqood, Registration Trustee, Property Trustee, Ejari, Trakheesi and Mollak.",
		"ar": "ابتداءً من الأول من يناير 2024، سيكون تسجيل الدخول للتطبيقات التالية عبر الهوية الرقمية فقط: عقود، أمين التسجيل، الأمين العقاري، تراخيصي، ملاك"
	},
	"claimant": {
		"ar": "المدعي",
		"en": "Claimant"
	},
	"shopping_mall": {
		"en": "Shopping Mall",
		"ar": "مركز تسوق"
	},
	"accept_send_invitation_link": {
		"en": "Accept & send invitation link",
		"ar": "الموافقة و ارسال رابط الدعوة"
	},
	"rdc_smart_judge": {
		"en": "Rental Disputes Center Virtual Judge",
		"ar": "مركز فض المنازعات الايجارية القاضي الافتراضي"
	},
	"home_dubai_rest_description": {
		"en": "Dubai REST offers a comprehensive suite of services, including lease management (registration, renewal, and cancellation), rental dispute resolution, and dispute tracking, among others, to both property owners and tenants.",
		"ar": "يقدم تطبيق دبي ريست  مجموعة شاملة من الخدمات، بما في ذلك إدارة العقود الإيجارية (التسجيل والتجديد والإلغاء)، وتسوية المنازعات الإيجارية، وتتبع المنازعات، وغيرها الكثير، لكل من أصحاب العقارات والمستأجرين."
	},
	"setback": {
		"ar": "الارتداد",
		"en": "Setback"
	},
	"sso_profile_update_tc_2": {
		"en": "If you have logged-in using Emirates Id, then all the user names associated with the Emirates Id will be updated with new phone/email.",
		"ar": "يرجى العلم بأنه في حاله استخدام الهويه لتسجيل الدخول في النظام فان جميع بيانات المستخدمين المربوطين بهذه الهوية سيتم تحديثها بالهاتف و البريد الالكتروني الجديد"
	},
	"pre_dev_title": {
		"en": "Pre Development Stage",
		"ar": "مرحلة ما قبل التطوير العقاري"
	},
	"mortgagee_name": {
		"en": "Mortgagee Name",
		"ar": "اسم المرتهن"
	},
	"license_number": {
		"en": "License Number",
		"ar": "الرخصة التجارية"
	},
	"form_validate_upload_required_document": {
		"en": "Please Upload Required Documents",
		"ar": "يرجى رفع ملفات مطلوبه"
	},
	"NewOfficeTimingsTxt3": {
		"en": "Monday till Thursday from 7:30 am until 3:30 pm, Friday 7:30 am till 12:00 pm",
		"ar": "من الاثنين إلى الخميس من 7:30 صباحًا حتى 3:30 مساءً ، الجمعة 7:30 صباحًا حتى 12:00 مساءً"
	},
	"new_password": {
		"en": "New Password",
		"ar": "كلمة مرور جديدة"
	},
	"license_details_text": {
		"en": "License Details",
		"ar": "تفاصيل الترخيص"
	},
	"full_name_label": {
		"en": "Your Full Name",
		"ar": "الأسم بالكامل"
	},
	"golden_visa_investor": {
		"en": "Golden Visa\u003Cbr/\u003E Investor",
		"ar": "الإقامة الذهبية \u003Cbr/\u003E مستثمر"
	},
	"banner-introducing-support-ticket-process-text": {
		"en": "All technical support requests must be raised through the \"Contact Us\" page on the Dubai Land Website. Raising a support ticket directly via email will no longer be supported.",
		"ar": "يجب إرسال جميع طلبات الدعم الفني من خلال صفحة \"اتصل بنا\" الموجودة على موقع دائرة الأراضي و الأملاك. لن يتم دعم أي طلب  يرسل مباشرة عبر البريد الإلكتروني "
	},
	"Linkedin": {
		"en": "Linkedin",
		"ar": "لينكد إن"
	},
	"emirati-program-master": {
		"en": "Masters Degree",
		"ar": "ماجيستير"
	},
	"home_Studies_All_Reports": {
		"en": "View All Reports",
		"ar": "عرض جميع التقارير"
	},
	"forget_ref_number": {
		"en": "If you have forgotten your Complaint Number, please enter your mobile number.",
		"ar": "إذا نسيت رقم الشكوى الخاصة بك، يرجى ادخال رقم الجوال."
	},
	"fsf": {

	},
	"Licensing Services": {
		"en": "Licensing Services",
		"ar": "خدمات الترخيص العقاري"
	},
	"previous": {
		"en": "Previous",
		"ar": "السابق"
	},
	"project_under_con": {
		"en": "Project Details",
		"ar": "تفاصيل المشروعات"
	},
	"i_agree_to": {
		"en": "I agree to the",
		"ar": "أنا موافق"
	},
	"rvs_transaction_completed_title": {
		"en": "Transaction Completed",
		"ar": "تمت المعاملة"
	},
	"built_up_area": {
		"en": "Built Up Area",
		"ar": "المساحة المبنية"
	},
	"search_result_label": {
		"en": "Search Results",
		"ar": "نتائج البحث"
	},
	"Residence Services": {
		"en": "Residence Services",
		"ar": "خدمات الإقامة العقارية"
	},
	"case_number": {
		"en": "Case Number",
		"ar": "رقم الدعوة"
	},
	"Home_News_badge": {
		"en": "News",
		"ar": "الأخبار"
	},
	"dirham": {
		"en": "AED",
		"ar": "درهم"
	},
	"was_this_service_helpful": {
		"en": "Was this service helpful?",
		"ar": "هل كانت هذه الخدمة مفيدة؟"
	},
	"enbd_pdf_link": {
		"en": "https://dubailand.gov.ae/media/gvwn1y5o/edm_for_non_residents_eng.pdf",
		"ar": "https://dubailand.gov.ae/media/4u2hmw10/edm_for_non_residents_arb.pdf"
	},
	"active": {
		"en": "Active",
		"ar": "نشيط"
	},
	"login_as_business_user_via": {
		"ar": "تسجيل الدخول كمستخدم أعمال من خلال",
		"en": "Login as Business User"
	},
	"sales": {
		"en": "Sales",
		"ar": "مبيعات"
	},
	"e_g_legal_type": {
		"ar": "e.g. L.L.C",
		"en": "e.g. L.L.C"
	},
	"form_validate_defendant_name": {
		"en": "Please enter the defendant name",
		"ar": "يرجى إدخال المدعي علية الاسم "
	},
	"earn_certificate_through_our_course": {
		"ar": "احصل على الشهادات المعتمدة من خلال دوراتنا التدريبية عن طريق تقديم الاختبار.  تتوفّر خيارات مرنة وملائمة لإجراء الاختبارات حتى تتمكن من تحديد أفضل ما يناسبك.",
		"en": "Earn certifications through our courses by taking the exam. We have flexible, convenient options for taking exams so you can select what works best for you."
	},
	"rvs_complaint_note_2": {
		"en": "Complaints regarding lease agreements must be submitted through the Center for Rental Disputes Portal",
		"ar": "للشكاوى المتعلقة بعقود الايجار يجب تقديمها عن طريق مركز المنازعات الايجارية عبر الموقع الالكتروني الموقع الالكترونى"
	},
	"management_company": {
		"en": "Management Companies",
		"ar": "شركات إدارة العقارات"
	},
	"rvs_complaint_note_1": {
		"en": "Pursuant to Law No. 16 for the year 2007 regarding the Establishment of the Real Estate Regulatory Agency and determining its competences, shall organize the activities of the real estate offices and lay down the rules and procedures regulating them. It is also competent to look into violations committed by individuals or real estate offices and to take the procedures against the violating companies. The Corporation is not competent to complain about financial claims or disagreement over the terms of the contract Parties are required to review the legal Departments.",
		"ar": "بناءا على القانون رقم ( 16 ) لسنة 2007 بشان انشاء مؤسسة التنظيم العقاري و تحديد اختصاصاتها تتولى المؤسسة تنظيم أنشطة المكاتب العقارية و وضع القواعد والاجراءات المنظمة لها كما تختص بالنظر في المخالفات المرتكبة من الافراد أوالمكاتب العقارية وأتخاذ الاجراءات المعتمدة ضد الشركات المخالفة ولا تختص المؤسسة بالشكاوى المتعلقة بالمطالبات المالية أوالخلاف على بنود التعاقد ويتوجب على الاطراف مراجعة جهات الاختصاص"
	},
	"home_emirates_book_valuation_standards": {
		"en": "Emirates Book \u003Cbr/\u003EValuation Standards",
		"ar": "كتاب الامارات\u003Cbr/\u003E لمعايير التقييم"
	},
	"Proceed_to_Pay": {
		"en": "Proceed to Pay",
		"ar": "تابع للدفع "
	},
	"we_have_sent_an_one_time_password_to_your_registered_mobile_number": {
		"en": "We have sent an one time password to your registered mobile number",
		"ar": "تم إرسال رقم سري إلى رقم الهاتف المسجل للمالك"
	},
	"password_req_fail": {
		"en": "Does not meet the password requirement",
		"ar": "ليست متوافقة مع متطلبات كلمة المرور"
	},
	"crm-service-channel": {
		"en": "Service Channel",
		"ar": "قناة الخدمة"
	},
	"unified_no": {
		"en": "Unified No",
		"ar": "الرقم الموحد"
	},
	"more-cancel-project-list": {
		"en": "Cancelled Project List",
		"ar": " قائمة المشاريع الملغاة"
	},
	"Syllabus": {
		"ar": "المنهج",
		"en": "Syllabus"
	},
	"otp_to_passcode": {
		"en": "We have upgraded from OTP (One Time password ) to Passcode.",
		"ar": "لقد حدثنا كلمه المرور الواحده لرمز المرور"
	},
	"search_by_name": {
		"en": "Search by Name",
		"ar": "البحث عن طريق الإسم"
	},
	"e_g_project_name": {
		"en": "e.g. EMAAR",
		"ar": "e.g. EMAAR"
	},
	"Home_owner_badge": {
		"en": "Owner",
		"ar": "المالك"
	},
	"service_time": {
		"en": "Service Time",
		"ar": "الزمن المتوقع لأنجاز الخدمة"
	},
	"completed": {
		"en": "Completed",
		"ar": "منجز"
	},
	"Home_DLD_Our_Partners": {
		"en": "Our Partners",
		"ar": "شركاؤنا"
	},
	"experience_in_dubai": {
		"en": "Experience In Dubai",
		"ar": "الخبرة داخل دبي"
	},
	"RI-for-same-property-type": {
		"en": "Rental Index for Same Property Type *",
		"ar": "مؤشر بدل الإيجار لنفس نوع العقار*"
	},
	"state": {
		"en": "State",
		"ar": "الإمارة"
	},
	"submit_complain": {
		"en": "Submit Complaint",
		"ar": "ارسل الشكوى"
	},
	"how_do_i_q1_link": {
		"en": "Proceed to Q & A",
		"ar": "انتقل إلى سؤال وجواب"
	},
	"owner_committee_terms_val_2": {
		"en": "Act in the best interests of all Owners and the Jointly Owned Property.",
		"ar": "التصرف لمصلحة جميع الملاك وملكية العقار المشترك."
	},
	"e_g_name": {
		"ar": "e.g. Ahmed Hussain",
		"en": "e.g. Ahmed Hussain"
	},
	"owner_committee_terms_val_12": {
		"en": "Each member of the Owners Committee pledges to abide by the behavioural and ethical rules whilst dealing with members of the Owners Committee, the Management Company and Service Providers.",
		"ar": "يتعهد كل عضو في لجنة الملاك بالالتزام بالقواعد السلوكية والأخلاقية في التعامل مع أعضاء لجنة الملاك وجهة الإدارة ومزودي"
	},
	"user_role_information": {
		"en": "User Role Information",
		"ar": "معلومات  عن دور المستخدم"
	},
	"pending_request": {
		"en": "There's a pending request to share rental cases details, you will receive the response via SMS and email",
		"ar": "يوجد طلب قيد الانتظار لمشاركة بيانات الصحيفة الايجارية, سيتم ارسال الرد قريبا علي رقم الهاتف والبريد الالكتروني"
	},
	"search_looking_for": {
		"en": "What are you looking for ?",
		"ar": "ما الذى تبحث عنه ؟"
	},
	"UnitCountType": {
		"en": "Unit Count",
		"ar": "عدد الوحدات"
	},
	"Search_Text_label_for_broker": {
		"en": "Search broker, offices, mobile, area, ORN",
		"ar": "البحث عن طريق الإسم"
	},
	"Public_Notice": {
		"en": "Public Notice",
		"ar": "الإعلانات بالنشر"
	},
	"Extension": {
		"en": "Extension",
		"ar": "رقم التحويلة"
	},
	"smart_judge_desc": {
		"en": "Contemporary application that enables the commercial relations' parties to be aware of their legal positions for rental contracts, and guides them towards the mechanisms and possibility of filing lawsuits before entering into any litigation stages, by way of simulations (Q&As).",
		"ar": "تطبيق معاصر يمكّن أطراف العلاقات التجارية من التعرف على مواقفهم القانونية من عقود الإيجار ، ويوجههم نحو آليات وإمكانية رفع الدعاوى قبل الدخول في أي مراحل تقاضي ، عن طريق المحاكاة (أسئلة وأجوبة)."
	},
	"vault_rename_folder_name": {
		"en": "Rename Folder Name",
		"ar": "إعادة تسمية اسم المجلد"
	},
	"land": {
		"en": "Land",
		"ar": "أرض"
	},
	"home_madmoun_title": {
		"en": "Verify the advertised property via \"Madmoun\" QR Code",
		"ar": " تحقق من صحة الإعلان العقاري عبر رمز QR Code ضمن خدمة \"مضمون"
	},
	"pre_registration_number": {
		"en": "Pre registration Number",
		"ar": "رقم التسجيل المسبق"
	},
	"minimum_password_uppercase": {
		"en": "One Uppercase character",
		"ar": "حرف واحد كبير"
	},
	"more-stage-of-completion": {
		"en": "Select stage of completion",
		"ar": "تحديد مرحلة الإنجاز"
	},
	"Commercial_Option": {
		"en": "Commercial",
		"ar": "تجاري"
	},
	"total_worth": {
		"en": "Total Worth",
		"ar": "مجموع القيمة"
	},
	"form_validate_certificate_number": {
		"en": "Please enter a valid certificate no.",
		"ar": "يرجى إدخال رقم الشهادة صحيح"
	},
	"full_fact_sheet": {
		"en": "Full Fact Sheet",
		"ar": "الوقائع الكاملة"
	},
	"crm-main-service": {
		"en": "Main Service",
		"ar": "الخدمة الرئيسية "
	},
	"vid_play": {
		"en": "Play",
		"ar": "تشغيل"
	},
	"txt_success": {
		"en": "Success",
		"ar": "نجاح"
	},
	"project_type_normal": {
		"en": "Normal",
		"ar": "عادي"
	},
	"e_g_state": {
		"ar": "e.g. Dubai",
		"en": "e.g. Dubai"
	},
	"RI-other-terms": {
		"en": "* Excluding water, electricity, or any other fees, and not applicable on furnished units, hotels, and hotel apartments.",
		"ar": "* غير شامل الماء والكهرباء أو أي رسوم أخرى وال ينطبق على الوحدات المفروشة والفنادق والشقق الفندقية  ستتم إضافة هذه المالحظة \nتحت الجدول."
	},
	"language": {
		"en": "Language",
		"ar": "اللغة"
	},
	"notice_number": {
		"en": "Notice Number",
		"ar": "رقم الإعلان"
	},
	"closed": {
		"en": "Closed",
		"ar": "تم اغلاق الشكوى"
	},
	"uae_pass": {
		"en": "UAE PASS",
		"ar": "UAE PASS"
	},
	"modal_Announcement": {
		"en": "Announcement",
		"ar": " إعلان"
	},
	"invalid_email_address": {
		"en": "Invalid email address",
		"ar": "البريد الإلكتروني غير صحيح"
	},
	"authorization_request": {
		"en": "Request to see cases details",
		"ar": "طلب اذن لمشاهدة تفاصيل القضايا"
	},
	"h_ramadan-time_details": {
		"en": "Business will continue as usual during the holy month with reduced office timings",
		"ar": "سيستمر العمل كالمعتاد خلال الشهر الكريم مع تخفيض مواعيد العمل في المكاتب"
	},
	"e_g_mobile": {
		"ar": "e.g. 5xxxxxxxxx",
		"en": "e.g. 5xxxxxxxxx"
	},
	"date_of_birth": {
		"en": "Date of Birth",
		"ar": "تاريخ الميلاد"
	},
	"additional_services": {
		"en": "Additional Services",
		"ar": "خدمات إضافية"
	},
	"License_Issue_Date_Text": {
		"en": "License Issue Date",
		"ar": "تاريخ إصدار الترخيص"
	},
	"share_text": {
		"en": "If you liked this page, share it with your friends !!",
		"ar": "اذا اعجبتك هذه الصفحة, شاركها مع اصدقائك !!"
	},
	"JointheliveAuctionnow": {
		"en": "View live Auction",
		"ar": "عرض المزاد العقاري"
	},
	"Income": {
		"en": "Income",
		"ar": "الدخل"
	},
	"floor": {
		"en": "Floor",
		"ar": "الأرض"
	},
	"voucher_details": {
		"en": "Voucher Details",
		"ar": "تفاصيل الإيصال"
	},
	"broker_number": {
		"en": "Broker Number",
		"ar": "رقم الوسيط"
	},
	"Please_select_another_Land": {
		"en": "Please select another Land",
		"ar": "يرجى اختيار أرض أخرى"
	},
	"vault_ref": {
		"en": "Ref",
		"ar": "رقم الطلب"
	},
	"real_estate_activities": {
		"en": "Real Estate Activities",
		"ar": "أنشطة الدولة الحقيقية"
	},
	"rec_type": {
		"en": "Type",
		"ar": "النوع"
	},
	"passwords_doesnt_match": {
		"en": "Password does not match",
		"ar": "كلمة المرور غير متطابقة"
	},
	"buy_property_text": {
		"en": "Enter your Booking Reference Number, verify the details and make the required payment",
		"ar": "أدخل الرقم المرجعي للتحقق من التفاصيل وإجراء الدفع الازم"
	},
	"cu_Social_Media": {
		"en": "Connect with us socially",
		"ar": "وسائل التواصل الاجتماعي"
	},
	"my_portfolio": {
		"en": "My Portfolio",
		"ar": "محفظتي"
	},
	"Online": {
		"en": "Online",
		"ar": "إلكتروني"
	},
	"home_Raise_a_Complaint": {
		"en": "Raise a Complaint",
		"ar": "رفع شكوى"
	},
	"view_details": {
		"en": "View Details",
		"ar": "عرض التفاصيل"
	},
	"shipping_policy": {
		"en": "Shipping Policy",
		"ar": "بوليصة الشحن"
	},
	"emirates_id_number": {
		"en": "Emirates ID Number",
		"ar": "رقم الهوية الوطنية"
	},
	"rt_select_your_rt_office": {
		"en": "Select your RT Office",
		"ar": "حدد مكتب أمين التسجيل الخاص بك"
	},
	"proceed_to_calculator": {
		"en": "Proceed to Calculator",
		"ar": "متابعة الى الحاسبة"
	},
	"rules_and_regulations": {
		"en": "Rules and Regulations",
		"ar": "القوانين والتشريعات"
	},
	"project_status_under_cancellation_decision": {
		"en": "Under Cancellation Decision",
		"ar": "تحت قرار الإلغاء"
	},
	"search_by": {
		"en": "Search By",
		"ar": "البحث بأستخدام"
	},
	"Company_Number": {
		"en": "Company Number",
		"ar": "رقم الشركة"
	},
	"Gift tooltip": {
		"en": "Gift Services",
		"ar": "خدمات المنح"
	},
	"registered_mobile_number": {
		"en": "Registered Mobile Number",
		"ar": "مسجل رقم الجوال"
	},
	"blocking_reason": {
		"en": "Blocking Reason",
		"ar": "سبب الإيقاف"
	},
	"loading": {
		"en": "Loading",
		"ar": "تحميل"
	},
	"rvs_violation_complaint": {
		"en": "RVS - Violation Complaint",
		"ar": "طلب تسجيل شكوى على مخالفة عقارية"
	},
	"rvs_company_complaint_type_mismatch": {
		"en": "Selected complaint type is not relevant for ~",
		"ar": "نوع الشكوى غير مطابق ~"
	},
	"SiteName": {
		"en": "ERES",
		"ar": "ايريس"
	},
	"otp": {
		"en": "OTP",
		"ar": "كود التحقق"
	},
	"function": {
		"en": "Function",
		"ar": "نوع الاستخدام"
	},
	"update_info_in_trustee_office": {
		"en": "To update your personal information, kindly send an email to any of the below given Trustee Offices.",
		"ar": "لتحديث معلوماتك الشخصية، يرجى إرسال بريد إلكتروني إلى أي من مكاتب الأمناء المذكورة أدناه."
	},
	"form_validate_branch_name": {
		"en": "Please enter a branch name",
		"ar": "يرجى إدخال اسم الفرع صحيح"
	},
	"new_file_name": {
		"en": "New File Name",
		"ar": "اسم ملف جديد"
	},
	"country": {
		"en": "Country",
		"ar": "البلد"
	},
	"RI-other-info": {
		"en": "For more information about the rental index:",
		"ar": "لمزيد من المعلومات عن مؤشر الإيجار:"
	},
	"home_training_exam_description": {
		"ar": "قم بإجراء الاختبارات واحصل على شهادة من خلال الدورات التدريبية المتاحة لدينا",
		"en": "Take exams and earn certification through our available courses"
	},
	"i_have_read_and_accept_the_terms_and_condition": {
		"ar": "I have read and accept the terms and conditions.",
		"en": "I have read and accept the terms and conditions."
	},
	"solution": {
		"en": "Solution",
		"ar": "الحل"
	},
	"project_start_date": {
		"en": "Project start date",
		"ar": "تاريخ بدء المشروع"
	},
	"name_english": {
		"en": "Name (English)",
		"ar": "الإسم (بالإنجليزية)"
	},
	"bua_of": {
		"en": "Built-up Area of",
		"ar": "المساحة المبنية من"
	},
	"modal_weather_title": {
		"en": "Remote Working - May 02 - 03, 2024",
		"ar": "العمل عن بعد يوم الخميس والجمعة 02 - 03 مايو 2024"
	},
	"above_info": {
		"en": "The above information doesn’t include the following services:",
		"ar": "المعلومات الواردة أعلاه لا تشمل الخدمات التالية:"
	},
	"Service_Description_PDF": {
		"en": "Service Description (PDF)",
		"ar": "وصف الخدمات (PDF)"
	},
	"form_validate_transaction_type": {
		"en": "Please select the transaction type",
		"ar": "يرجى إختيار نوع المعاملة"
	},
	"more-previous": {
		"en": "Previous",
		"ar": "السابق"
	},
	"e_g_annual_rent": {
		"en": "e.g. 30,000",
		"ar": "e.g. 30,000"
	},
	"Instagram_desc": {
		"en": "View our Instagram page for the latest news and events.",
		"ar": "شاهد صفحتنا على إنستجرام لأحدث الأخبار والفعاليات"
	},
	"Dubai Development Authority": {
		"en": "Dubai Development Authority",
		"ar": "هيئة دبي للتطوير"
	},
	"property_sub_type": {
		"en": "Property Sub Type",
		"ar": "تصنيف العقار"
	},
	"dm_violation": {
		"en": "Dubai Municipality Violation",
		"ar": "مخالفات بلدية دبي"
	},
	"we_have_sent_otp_to_your_email": {
		"en": "Dear customer, we have sent an OTP to your email address.",
		"ar": "عزيزي العميل ، لقد أرسلنا رمز التحقق إلى عنوان بريدك الإلكتروني."
	},
	"defendant_details_section": {
		"en": "2 - Defendant Details",
		"ar": "2 - بيانات المشتكى عليه"
	},
	"storage": {
		"en": "Storage",
		"ar": " وحدة تخزين"
	},
	"key_findings": {
		"en": "\u003Cspan\u003E\n                                    Key\n                                \u003C/span\u003E\n                                \u003Cspan\u003EFindings\u003C/span\u003E",
		"ar": "\u003Cspan\u003E\n                                    النتائج\n                                \u003C/span\u003E\n                                \u003Cspan\u003Eالرئيسية\u003C/span\u003E"
	},
	"Trustees": {
		"en": "Trustees",
		"ar": "مراكز الخدمة"
	},
	"Additional_Services_Link": {
		"en": "View All Additional Services",
		"ar": "View All Additional Services"
	},
	"no_entities": {
		"en": "Number of Entities Involved",
		"ar": "عدد الكيانات المشاركة"
	},
	"zone_authority": {
		"en": "Zone Authority",
		"ar": "سلطة المنطقة"
	},
	"issued_documents": {
		"en": "Issued Documents",
		"ar": "المستندات الصادرة"
	},
	"form_validate_phone_number": {
		"en": "Please enter a valid phone number",
		"ar": "يرجى إدخال رقم الهاتف صحيح"
	},
	"inquery-reason": {
		"en": "Inquiry Type",
		"ar": "نوع الإستفسار"
	},
	"Home_Service_Charge_Index_text": {
		"en": "This service allows customers to enquire about the approved service fees for joint-ownership properties from the Real Estate Regulatory Agency. The service is provided by the Real Estate Relations Regulatory Department.",
		"ar": "تتيح هذه الخدمة للمتعامل الاستعلام عن رسوم الخدمات المعتمدة للعقارات ذات الملكية المشتركة من مؤسسة التنظيم العقاري في إمارة دبي."
	},
	"review_the_response_from_section_cordinator": {
		"en": "Review the response from\u003Cbr /\u003E the section co-ordinator",
		"ar": "مراجعة الاستجابة من قبل مسؤول القطاع"
	},
	"forgot_passcode": {
		"en": "Forgot your passcode?",
		"ar": "نسيت رمز المرور الخاص بك؟"
	},
	"customer_category": {
		"en": "Customer Category",
		"ar": "فئة العميل"
	},
	"form_validate_activity_type": {
		"en": "Please select the activity type",
		"ar": "يرجى إختيار نوع الأنشطة"
	},
	"multi_participants": {
		"ar": ".لقد وجدنا مالكا واحدًا أو أكثر يطابق معايير البحث الخاصة بك",
		"en": "We have found one or more owners matching your search criteria."
	},
	"submit_final_request": {
		"en": "Submit the final request.",
		"ar": "قم بإرسال الطلب النهائي."
	},
	"resed_label": {
		"en": "Residential",
		"ar": "سكني"
	},
	"connect_with_agent": {
		"en": "Connect with our Customer Service team",
		"ar": "تواصل مع فريق خدمة المتعاملين"
	},
	"chamber_of_commerce_no": {
		"en": "Chamber of Commerce No.",
		"ar": "رقم غرفة التجارة"
	},
	"valuations": {
		"en": "Valuations",
		"ar": "التقييمات"
	},
	"per_sqft_value": {
		"en": "Per Sq.Ft value",
		"ar": "القيمة لكل قدم مربع"
	},
	"issuing_map_application": {
		"en": "Issuing \u003Cbr/\u003EMap Application",
		"ar": "طلب إصدار\u003Cbr/\u003E خارطة"
	},
	"home_DLD_Vault_Description": {
		"en": "Digitize your documents and move to a totally paperless workflow.",
		"ar": "رقمنة المستندات الخاصة بك والانتقال إلى سير عمل خالٍ من الورق تمامًا"
	},
	"verification": {
		"en": "Verification",
		"ar": "التحقق"
	},
	"more": {
		"en": "more",
		"ar": "المزيد"
	},
	"document_details": {
		"en": "Document Details",
		"ar": "تفاصيل المستند"
	},
	"partnershipParagraph2": {
		"en": "With the Dubai Land Department interface, you will be able to identify our partners, and easily communication with us through applying the forms online for a partnership or communication with the department. We are pleased to communicate with any departments particularly through our email address : \u003Ca href=\"mailto:partnership@dubailand.gov.ae\" class=\"btn-link\"\u003Epartnership@dubailand.gov.ae\u003C/a\u003E\n\u003Cp\u003E\u003C/p\u003E",
		"ar": "\n                            تمكنكم قائمة الشركاء التعرف على شركاء دائرة الأراضي والأملاك, كما يمكن للمؤسسات الحكومية والخاصة التقدم بطلب عقد شراكة أو التواصل مع الدائرة من خلال الخدمات الالكترونية عبر الموقع.\n \n                            ويسعدنا التواصل مع أي مؤسسات حكومية وخاصة من خلال التواصل معنا على البريد الإلكتروني\n                     \n                            \u003Ca href=\"mailto:partnership@dubailand.gov.ae\" class=\"btn-link\"\u003Epartnership@dubailand.gov.ae\u003C/a\u003E\n\u003Cp\u003E\u003C/p\u003E"
	},
	"complaints_handling_process_steps1_title": {
		"en": "Complaint Administrator will receive the request and transfer it to the Sector Co-ordinator",
		"ar": "سيقوم المسؤول عن الشكاوى باستلام الطلب ومن ثمّ إحالته إلى الشخص المعني حسب القطاع"
	},
	"form_validate_english_name": {
		"en": "Please enter a valid English name",
		"ar": "يرجى إدخال اسم الشركة (انجليزي) صحيح"
	},
	"other_properties": {
		"en": "Other Properties",
		"ar": "العقارات الأخرى"
	},
	"owner_regi": {
		"en": "Your registration is completed successfully.",
		"ar": "تم تسجيلك بنجاح."
	},
	"emirati-program-place-of-work": {
		"en": "Place of work",
		"ar": "مكان العمل"
	},
	"forgot_password_info": {
		"en": "Please note that a OTP will be sent to your registered email / mobile for verification.",
		"ar": "يرجى ملاحظة أنه سيتم إرسال OTP إلى بريدك الإلكتروني المسجل / هاتفك المحمول للتحقق."
	},
	"land_owners_num": {
		"en": "Number Of Owners",
		"ar": "عدد الملاك"
	},
	"main_menu": {
		"ar": "القائمة الرئيسية",
		"en": "Main Menu"
	},
	"uae_pass_desc": {
		"en": "The UAE Pass app is the first national digital identity and signature solution that enables users to identify themselves to government service providers in all emirates through a smartphone-based authentication. It also enables users to sign documents digitally with a high level of security.",
		"ar": "يعد تطبيق UAE Pass أول حل للتوقيع والهوية الرقمية الوطنية يتيح للمستخدمين التعرف على أنفسهم لمقدمي الخدمات الحكومية في جميع الإمارات من خلال مصادقة تعتمد على الهاتف الذكي. كما أنه يمكّن المستخدمين من توقيع المستندات رقميًا بمستوى عالٍ من الأمان."
	},
	"violation_status": {
		"en": "Violation Status",
		"ar": "حالة الانتهاك"
	},
	"email_label": {
		"en": "Email",
		"ar": "البريد الالكتروني"
	},
	"start_date_should_be_after_end_date": {
		"en": "Start date can not be after end date",
		"ar": "تاريخ النهاية لا يمكن أن يكون قبل تاريخ البداية"
	},
	"from_date": {
		"en": "From Date",
		"ar": "من تاريخ"
	},
	"delete": {
		"en": "Delete",
		"ar": "حذف"
	},
	"Ejari Templates": {
		"en": "Ejari Templates",
		"ar": "نماذج إيجاري"
	},
	"comp_expec": {
		"en": "What are your expectations from Dubai Land Department to\n                                        resolve your complaint?",
		"ar": "ما هي توقعاتك من دائرة الأراضي والأملاك في دبي في حل شكواك ؟"
	},
	"applicant_mobile": {
		"en": "Applicant Mobile",
		"ar": "الهاتق المحمول"
	},
	"search_property": {
		"en": "Search Property",
		"ar": "بحث عقار"
	},
	"escrow_account_number": {
		"en": "Escrow Account Number",
		"ar": "رقم حساب الضمان"
	},
	"otp_instruction_msg": {
		"en": "An OTP has been sent to your mobile / email. Please enter the OTP to submit transaction.",
		"ar": "تم ارسال الكود الى جوالك / البريد الالكترونى\nمن فضلك ادخل كود التحقق"
	},
	"e_g_branch_name": {
		"ar": "e.g. Marina Branch",
		"en": "e.g. Marina Branch"
	},
	"form_validate_to_date": {
		"en": "Please enter the valid To Date",
		"ar": "يرجى إدخال تاريخ نهاية صحيح"
	},
	"enter_you_emirates_id_number": {
		"en": "Enter you Emirates ID Number",
		"ar": "أدخل رقم الهوية الإماراتية"
	},
	"form_validate_case_type": {
		"en": "Please select the case type",
		"ar": "يرجى إختيار نوع الدعوى"
	},
	"mashrooi-project-remarks": {
		"en": "Remarks",
		"ar": "ملاحظات"
	},
	"RI-amount-of-increase": {
		"en": "Amount of Increase",
		"ar": "مبلغ الزيادة"
	},
	"view_detail_pdf": {
		"en": "View Details (pdf)",
		"ar": "(pdf) عرض التفاصيل"
	},
	"Escrow_Account_label": {
		"ar": "حساب الضمان",
		"en": "Escrow Account"
	},
	"personal": {
		"en": "Personal",
		"ar": "شخصي"
	},
	"footer": {
		"en": "Footer",
		"ar": "فوتر"
	},
	"dev_step_1": {
		"en": "Step 01",
		"ar": "الخطوة 01"
	},
	"view_all_projects": {
		"en": "Proceed to the map",
		"ar": "عرض جميع المشاريع في دبي"
	},
	"report_type": {
		"en": "Report Type",
		"ar": "نوع التقرير"
	},
	"Home_RDC_Register_your_Case_text": {
		"en": "You can register your Case using this service",
		"ar": "يمكنك تسجيل دعواك من خلال استخدام تلك الخدمة"
	},
	"rt_duplicate_party": {
		"en": "The Party already exists with given Emirates ID or Passport.",
		"ar": "تم العثور على الطرف برقم هوية إماراتية أو جواز سفر."
	},
	"office_name": {
		"en": "Office Name",
		"ar": "اسم المكتب"
	},
	"estimated_price": {
		"en": "Estimated Price",
		"ar": "القيمة المتوقعة"
	},
	"includes_one_year_support": {
		"ar": "(يتضمن دعم لمدة عام واحد)",
		"en": "(Includes one year support)"
	},
	"Training_Date": {
		"en": "Training Date",
		"ar": "تاريخ التدريب"
	},
	"current_file_name": {
		"en": "Current File Name",
		"ar": "اسم الملف الحالي"
	},
	"Dubai Land Department": {
		"en": "Dubai Land Department",
		"ar": "دائرة الأراضي والأملاك"
	},
	"project_under": {
		"en": "Project is under",
		"ar": "المشروع تحت"
	},
	"ejari_request_sent": {
		"en": "Request Sent",
		"ar": "Request Sent"
	},
	"community": {
		"en": "Community",
		"ar": "المنطقة"
	},
	"registration_date": {
		"en": "Registration Date",
		"ar": "تاريخ التسجيل"
	},
	"comp_service": {
		"en": "Service",
		"ar": "الخدمة"
	},
	"efficiency_and_excellence": {
		"en": "Efficiency and Excellence of Real Estate Valuation Company",
		"ar": "كفاءة وتميز شركة التثمين العقاري"
	},
	"unit_label": {
		"en": "Unit / Store",
		"ar": "وحدة / مستودع"
	},
	"Price": {
		"en": "Price",
		"ar": "السعر"
	},
	"e_g_rvs_case_number": {
		"en": "e.g. 123/2024",
		"ar": "e.g. 123/2024"
	},
	"helpText_ExternalLink": {
		"en": "This link will direct you to an external website that may have different content and privacy policies than dubailand.gov.ae",
		"ar": "يوجهك هذا الرابط الى موقع خارجي قد يكون له سياسات مختلفة للمحتوى والخصوصية عن موقع دائرة الأراضي و الأملاك."
	},
	"total_property_worth": {
		"en": "Total Property Worth",
		"ar": "إجمالي قيمة الممتلكات"
	},
	"form_validate_emirates_id": {
		"en": "Please enter a valid emirates id number",
		"ar": "يرجى إدخال رقم الهوية صحيح"
	},
	"emirati-program-disclamer": {
		"en": "This service is only for UAE nationals and who do not hold a broker license.",
		"ar": "هذه الخدمة مخصصة فقط لمواطني دولة الإمارات العربية المتحدة ولا يمتلكون رخصة وسيط"
	},
	"Customer_Happiness_Charter_card": {
		"en": "Customer Happiness Charter",
		"ar": "ميثاق إسعاد المتعاملين"
	},
	"By_Project_Option": {
		"en": "By Project",
		"ar": "حسب المشروع"
	},
	"home_banner_webinar_Virtually": {
		"en": "Virtually",
		"ar": "جلسة افتراضية"
	},
	"register_as_new_user": {
		"en": "Sign up as New User",
		"ar": "سجل كمستخدم جديد"
	},
	"emirates_id_expired": {
		"en": "Emirates id expired",
		"ar": "انتهت صلاحية هوية الإمارات."
	},
	"form_validate_looks_good": {
		"en": "Looks good!",
		"ar": "يبدو جيدا!"
	},
	"non_contractual_complaint_msg": {
		"en": "\u003Cdiv class=\"card-title fw-bold mb-3\"\u003E\n                    Dear customer: You must read and agree to these terms and conditions before filing a complaint in the real estate violations system, as if the complaint does not meet the following conditions, the complaint will be closed.\n                \u003C/div\u003E",
		"ar": "\u003Cdiv class=\"card-title fw-bold mb-3\"\u003E\n                   عميلنا العزيز : يجب قراءة هذه الشروط والاحكام والموافقة عليها  قبل تقديم الشكوى في نظام المخالفات العقاري  حيث انه في حالة عدم مطابقة الشكوى للشروط التالية سوف يتم اغلاق الشكوى.\n                \u003C/div\u003E"
	},
	"owner_register_label": {
		"en": "Individual",
		"ar": "كفرد"
	},
	"download_conduct": {
		"en": "Conduct Certificate",
		"ar": "تحميل الصحيفة الايجارية"
	},
	"Re-Shield-Form-Country": {
		"en": "Where are you from? * ",
		"ar": "بلدك؟*"
	},
	"complaint_type": {
		"en": "Complaint Type",
		"ar": "نوع الشكوى"
	},
	"banner_noqodi_link": {
		"en": "Application Form",
		"ar": "نموذج الطلب"
	},
	"All_Brokers_Option": {
		"en": "All Brokers",
		"ar": "جميع الوسطاء"
	},
	"amount": {
		"en": "Amount",
		"ar": "المبلغ"
	},
	"commercial": {
		"en": "Commercial",
		"ar": "تجاري"
	},
	"form_validate_transaction_number": {
		"en": "Please enter a valid transaction number",
		"ar": "يرجى إدخال رقم المعاملة صحيح"
	},
	"map_view": {
		"en": "Map",
		"ar": "الخريطة"
	},
	"title_Deed_Explanation": {
		"en": "Title Deed Explanation",
		"ar": "شرح الملكية العقارية"
	},
	"issue_date": {
		"en": "Issue Date",
		"ar": "تاريخ الإصدار"
	},
	"اليوم": {
		"en": "Delete",
		"ar": "حذف"
	},
	"EscrowAccountBalance": {
		"en": "Escrow Account Balance",
		"ar": "رصيد حساب الضمان"
	},
	"contact_ejari": {
		"en": "04-2030461",
		"ar": "04-2030461"
	},
	"broker_training_FAQs_Q7_a": {
		"ar": "\u003Cul class=\"arrow-list px-4\"\u003E\n                                    \u003Cli\u003Eصورة عن الرخصة التجارية للشركة\u003C/li\u003E\n                                    \u003Cli\u003Eخطاب تفويض (يجب أن تكون ورقة خطاب رسمية من الشركة، وموقعة ومختوم من قِبل الشخص المسؤول\u003C/li\u003E\n                                    \u003Cli\u003Eتوكيل رسمي (في حال لم يكن توقيع الشخص المسؤول موجوداً على رخصة الشركة التجارية)\u003C/li\u003E\n                                    \u003Cli\u003Eجواز السفر أو التأشيرة أو الهوية الإماراتية للشخص الموقع.\u003C/li\u003E\n                                    \u003Cli\u003Eصورة عن جواز السفر وصفحة التأشيرة للمستخدم المطلوب\u003C/li\u003E\n                                    \u003Cli\u003E إذا لم تكن تأشيرة المستخدم المطلوبة من نفس الشركة، فسيلزم شهادة عدم ممانعة من الكفيل.\u003C/li\u003E\n                                \u003C/ul\u003E",
		"en": "\u003Cul class=\"arrow-list px-4\"\u003E\n                                    \u003Cli\u003ECopy of company trade license\u003C/li\u003E\n                                    \u003Cli\u003EAuthorization Letter(must be on company letter head and signed  and stamped by authorized person and submitted in original)\u003C/li\u003E\n                                    \u003Cli\u003EPower of attorney (If authorized signature not part of trade license)\u003C/li\u003E\n                                    \u003Cli\u003EPassport/ Visa/ Emirates Id of the signatory person.\u003C/li\u003E\n                                    \u003Cli\u003EPassport Copy with Visa page for requested user\u003C/li\u003E\n                                    \u003Cli\u003EIf the requested user person visa is not from the same company then NOC from sponsor is required.\u003C/li\u003E\n                                \u003C/ul\u003E"
	},
	"mars_hope_probe_text": {
		"en": "The Emirates Mars Mission \"Hope Probe\" will be the first probe to provide a complete picture of the Martian atmosphere and its layers when it reaches the red planet’s orbit in 2021.",
		"ar": "سيقدم مشروع الإمارات لاستكشاف المريخ \"مسبار الأمل\"، أول صورة متكاملة للغلاف الجوي للمريخ، عندما يصل إلى الكوكب الأحمر عام 2021"
	},
	"partnershipDLDSRT": {
		"en": "Real Estate Registration Trustee Centres",
		"ar": "مراكز أمناء التسجيل العقاري"
	},
	"cheque_return_letter": {
		"ar": "رسالة ارتجاع الشيك",
		"en": "Cheque Return Letter"
	},
	"broker_name": {
		"en": "Broker Name",
		"ar": "اسم الوسيط"
	},
	"project_Type_misc": {
		"en": "Miscellaneous",
		"ar": "متعدد"
	},
	"please_select_main_service": {
		"en": "Please select main service",
		"ar": "الرجاء تحديد الخدمة الرئيسية"
	},
	"notice_party": {
		"en": "Notice Party",
		"ar": "المطلوب اعلانه"
	},
	"Retails_Option": {
		"en": "Retails",
		"ar": "تجارة التجزئة"
	},
	"Project_Contractor": {
		"en": "Project Contractor",
		"ar": "متعاقد المشروع"
	},
	"banner-btc-description": {
		"en": "To obtain a broker card, you must pass the test prepared by Land Department, and a booklet about the test is available that can be purchased from the website",
		"ar": "للحصول على بطاقة الوسيط العقاري يجب عليك اجتياز اختبار دائرة الأراضي والأملاك في دبي. بإمكانك شراء كتيب الإعداد للاختبار من الموقع الإلكتروني"
	},
	"DubaiCareer": {
		"en": "Dubai Career",
		"ar": "وظائف دبي"
	},
	"home_Integrate_with_our_api_description": {
		"en": "Integrate your apps with our systems to accelerate your digital transformation.",
		"ar": "اربط التطبيقات الخاصة بك مع الأنظمة الخاصة بنا لتسريع التحول الرقمي"
	},
	"technical_support": {
		"en": "Technical Support",
		"ar": "دعم تقني"
	},
	"project_or_unit_details": {
		"en": "Project / Unit Details",
		"ar": "بيانات المشروع / الوحدة"
	},
	"Dubai South": {
		"en": "Dubai South",
		"ar": "دبي الجنوب"
	},
	"home_rental_good_conduct_certificate": {
		"en": "Rental Good \u003Cbr/\u003E Conduct Certificate",
		"ar": "صحيفة \u003Cbr/\u003E الحالة الايجارية"
	},
	"my_requests": {
		"en": "My Requests",
		"ar": "طلباتي"
	},
	"Service Providing-Entities": {
		"en": "Service Providing-Entities",
		"ar": "الجهات المقدمة للخدمات"
	},
	"connect_apps_with_ease": {
		"en": "Connect Apps with Ease",
		"ar": "تسهيل ربط التطبيقات  بسهولة"
	},
	"message": {
		"en": "Message",
		"ar": "الرسالة"
	},
	"f_square": {
		"en": "Square feet",
		"ar": "قدم مربع"
	},
	"office_trade_license_text": {
		"en": "Search trade license numbers registered with DLD and check the validity.",
		"ar": "ابحث عن أرقام الرخص التجارية من مع دائرة الأراضي و تحقق من الصلاحية"
	},
	"other_dld_apps": {
		"en": "Other Dubai Land Applications",
		"ar": "تطبيقات الدائرة الأخرى"
	},
	"real_estate_transactions_description": {
		"en": "This service allows customers to search for the sites of Registration Trustees and Property Trustee Centres providing the services of the Real Estate Transaction Services such as registration of sale and mortgage.",
		"ar": "عرض جميع التصرفات العقارية المسجلة في دائرة الأراضي والأملاك بدبي. يمكنك التصفح حسب المجمع أو المنطقة وكذلك أنواع العقارات"
	},
	"reference_number": {
		"en": "Reference Number",
		"ar": "رقم المرجع"
	},
	"home_innovation_incubator_title": {
		"en": "Real Estate Evolution Space (REES)",
		"ar": "مبادرة ريس للابتكار العقاري"
	},
	"Newsroom": {
		"ar": "غرفة الأخبار",
		"en": "Newsroom"
	},
	"Dubai_Option_label": {
		"en": "Dubai",
		"ar": "دبي"
	},
	"Entities_Involved": {
		"en": "Entities Involved\u003Cbr /\u003E with Us",
		"ar": "الجهات المشاركة"
	},
	"employee": {
		"en": "Employee",
		"ar": "الموظف"
	},
	"propertyAuction_banner": {
		"en": "Live\u003Cbr/\u003EProperty Auction",
		"ar": "المزاد\u003Cbr/\u003E العقاري"
	},
	"file size kb": {
		"en": "kb",
		"ar": "كيلوبايت"
	},
	"Trainer": {
		"en": "Trainer",
		"ar": "المدرّب"
	},
	"multiple_attempts": {
		"ar": "محاولات متعددة",
		"en": "Multiple Attempts"
	},
	"partnershipRealEstatePartners": {
		"en": "Real Estate Partners",
		"ar": "شركاء القطاع العقاري"
	},
	"Where_is_my_Title_Deed_number": {
		"en": "Where is my Title Deed number?",
		"ar": "أين رقم الشهادة (الملكية) الخاصة بي؟"
	},
	"description-placeholder": {
		"en": "Type issue description",
		"ar": "الرجاء إدخال الوصف"
	},
	"emirati-program-govt-organization": {
		"en": "Government Organisation",
		"ar": "مؤسسة حكومية"
	},
	"rdc_smart_ai": {
		"en": "Swift self-litigation system using AI",
		"ar": "نظام التقاضي الذاتي السريع باستخدام الذكاء الاصطناعي"
	},
	"information": {
		"en": "Information",
		"ar": "معلومات"
	},
	"true": {
		"en": "Yes",
		"ar": "نعم"
	},
	"form_validate_expiry_date": {
		"ar": "يرجى إدخال تاريخ انتهاء",
		"en": "Please enter expiry date"
	},
	"sub_type": {
		"en": "Sub Type",
		"ar": "نوع العقار الفرعي"
	},
	"dld_rvs_case_tracking_description": {
		"en": "This service enables customers to inquire about the status of a Real Estate Violation System complaint number",
		"ar": "تتيح هذة الخدمة للعملاء الاستعلام عن حالة الشكوى الخاصة بنظام المخالفات العقارية باستخدام رقم الشكوى"
	},
	"more-villa-count": {
		"en": "Villa Count",
		"ar": "عدد الفيلات"
	},
	"Offices_Developers": {
		"en": "Offices & Developers",
		"ar": "المكاتب و المطورين"
	},
	"bank_address": {
		"en": "Bank address",
		"ar": "عنوان البنك"
	},
	"Home_RDC_Pay_Fees_Deposits_text": {
		"en": "The RDC's customers can pay their fees and due monetary claims on Dubai Land Department website by using the (RDC - Pay Fees and Deposits) service.",
		"ar": "يمكن لمتعاملي المركز سداد جميع الرسوم والمطالبات المستحقة عليهم في نظام المركز من خلال خدمة ( ادفع مستحقاتك الان ) والمتاحة ضمن الخدمات العامة لمتصفحي موقع دائرة الأراضي والاملاك"
	},
	"h_complaint_handling_Process": {
		"en": "Complaints \u003Cbr/\u003EHandling Process",
		"ar": "آلية معالجة\u003Cbr/\u003E الشكاوي"
	},
	"form_validate_current_annual_rent": {
		"en": "Please enter the current annual rent",
		"ar": "يرجى إدخال الأيجار السنوي"
	},
	"download_the_Pledge": {
		"en": "Download non-disclosure of confidentiality",
		"ar": "تحميل اقرار عدم إفشاء السرية"
	},
	"moasher_sales_price_index": {
		"en": "Mo’asher",
		"ar": "مؤشر "
	},
	"non_contractual_complaint_msg_3": {
		"en": "\u003Cdiv class=\"text-danger\"\u003E\n                    \u003Cb\u003EImportant note:\u003C/b\u003E In order to quickly complete the transaction, the system will automatically transfer the complaint submitted to the company officials to respond to it, and the employee will follow up, take action and respond to the complainant.\n                \u003C/div\u003E",
		"ar": "\u003Cdiv class=\"text-danger\"\u003E\n                    \u003Cb\u003Eملاحظة هامة :\u003C/b\u003E لسرعة انجاز المعاملة سيقوم النظام بشكل تلقائي بتحويل الشكوى المقدمة الى لمسؤولي الشركة للرد عليها ومن ثم يقوم الموظف المعني بالمتابعة واتخاذ الإجراءات المعتمدة والرد على المشتكي.  \n                \u003C/div\u003E"
	},
	"contact_registration_and_property_trustees": {
		"en": "04-2030505",
		"ar": "04-2030505"
	},
	"valuation_transactions": {
		"en": "Valuation Transactions",
		"ar": "التقييم العقاري"
	},
	"modal_Announcement_content": {
		"en": "We have successfully completed the required number of participants for the second phase of the 'Dubai Real Estate Broker' program, and registration for this phase is now closed. The training programs for this phase will be announced in November 2024.\u003Cbr/\u003E \u003Cbr/\u003E Those interested in joining the program are encouraged to follow the department's official channels and stay tuned for announcements regarding next phases.",
		"ar": "استكملنا العدد المطلوب للدورة الثانية من برنامج “دبي للوسيط العقاري”، وتم إغلاق باب التسجيل لهذه المرحلة. وسيتم الإعلان عن البرامج التدريبية الخاصة بها في نوفمبر 2024. \u003Cbr/\u003E ومن يرغب بالانضمام للبرنامج، يمكنه متابعة القنوات الرسمية للدائرة وترقب الإعلان عن المراحل التالية."
	},
	"max_file_size_allowed": {
		"en": "Max. allowed file size: 2MB",
		"ar": "ماكس. حجم الملف المسموح به: 2MB"
	},
	"allowed_file_types": {
		"en": "Allowed File Types",
		"ar": "انواع الملفات المسموحة"
	},
	"OtherServices": {
		"en": "Other Services",
		"ar": "Other Services"
	},
	"new_user_registartion": {
		"en": "New User Registration",
		"ar": "تسجيل مستخدم جديد"
	},
	"one_acc": {
		"en": "One Account for All",
		"ar": "حساب واحد للكل"
	},
	"are_you_sure_you_want_to_delete_this_file": {
		"en": "Are you sure you want to delete this file?",
		"ar": "هل أنت متأكد أنك تريد حذف هذا الملف؟"
	},
	"num_of_prop_rented": {
		"en": "No. of properties rented",
		"ar": "عدد العقارات المستأجرة"
	},
	"describe_here": {
		"en": "Describe here",
		"ar": "وصف هنا"
	},
	"service_charge": {
		"en": "Service Charges",
		"ar": "رسوم الخدمة"
	},
	"golden_visa_investor_text": {
		"en": "This service allows the real estate investor owning a property the purchase value of which is equal to or more than 2 million AED at the time of purchase.",
		"ar": "تتيح هذه الخدمة للمستثمر العقاري الذي يملك عقار تساوي او تزيد قيمته الشرائية عن مليونين درهم وقت الشراء."
	},
	"new_customers": {
		"ar": "العملاء الجدد",
		"en": "New Customers"
	},
	"units": {
		"en": "Units",
		"ar": "الوحدات"
	},
	"Home_rental_calculator_proceed": {
		"en": "Proceed to Rental Calculator",
		"ar": "انتقل إلى الحاسبة الإيجارية"
	},
	"files_selected": {
		"en": "file(s) selected",
		"ar": "تم تحديد الملف"
	},
	"vault_files": {
		"en": "Vault Files",
		"ar": "ملفات الخزينة الرقمية"
	},
	"Master developer": {
		"en": "Master developer",
		"ar": "مطور رئيسي"
	},
	"property_status": {
		"en": "Property Status",
		"ar": "حالة العقار"
	},
	"sale_Second": {
		"en": ", Second",
		"ar": ", الثاني: "
	},
	"offplan": {
		"en": "Off Plan",
		"ar": "بيع مبدئى"
	},
	"form_validate_budget_year": {
		"ar": "Please enter a valid budget year",
		"en": "Please enter a valid budget year"
	},
	"rent_value": {
		"en": "Rent Value",
		"ar": "قيمة التمويل"
	},
	"ejari-contract-no": {
		"en": "Ejari Contract Number",
		"ar": "رقم عقد إيجاري"
	},
	"emirati-program-unemployed": {
		"en": "Unemployed",
		"ar": "غير موظف"
	},
	"more-document-title": {
		"en": "Project Quotation Proposal *",
		"ar": "مقترح عرض أسعار المشروع *"
	},
	"forgot_username": {
		"en": "Forgot Username",
		"ar": "نسيت اسم المستخدم"
	},
	"Policies": {
		"en": "Policies",
		"ar": "السياسات"
	},
	"phone": {
		"en": "Phone",
		"ar": "الهاتف"
	},
	"Upload_Passport_Copy_Label": {
		"en": "Upload Passport Copy",
		"ar": "صورة الجواز"
	},
	"add_project": {
		"en": "Add Project",
		"ar": "إضافة مشروع"
	},
	"PhotoArchive_Title": {
		"en": "Photo Archive",
		"ar": "أرشيف الصور"
	},
	"more-completed": {
		"en": "Completed",
		"ar": "مكتمل"
	},
	"file_max_allowed": {
		"en": "Maximum {{fi-limit}} files allowed",
		"ar": "يسمح بحد أقصى {{fi-limit}} ملفات"
	},
	"email_validation": {
		"en": "Please provide a valid email.",
		"ar": "يرجي إدخال بريد الكتروني صحيح."
	},
	"rt_office": {
		"en": "RT Office",
		"ar": "مكتب أمين التسجيل العقاري"
	},
	"company_type": {
		"en": "Company Type",
		"ar": "نوع الشركة"
	},
	"select_areas": {
		"en": "Please type here",
		"ar": "من فضلك ادخل اسم المنطقة"
	},
	"banner-in-our-continuous-effort": {
		"en": "In our continuous effort to improve proactive services and enhance customer experience, we are providing our services at multiple locations across Dubai.",
		"ar": "سعياً منّا لتعزيز خدماتنا الاستباقيّة وتوفير تجربة أفضل لمتعاملينا، وفرنا لكم خدماتنا في عدد من مراكز الخدمة في دبي."
	},
	"home_integrate_your_apps_with_systems": {
		"en": "Elevate your customer experience by integrating your apps with DLD systems like Ejari, Mollak, and Trakheesi.",
		"ar": " ارتقِ بتجربة عملائك من خلال دمج تطبيقاتك مع أنظمة دائرة الأراضي والأملاك في دبي مثل إيجاري وملاك وتراخيصي."
	},
	"Home_Title_Deed_Verification": {
		"en": "Verification of Certificate of Title / Title deed",
		"ar": "التحقق من شهادة التملك"
	},
	"news_admin_label": {
		"en": "Admin, Land Department",
		"ar": "المشرف ، دائرة الأراضي"
	},
	"sso_link_fail_create_new_user_id": {
		"en": "auto user creation failed. Please enter new account username and password",
		"ar": "فشل إنشاء المستخدم التلقائي. الرجاء إدخال اسم مستخدم حساب جديد وكلمة مرور"
	},
	"form_validate_upload_establishment_contract": {
		"en": "Please upload the company establishment contract",
		"ar": "يرجى تحميل العقد تأسيس الشركة"
	},
	"form_validate_upload_emirates_id_copy": {
		"en": "Please upload emirates id copy",
		"ar": "يرجى رفع نسخة الهوية"
	},
	"no_of_rooms": {
		"en": "Number of Rooms",
		"ar": "عدد الغرف"
	},
	"EscrowAgents": {
		"en": "Escrow Agents",
		"ar": "امناء حساب الضمان"
	},
	"home_banner_Registration_Trustees_text": {
		"en": "Location of RT Offices that provide RERA Services, including sale and mortgage",
		"ar": "موقع مكاتب RT التي تقدم خدمات هيئة التنظيم العقارية متضمنه البيع و الرهن العقاري"
	},
	"home_Raise_a_Complaint_text": {
		"en": "The 04  platform enables customers to submit suggestions, comments and complaints in three steps via an omni channel experience.",
		"ar": "تمثل منصة \"04\" منصة موحدة للتواصل بين حكومة دبي ومتعامليها، حيث تمكن المتعاملين من تقديم الاقتراحات والشكاوى من خلال ثلاث خطوات عبر منصة شاملة."
	},
	"sso_app_desc_propertysurvey": {
		"en": "The Property Survey system is an online platform that allows the certified survey companies to upload.",
		"ar": "نظام شركات المساحة هو نظام الكتروني  يسمح لشركات المساحة لتحميل العقارات"
	},
	"violation_description": {
		"en": "Violation Type",
		"ar": "نوع الانتهاك"
	},
	"speech_msg": {
		"en": "Now you can access the menu just with your voice!!",
		"ar": "الآن يمكنك الوصول إلى القائمة فقط بصوتك !!"
	},
	"munacipility_search_label": {
		"en": "Municipality Number",
		"ar": "رقم البلدية"
	},
	"silver": {
		"en": "Silver",
		"ar": "الفضية"
	},
	"Report Name": {
		"en": "Report Name",
		"ar": "اسم التقرير"
	},
	"Home_Registration_Trustee_Proceed": {
		"en": "View list of Registration Trustees",
		"ar": "عرض قائمة أمناء التسجيل العقاري"
	},
	"rt_no_party_info": {
		"en": "No Party has been added yet, please add to proceed.",
		"ar": "لم يتم إضافة أي طرف حتى الآن ، يرجى الإضافة للمتابعة."
	},
	"home_Studies_text_desc": {
		"en": "Comprehensive dashboard for the real estate official indexes providing insights and deep analysis for each market performance index.",
		"ar": "لوحة تحكم شاملة لمؤشرات العقارات الرسمية، توفر رؤى وتحليلات عميقة لأداء كل مؤشر"
	},
	"RealEstateConsultancy": {
		"en": "Real Estate Consultancy",
		"ar": "الاستشارات العقارية"
	},
	"RI-index-type": {
		"en": "Rental Index Type",
		"ar": "نوع المؤشر"
	},
	"summary": {
		"en": "Summary",
		"ar": "ملخص"
	},
	"more-court-cases-count": {
		"en": "Court Cases Count",
		"ar": "عدد دعاوي المحكمة"
	},
	"escrow_dept_approved_auditors": {
		"en": "Escrow Dept Approved Auditors",
		"ar": "مكاتب التدقيق المعتمدة لدى إدارة حسابات الضمان"
	},
	"no_of_buyer": {
		"en": "No. of Buyer",
		"ar": "إجمالي المشترين"
	},
	"form_validate_unit_number": {
		"en": "Please enter a valid unit number",
		"ar": "يرجى إدخال رقم الوحدة صحيح"
	},
	"ejari_services": {
		"en": "Ejari Services",
		"ar": "خدمات إيجاري"
	},
	"unit_size_sq_mt": {
		"en": "Unit Size (Sq.Mt.)",
		"ar": "مساحة الوحدة (متر مربع)"
	},
	"land_geo_land": {
		"en": "Land",
		"ar": "أرض"
	},
	"floor_count": {
		"en": "Floor Count",
		"ar": "عدد الطوابق"
	},
	"rents": {
		"en": "Rents",
		"ar": "الإيجارات"
	},
	"form_validate_issue_date": {
		"ar": "Please enter issue date",
		"en": "Please enter issue date"
	},
	"msg_sent_registrated_email": {
		"en": "Confirmation will be sent to this email address",
		"ar": "سيتم ارسال رسالة تاكيد لبريدك الالكتروني"
	},
	"license_issuer": {
		"en": "License Issuer",
		"ar": "مصدر الرخصة"
	},
	"owner_committee_terms_val_7": {
		"en": "Not to communicate with any service provider except through the Management Company.",
		"ar": "عدم التواصل مع أي مزود الخدمة الا عن طريق جهة الإدارة."
	},
	"home_real_estate_companies": {
		"ar": "الشركات\u003Cbr/\u003E العقارية",
		"en": "Real Estate\u003Cbr /\u003E Companies"
	},
	"service_tag": {
		"en": "Service",
		"ar": "خدمة"
	},
	"sme_member": {
		"en": "SME Member",
		"ar": "عضو مؤسسة محمد بن راشد لدعم المشاريع الصغيرة والمتوسطة"
	},
	"summary_label": {
		"en": "Summary",
		"ar": "الملخص"
	},
	"faq_question_label": {
		"en": "Questions",
		"ar": "الأسئلة"
	},
	"form_validate_please_confirm": {
		"en": "Please confirm",
		"ar": "الرجاء تحديد"
	},
	"home_survey_guide": {
		"en": "Survey \u003Cbr/\u003EGuide",
		"ar": "دليل\u003Cbr/\u003E المساحة"
	},
	"by_passport": {
		"en": "Search by Passport",
		"ar": "رقم جواز السفر"
	},
	"mobile_verification_code": {
		"en": "Mobile verification code",
		"ar": "رمز التحقق المحمول"
	},
	"form_validate_preferred_user_name_required": {
		"ar": "اسم المستخدم مطلوب",
		"en": "User name is required"
	},
	"home_Mail_us_at": {
		"en": "Mail us at",
		"ar": "ارسل لنا بريد عبر"
	},
	"rvs_complain_success": {
		"en": "Your complaint has been submitted successfully.",
		"ar": "تم تقديم شكواك بنجاح."
	},
	"NewOfficeTimingsTxt2": {
		"en": "Office Working Hours",
		"ar": "ساعات عمل المكتب"
	},
	"valid_label": {
		"en": "Looks good!",
		"ar": "تبدو جيدا!"
	},
	"terms_and_conditions": {
		"en": "Terms and Conditions",
		"ar": "الشروط والأحكام"
	},
	"file_no": {
		"en": "File Number",
		"ar": "رقم الملف"
	},
	"auction_noti_msg_lini_2": {
		"en": "https://emart.dubailand.gov.ae/Listings/ListingAuctionDetails.aspx?WAVqnAVPb29lh7UtGXKJ%2fPcWa%2fjFEdk6D5EqH0%2fgaJTLgfRvTUtnTrF%2fHoL8adrF",
		"ar": "https://emart.dubailand.gov.ae/Listings/ListingAuctionDetails.aspx?WAVqnAVPb29lh7UtGXKJ%2fPcWa%2fjFEdk6D5EqH0%2fgaJTLgfRvTUtnTrF%2fHoL8adrF"
	},
	"mun_search_label": {
		"en": "Municipality Number",
		"ar": "رقم البلدية"
	},
	"e_g_contract_number": {
		"en": "e.g. 0120200212345678",
		"ar": "e.g. 0120200212345678"
	},
	"Manual_Cases_Registration": {
		"en": "Manual Cases Registration - Petition Order Request - Sequestration",
		"ar": "التسجيل اليدوي للقضايا - طلب عريضة - مصادرة"
	},
	"complain_description": {
		"en": "Complain Description (Max 2000 characters)",
		"ar": "تفاصيل الشكوى - (2000 حرف كحد أقصى)"
	},
	"records_label": {
		"en": "Records",
		"ar": "البيانات"
	},
	"area_square_meter": {
		"en": "Area (Sq.Mt)",
		"ar": "المساحة (متر مربع)"
	},
	"dubai": {
		"en": "Dubai",
		"ar": "دبي"
	},
	"cert_person_detail": {
		"en": "Owner Participant Number / Name",
		"ar": "رقم/اسم المالك المشارك"
	},
	"Residential_Option": {
		"en": "Residential",
		"ar": "سكني"
	},
	"certificate_type": {
		"en": "Certificate Type",
		"ar": "نوع الشهادة"
	},
	"top_sales": {
		"en": "Top Sales",
		"ar": "أعلى المبيعات"
	},
	"Upload_Copy_of_payment_receipt_Label": {
		"en": "Upload Copy of payment receipt",
		"ar": "إيصالات او إثبات الدفع"
	},
	"Dispute Services": {
		"en": "Dispute Services",
		"ar": "خدمات النزاعات العقارية"
	},
	"next": {
		"en": "Next",
		"ar": "التالي"
	},
	"broker_training_FAQs_Q4": {
		"en": "\u003Cp class=\"fw-bold\"\u003E\n                                    Q. Is there any exam after the training?\n                                \u003C/p\u003E\n                                \u003Cp\u003E\n                                    \u003Cb\u003E A.\u003C/b\u003E No, there is no exam after the training. However, exams are conducted separately for certain categories such as brokers.\n                                \u003C/p\u003E",
		"ar": "\u003Cp class=\"fw-bold\"\u003E\n                                    Q. هل يوجد امتحان بعد التدريب؟\n                                \u003C/p\u003E\n                                \u003Cp\u003E\n                                    \u003Cb\u003E A.\u003C/b\u003E لا، لا يوجد امتحان بعد التدريب. ومع ذلك، يتم إجراء الاختبارات بشكل منفصل لفئات معينة مثل الوسطاء.\n                                \u003C/p\u003E"
	},
	"transaction_sub_type": {
		"en": "Transaction sub type",
		"ar": "النوع الفرعي للمعاملة"
	},
	"DubaiPulse": {
		"en": "Dubai Pulse",
		"ar": "Dubai Pulse"
	},
	"real_estate_id": {
		"en": "Real Estate Id",
		"ar": "معرف العقارات"
	},
	"enter_otp": {
		"en": "Enter OTP Code",
		"ar": "أدخل رمز التحقق"
	},
	"innovation_incubator_signup": {
		"en": "https://rees.dubailand.gov.ae/en-us/Account/Signup",
		"ar": "https://rees.dubailand.gov.ae/ar-ae/Account/Signup"
	},
	"home_rental_dispute_service": {
		"ar": "خدمات \u003Cbr/\u003E المنازعات الإيجارية",
		"en": "Rental Dispute\u003Cbr/\u003E Services"
	},
	"cu_Customer_Service": {
		"en": "Customer Service",
		"ar": "خدمة العملاء"
	},
	"category": {
		"en": "Category",
		"ar": "الفئة"
	},
	"Home_Download_Your_Certificate": {
		"en": "Download Your Certificate",
		"ar": "قم بتنزيل شهادتك"
	},
	"property_size": {
		"en": "Property Size (sq.m)",
		"ar": "مساحة العقار (sq.m)"
	},
	"certificate": {
		"en": "Certificate",
		"ar": "شهادة"
	},
	"NewOfficeTimings": {
		"en": "New Office Timings",
		"ar": "أوقات عمل المكتب الجديدة"
	},
	"Sale tooltip": {
		"en": "Sale Services",
		"ar": "خدمات البيع"
	},
	"property_on_map": {
		"ar": "الملكية على الخريطة",
		"en": "Property on Map"
	},
	"total_services": {
		"en": "Total Services",
		"ar": "إجمالي الخدمات"
	},
	"serivce_charges_information": {
		"en": "Service Charges Information",
		"ar": "معلومات رسوم الخدمة"
	},
	"yearly": {
		"en": "Yearly",
		"ar": "سنوياً"
	},
	"more-submit": {
		"en": "Submit",
		"ar": "أرسل"
	},
	"no_transaction": {
		"en": "No Transactions",
		"ar": "لا توجد معاملات"
	},
	"Dubai Corporation for Ambulance Services": {
		"en": "Dubai Corporation for Ambulance Services",
		"ar": "مؤسسة دبي لخدمات الإسعاف"
	},
	"subject": {
		"en": "Subject",
		"ar": "الموضوع "
	},
	"department_email": {
		"en": "info@dubailand.gov.ae",
		"ar": "info@dubailand.gov.ae"
	},
	"passport_label": {
		"en": "Passport Number",
		"ar": "رقم جواز السفر"
	},
	"under": {
		"en": "under",
		"ar": "تحت"
	},
	"floor_no": {
		"en": "Floor No.",
		"ar": "رقم الطابق"
	},
	"accept_call_for_meeting": {
		"en": "Accept & call for meeting",
		"ar": "الموافقة و طلب اجتماع"
	},
	"dubai_projects_map": {
		"en": "Map of Projects in The Emirates of Dubai",
		"ar": "خريطة المشاريع في إمارة دبي"
	},
	"actual_common_area": {
		"en": "Actual Common Area",
		"ar": "المنطقة المشتركة الفعلية"
	},
	"working_day_one": {
		"en": "1 working day",
		"ar": "1 يوم عمل"
	},
	"banner-emirati-program-title": {
		"en": "Dubai Real Estate Brokers Program",
		"ar": "برنامج دبي للوسيط العقاري"
	},
	"website": {
		"en": "Website",
		"ar": "الموقـع الإلكتروني"
	},
	"chat with us": {
		"en": "Chat with Us",
		"ar": "تواصل معنا"
	},
	"more-investor-count": {
		"en": "Investor Count",
		"ar": "عدد المستثمرين"
	},
	"applicant_email": {
		"en": "Applicant Email",
		"ar": "البريد الإلكتروني"
	},
	"confirm_policy": {
		"en": "I confirm that i have read and approving",
		"ar": "أؤكد أنني قد قرأت وأوافق"
	},
	"sso_app_desc_tasken": {
		"en": "Premium properties residency visa management system",
		"ar": "نظــــام إصدار الإقامة للعقارات الأكثر من مليون درهم"
	},
	"lic_exp_date": {
		"en": "License Expiry Date",
		"ar": "تاريخ انتهاء الرخصة"
	},
	"upload_documents_text": {
		"en": "Upload the required documents that are required for a committee member",
		"ar": "تحميل المستندات المطلوبة لعضوية اللجنة"
	},
	"owner": {
		"en": "Owner",
		"ar": "مالك"
	},
	"leased": {
		"en": "Leased",
		"ar": "مؤجرة"
	},
	"cu_Location_text": {
		"en": "Dubai Land Department, Baniyas Road P.O.Box: Dubai 1166 Makani: 30404 94991 United Arab Emirates",
		"ar": "دائرة الأراضي والأملاك, شارع بنى ياس صندوق بريد: دبي 1166 رقم مكاني: 30404 94991 الأمارات العربية المتحدة"
	},
	"Home_Project_Status_text": {
		"en": "Track the status of the projects in Dubai and view up to date and accurate information about the master developer, sub developer, projects and escrow account information on all buildings under development in the emirate.",
		"ar": "متابعة الحاله لمشاريع دبي و عرض معلومات حديثه و دقيقة للمطور الرئيسي و الفرعي و المشاريع وبيانات حساب الضمان في كل المباني قيد التطوير في الامارة"
	},
	"e_g_email": {
		"ar": "e.g. ahmed.hussain@dummyemail.com",
		"en": "e.g. ahmed.hussain@dummyemail.com"
	},
	"HomeLabel": {
		"en": "Home",
		"ar": "الرئيسية"
	},
	"dld_support_text_title": {
		"en": "Raise a Support Ticket",
		"ar": "تقديم تذكرة دعم"
	},
	"bc_welcome_text": {
		"en": "Welcome to \u003Cbr /\u003E Dubai Land Department",
		"ar": "مرحبا بك في\u003Cbr/\u003E دائرة الأراضي والأملاك في دبي"
	},
	"property_age": {
		"en": "Property Age",
		"ar": "عمر العقار"
	},
	"more-request-no": {
		"en": "Request Number",
		"ar": "رقم الطلب"
	},
	"locate_on_map": {
		"en": "Locate on Map",
		"ar": "تحديد الموقع على الخريطة"
	},
	"indexes_dashboard_title": {
		"en": "Indexes Dashboard",
		"ar": "لوحة المؤشرات"
	},
	"add_service_title": {
		"en": "Additional Services",
		"ar": "خدمات إضافية"
	},
	"valuation_certificate": {
		"en": "Valuation Certificate",
		"ar": "طلب شهادة تثمين"
	},
	"Phone_text": {
		"en": "Phone",
		"ar": "هاتف"
	},
	"valuator_name": {
		"en": "Valuator Name",
		"ar": "إسم المقيم"
	},
	"staff_acc_label": {
		"en": "Staff Accomodation",
		"ar": "سكن الموظفين"
	},
	"gfa": {
		"en": "Gross Floor Area",
		"ar": "المساحة الإجمالية"
	},
	"more-search": {
		"en": "Search",
		"ar": " بحث"
	},
	"Previous Index": {
		"en": "Previous Index",
		"ar": "المؤشر السابق"
	},
	"more-unit-count": {
		"en": "Unit Count",
		"ar": "عدد الوحدات"
	},
	"type": {
		"en": "Type",
		"ar": "النوع"
	},
	"select_company_to_register_complain": {
		"en": "Select Company to register complain",
		"ar": "اختر شركة لتسجيل الشكوى"
	},
	"other_partner_description": {
		"en": "Search for companies, agents and Auditors certified by Dubai Land Department",
		"ar": "البحث عن شركات ووكلاء ومدققين معتمدين من دائرة الأراضي والأملاك في دبي"
	},
	"emirates_id_copy": {
		"en": "Emirates ID copy of the authorized signature",
		"ar": "نسخة من الهوية الإماراتية للتوقيع المعتمد"
	},
	"PropertyTrustee_description": {
		"ar": " ابحث عن مواقع مراكز الأمناء التي تقدم خدمات مثل تسجيل وتجديد عقود إيجاري وتقييم العقارات وما إلى ذلك.",
		"en": "Search for the sites of Trustees Centers providing services like register and renew Ejari contracts, property valuation etc."
	},
	"rt_role_parties_validation": {
		"en": "Please add parties to all Roles.",
		"ar": "يجب اضافة طرف اخر للاجراء."
	},
	"owner_committee_terms_val_13": {
		"en": "Acknowledge that any authority having powers pertaining to national security and safety, RERA or any party appointed by RERA, has all the right to check all the information systems utilized by the Owners Committee or accounting systems or  other documents and systems related to the Committee.",
		"ar": "يجوز للجهات الأمنية وللمؤسسة أو من تعينه لذلك الحق في الاطلاع على كافة نظم لجنة الملاك المعلوماتية أو المحاسبية أو غيرها من المستندات والنظم الخاصة باللجنة."
	},
	"form_validate_year": {
		"en": "Please select a year",
		"ar": " يرجى إختيار السنة"
	},
	"Countdown_to_Expo_2020": {
		"en": "Buy Tickets",
		"ar": "شراء التذاكر"
	},
	"rt_party_share_validation": {
		"en": "The total parties share should be 100%.",
		"ar": "يجب أن تكون حصة الأطراف الإجمالية 100٪."
	},
	"home_api_integration": {
		"en": "API Integration",
		"ar": "ربط API "
	},
	"gold": {
		"en": "Gold",
		"ar": "الذهبية"
	},
	"active_rdc_cases": {
		"en": "Active Rental Disputes Cases ",
		"ar": "الدعاوى الإيجارية المفعلة"
	},
	"cu_Important_Email": {
		"en": "Find the contact details of Head of Departments within Dubai Land Department.",
		"ar": "للعثور على تفاصيل الاتصال الخاصة بمدراء الإدارات في دائرة الأراضي والأملاك في دبي،"
	},
	"under_processing": {
		"en": "Under Processing",
		"ar": "تحت التجهيز"
	},
	"invalid_date_range": {
		"ar": "النطاق الزمني غير صالح",
		"en": "Invalid date range"
	},
	"emirati-program-other": {
		"en": "Other",
		"ar": "أخرى"
	},
	"Rental Services": {
		"en": "Rental Services",
		"ar": "خدمات التأجير العقاري"
	},
	"userid_valid_chars": {
		"en": "Only alphanumeric, '.' and '_' characters are allowed",
		"ar": "الأحرف المسموح بها هي فقط الأبجدية الرقمية ، \".\" و \"_\""
	},
	"more-project-name": {
		"en": "Project Name",
		"ar": "اسم المشروع"
	},
	"selected": {
		"en": "Selected",
		"ar": "مختار"
	},
	"address": {
		"en": "Address",
		"ar": "العنوان"
	},
	"nav_user_guide": {
		"en": "User Guide",
		"ar": "دليل المستخدم"
	},
	"smart_app": {
		"en": "Smart App",
		"ar": "تطبيق ذكي"
	},
	"passport_issue_place_en": {
		"en": "Passport Issue Place (EN)",
		"ar": "مكان اصدار الجواز (بالانجليزية)"
	},
	"Process_Failed": {
		"en": "Process Failed",
		"ar": "Process Failed"
	},
	"home_Raise_a_Complaint_title": {
		"en": "Raise a Complaint...",
		"ar": "...رفع شكوى"
	},
	"property_services": {
		"en": "Property Services",
		"ar": "الخدمات العقارية"
	},
	"rt_specify_procedure_and_rent_value": {
		"en": "Specify the Procedure and Rent Value",
		"ar": "حدد الإجراء وقيمة الإيجار"
	},
	"emirati-program-highest-qualification": {
		"en": "Your Highest Qualification",
		"ar": "أعلى مؤهلاتك العلمية "
	},
	"uae_pass_desc_2": {
		"en": "To avail of the service, users should link their UAE Pass account with this application.",
		"ar": "للاستفادة من الخدمة ، يجب على المستخدمين ربط حساب الهويه الرقمية الخاص بهم بهذا التطبيق."
	},
	"developer_information": {
		"ar": "معلومات المطور",
		"en": "Developer Information"
	},
	"in_aed": {
		"en": "In AED",
		"ar": "درهم"
	},
	"sso_app_desc_ejari": {
		"en": "A complete online solution specifically designed to regulate and facilitate property leasing in Dubai.",
		"ar": "حل متكامل عبر الإنترنت مصمم خصيصًا لتنظيم وتسهيل تأجير العقارات في دبي."
	},
	"Termination": {
		"en": "Termination",
		"ar": "إنهاء"
	},
	"ownership_certificate": {
		"en": "Ownership Certificate",
		"ar": "شهادة الملكية"
	},
	"educational": {
		"en": "Educational",
		"ar": "منشأة تعليمية "
	},
	"E-Services": {
		"en": "E-Services",
		"ar": "الخدمات الالكترونية"
	},
	"Tabu_Request_Inquiry": {
		"en": "Tabu Request Inquiry",
		"ar": "استعلام عن طلب"
	},
	"tax_certificate": {
		"en": "Tax Certificate",
		"ar": "شهادة الضريبة"
	},
	"by_id": {
		"en": "Search by Emirates ID",
		"ar": "باستخدام رقم الهوية الإماراتية"
	},
	"send_survey_to_the_customer": {
		"en": "Send customer satisfaction\u003Cbr /\u003E survey to the user and close the complaint",
		"ar": "إرسال استبيان رضا المتعامل \u003Cbr/\u003Eللمستخدم ومن ثمّ إغلاق الشكوى"
	},
	"no_of_properties": {
		"en": "No of Properties",
		"ar": "عدد العقارات"
	},
	"role_based_label": {
		"en": "Role Based Services",
		"ar": "الخدمات حسب الدور"
	},
	"view_more": {
		"en": "View More",
		"ar": "عرض المزيد"
	},
	"Master Community": {
		"en": "Select",
		"ar": "اختار"
	},
	"residential_rental_price_index": {
		"en": "Residential Rental Performance Index",
		"ar": "مؤشر أداء الإيجارات السكنية"
	},
	"track_complain": {
		"en": "Tracking Complaint",
		"ar": "تابع حالة الشكوى"
	},
	"only_numbers": {
		"en": "only numbers are allowed",
		"ar": "يرجي ادخال ارقام فقط"
	},
	"total_area_sqm": {
		"en": "Total area (Sq.Mt)",
		"ar": "المساحة الكلية (متر مربع)"
	},
	"lets_validate_your_information": {
		"en": "Let's validate your Information",
		"ar": "دعونا نتحقق من صحة المعلومات الخاصة بك"
	},
	"download_report": {
		"en": "Download Report",
		"ar": "تحميل التقرير"
	},
	"fax": {
		"en": "Fax",
		"ar": "فاكس"
	},
	"business_user_reg": {
		"en": "Register as a Business User",
		"ar": "سجل كمستخدم تجاري"
	},
	"accessRentalIndexFromDubaiRestStep4": {
		"en": "\u003Cstrong\u003EStep 4\u003C/strong\u003E\u003Cbr /\u003E\n                                Access Rental Calculator from \"services\" menu",
		"ar": "\u003Cstrong\u003Eالخطوة 4\u003C/strong\u003E\u003Cbr /\u003E\n                               يمكن الدخول لخدمه الحاسبه الايجاريه من القائمه"
	},
	"no_access": {
		"en": "No Access",
		"ar": "ممنوع الدخول"
	},
	"Dubai Integrated Economic zone – DIEZ": {
		"en": "Dubai Integrated Economic zone – DIEZ",
		"ar": "دبي للمناطق الصناعية المتكاملة"
	},
	"name": {
		"en": "Name",
		"ar": "الاسم"
	},
	"subscribe": {
		"en": "Subscribe with Us",
		"ar": "اشترك معنا"
	},
	"Re-Shield-ThankYou": {
		"en": "Thank you!",
		"ar": "شكرًا لك!"
	},
	"LetsContinueOur": {
		"en": "Lets Continue our",
		"ar": "لنكمل رحلة التميز"
	},
	"view_less": {
		"ar": "عرض أقل",
		"en": "View Less"
	},
	"sso_app_desc_drebp": {
		"en": "This service is only for UAE nationals and who do not hold a broker license.",
		"ar": "هذة الخدمة متاحة فقط لمواطنين دولة الامارات وليس لديهم بطاقة وسيط عقارى"
	},
	"rtOfficeTiming": {
		"en": "The official working hours of the Trustees Centers start at 9:00 am until 3:00 pm, from Sunday to Thursday, On Friday from 9:00 am to 12:00 pm.",
		"ar": "الدوام الرسمي لمراكز أمناء يبدأ في الساعة 9:00 صباحاً وحتى 3:00 ظهراً من الأحد الى الخميس\nيوم الجمعة من الساعة 9:00 صباحا وحتى الساعة  12:00 ظهرا"
	},
	"FAQs_link": {
		"en": "FAQs",
		"ar": "الأسئلة الاكثر تكراراً"
	},
	"case_activation_date": {
		"en": "Case Activation Date",
		"ar": "تاريخ تفعيل القضية"
	},
	"arabic_name": {
		"ar": "الاسم (عربي)",
		"en": "Name (Arabic)"
	},
	"rt_party_doc_validation": {
		"en": "Please add all party's documents.",
		"ar": "يرجى إضافة وثائق جميع الأطراف."
	},
	"mortgaged": {
		"ar": "مرهون",
		"en": "Mortgaged"
	},
	"change_eid": {
		"en": "Change Emirates ID",
		"ar": "تغيير الهوية الإماراتية"
	},
	"sso_reg_label": {
		"en": "Step {current} of {total}",
		"ar": "الخطوة {current} من {total}"
	},
	"please_select_sub_service": {
		"en": "Please select sub service",
		"ar": "الرجاء تحديد الخدمة الفرعية"
	},
	"export_as_excel": {
		"en": "Export as Excel",
		"ar": "تصدير إلي إكسيل"
	},
	"duplicate_twimc_error_msg": {
		"en": "This request already exists, if you want to modify the request, Please cancel existing request from \"My Requests\"",
		"ar": "هذا الطلب موجود بالفعل ، إذا كنت ترغب في تعديل الطلب ، يرجى إلغاء الطلب الموجود من \"طلباتي\""
	},
	"no_data_found": {
		"en": "No Data found",
		"ar": "لم يتم العثور على بيانات"
	},
	"emirati-program-bachelors": {
		"en": "Bachelors Degree",
		"ar": "درجة البكالوريوس"
	},
	"map_not_available": {
		"en": "Map not available",
		"ar": "الخريطة غير متوفرة"
	},
	"Land Department": {
		"en": "Land Department",
		"ar": "دائرة الاراضي"
	},
	"Sitemap": {
		"en": "Sitemap",
		"ar": "خريطة الموقع"
	},
	"share_business_card": {
		"en": "Share Business Card",
		"ar": "مشاركة بطاقة العمل"
	},
	"diamond": {
		"en": "Diamond",
		"ar": "الماسية"
	},
	"project": {
		"en": "Project",
		"ar": "مشروع"
	},
	"compl_ref_number_label": {
		"en": "Complaint Reference Number",
		"ar": "رقم الشكوى المرجعى"
	},
	"swimming_pools": {
		"en": "Swimming Pools",
		"ar": "حوض سباحة"
	},
	"flats": {
		"en": "Flats",
		"ar": "الشقق"
	},
	"duplicate_tabu_error_msg": {
		"en": "This request is already exists on this property, if you want to create/modify request on this property, Please cancel existing request from \"MyRequests\"",
		"ar": "هذا الطلب موجود بالفعل على هذا العقار، إذا كنت ترغب في تعديل الطلب، يرجى إلغاء الطلب الحالي من قسم \"طلباتي\""
	},
	"home_Studies_text": {
		"en": "Real Estate Sector Performance",
		"ar": "اداء القطاع العقاري"
	},
	"cheque_amount": {
		"en": "Amount",
		"ar": "القيمة"
	},
	"home_contract_f_URL": {
		"en": "https://dubailand.gov.ae/media/gs3oyzez/contractf2021.pdf",
		"ar": "https://dubailand.gov.ae/media/gs3oyzez/contractf2021.pdf"
	},
	"form_validate_case_number": {
		"en": "Please enter a valid case number",
		"ar": "يرجى إدخال رقم الدعوى صحيح"
	},
	"Development Services": {
		"en": "Development Services",
		"ar": "خدمات التطوير العقاري"
	},
	"Register_your_Interest": {
		"en": "Register",
		"ar": "التسجيل"
	},
	"Re-Shield-Top-Questions": {
		"en": "Top Questions",
		"ar": "الأسئلة الأكثر شيوعا"
	},
	"issuing_map_application_text": {
		"en": "This service allows an owner to apply for a map of the registered property",
		"ar": "تتيح هذه الخدمة للمالك التقدم باصدار خارطة للعقار المسجل"
	},
	"pdf_download": {
		"en": "Download Report",
		"ar": "تحميل التقرير"
	},
	"no_data_found_msg": {
		"en": "We could not find any data based on the information which you had provided.",
		"ar": "لم نتمكن من العثور على أي بيانات بناءً على المعلومات التي قدمتها."
	},
	"Real Estate Price index for 4th quarter": {
		"en": "Real Estate Price index for 4th quarter",
		"ar": "المؤشر لأسعار العقارات للربع الرابع"
	},
	"Expand_all": {
		"en": "Expand All",
		"ar": "عرض الكل"
	},
	"View_Service_Information": {
		"en": "View Service Information",
		"ar": "عرض خدمات المعلومات"
	},
	"supplier_request_confirmation": {
		"en": "\u003Cb\u003ENext Step\u003C/b\u003E\n                        Auditor will now take an action of either accepting or rejecting your request. You will be notified via Email / SMS.",
		"ar": "\u003Cb\u003E الخطوة التالية \u003C/b\u003E\n                         سيقوم المدقق بالتحقق من طلبك وسيتم إعلامك بحالة طلبك عبر البريد الإلكتروني / الرسائل القصيرة."
	},
	"more-selectArea-label": {
		"en": "Please chose the area/s where you would like to invest.",
		"ar": "يرجى اختيار المنطقة/المناطق التي ترغب في الاستثمار فيها."
	},
	"inspection_details": {
		"en": "Inspection Details",
		"ar": "بيانات الفحص"
	},
	"value_added_tax": {
		"ar": "VAT",
		"en": "VAT"
	},
	"award_title": {
		"en": "RERA Award Winner",
		"ar": "الفائز بجائزة وكالة التنظيم العقاري"
	},
	"owner_committee_terms_desc": {
		"en": "Owners Committee members must comply with the following:-",
		"ar": "ويفرض على الأعضاء لجنة ملاك اتباع النقاط التالية:"
	},
	"ApprovedBrokers_title": {
		"en": "Licensed Real Estate Brokers",
		"ar": "الوسطاء العقاريين المرخصين"
	},
	"green_list_tc_1": {
		"en": "Participate in the system in the sense of providing a mobile/telephone number and private e-mail to real estate brokers so that they can communicate with me so they can provide their services, whether with regard to sell or lease property.",
		"ar": "المشاركة في النظام بمعنى توفير رقم هاتفي وبريد الإلكتروني الخاص للوسطاء العقاريين بحيث يمكنهم التواصل معي وتقديم خدماتهم سواءً بالنسبة لبيع العقار أو التأجير."
	},
	"home_about_us_link": {
		"en": "About Us",
		"ar": "عن الدائرة"
	},
	"RegistrationTrustees": {
		"en": "Registration Trustee",
		"ar": "أمين التسجيل العقاري"
	},
	"owner_login_label": {
		"en": "Owner / Tenant / Individual",
		"ar": "كمالك / مستأجر / فرد"
	},
	"procedure_value": {
		"en": "Procedure Value",
		"ar": "قيمه الإجراء"
	},
	"confirm_reg_cancel": {
		"en": "Are you sure you want to cancel registration process ?",
		"ar": "هل أنت متأكد أنك تريد إلغاء عملية التسجيل؟"
	},
	"sso_app_desc_PT": {
		"en": "Ownership Registration Procedures including Ownership Change, Heirs and Cutoff",
		"ar": "إجراءات التسجيل المختلفة للملاك مثل تعديل بيانات ملكية و التوريث و فصل العقارات"
	},
	"instance_date": {
		"en": "Transaction Date",
		"ar": "تاريخ الصفقة"
	},
	"other_partner_title": {
		"en": "Other Partners",
		"ar": "الشركاء الآخرون"
	},
	"Summary_report_Download": {
		"en": "Transactions Summary Report 2015-2019",
		"ar": "تقرير ملخص المعاملات 2015-2019"
	},
	"MANUAL_EXECUTIVE_WRITE_MATURE": {
		"en": "Please visit RDC to request for Execution Writ",
		"ar": "لا يمكنك الحصول على الصيغة التنفيذية إلكترونيا، يرجى مراجعة القسم المختص للحصول على الصيغة التنفيذية وتحميله ضمن الوثائق المطلوبة عند فتح ملف التنفيذ"
	},
	"average_time": {
		"en": "Average Time (in Days)",
		"ar": "متوسط الوقت (بالأيام)"
	},
	"form_validate_license_activities": {
		"en": "Please enter a valid license activities",
		"ar": "يرجى إدخال أنشطة الترخيص صحيح"
	},
	"listing_number": {
		"en": "Listing Number",
		"ar": "رقم الاعلان"
	},
	"we_have_sent_otp_to_your_mobile_email": {
		"en": "Dear customer, we have sent an OTP to your mobile number and email address.",
		"ar": "عزيزي العميل ، لقد أرسلنا رمز التحقق إلى رقم هاتفك المحمول وعنوان بريدك الإلكتروني."
	},
	"form_validate_defendant_type": {
		"en": "Please select the defendant type",
		"ar": "يرجى إختيار صفة المشتكى علية"
	},
	"cu_Customer_Service_text": {
		"en": "Customer Service is available through phone, email and chat from 7:30 am to 4:30 pm (Monday to Friday)\u003C/span\u003E",
		"ar": "خدمة العملاء متاحة عبر الهاتف والبريد الإلكتروني والدردشة من الساعة 7:30 صباحًا حتى 4:30 مساءً (من الاثنين إلى الجمعة)\u003C/span\u003E"
	},
	"more-reason-of-interest": {
		"en": "Reason For Interest",
		"ar": " سبب الاهتمام"
	},
	"emirati-program-personal-details": {
		"en": "Provide your details",
		"ar": "ادخل بياناتك"
	},
	"subscribe_now": {
		"en": "Subscribe Now",
		"ar": "اشترك الان"
	},
	"service_provider": {
		"en": "Service Providers",
		"ar": "مزودي الخدمات"
	},
	"mali_call_defendant_details": {
		"en": "Defendant Details",
		"ar": "بيانات المشتكى عليه"
	},
	"vault_lets_start": {
		"en": "Let’s Start by naming the folder and uploading your documents.",
		"ar": "لنبدأ بتسمية المجلد وتحميل المستندات الخاصة بك."
	},
	"total_sales": {
		"en": "Total Sales",
		"ar": "إجمالي المبيعات"
	},
	"user_role_intro": {
		"en": "We have created separate roles based on your profile to give you a customized and seamless experience",
		"ar": "تم انشاء عدة أدوار منفصلة بناءً على ملفك الشخصي لمنحك تجربة مخصصة وسلسة"
	},
	"save": {
		"en": "Save",
		"ar": "حفظ"
	},
	"registered": {
		"en": "Registered",
		"ar": "سجل"
	},
	"sso_app_desc_rt": {
		"en": "Register procedures, issue initial contracts, and send procedures to DLD for auditing & issuing final certificates.",
		"ar": "تسجيل الإجراءات وإصدار العقود الأولية وإرسال الإجراءات إلى الدائرة للتدقيق وإصدار الشهادات النهائية."
	},
	"Access_this_Service": {
		"en": "Access this Service",
		"ar": "الدخول للخدمة"
	},
	"LicensedRealEstateBrokersOffices": {
		"en": "Licensed Real Estate Brokers Offices",
		"ar": "مكاتب الوساطة العقارية المرخصة"
	},
	"home_Land_Department_Services": {
		"en": "Department Services",
		"ar": "خدمات الادارات"
	},
	"mandatory_label": {
		"en": "Note: All fields marked with asterisk (*) are mandatory",
		"ar": "ملاحظة: جميع الحقول التي تحمل علامة النجمة (*) إلزامية"
	},
	"lets_start_with_basic_validation": {
		"en": "Let's start with the basic information (with validation)",
		"ar": "لنبدأ بالمعلومات الأساسية (مع التحقق)"
	},
	"offline_payment": {
		"en": "Offline Payment",
		"ar": "الدفع التقليدي"
	},
	"home_banner_webinar": {
		"en": "WEBINAR",
		"ar": "ملتقي"
	},
	"awb_number": {
		"en": "AWB Number",
		"ar": "رقم بوليصة الشحن"
	},
	"search keyword": {
		"en": "You searched for :",
		"ar": "لقد قمت بالبحث عن :"
	},
	"complain_status": {
		"en": "Complaint Status",
		"ar": "حالة الشكوى"
	},
	"e_g_dewa_number": {
		"en": "e.g. 12346...",
		"ar": "e.g. 12346..."
	},
	"contact_oqood_and_survey": {
		"en": "04-2030578",
		"ar": "04-2030578"
	},
	"select_file": {
		"en": "Select file",
		"ar": "اختر الملف"
	},
	"leases": {
		"en": "Leases",
		"ar": "العقود"
	},
	"Trakhees": {
		"en": "Trakhees",
		"ar": "تراخيص"
	},
	"budget_year": {
		"en": "Budget Year",
		"ar": "سنة الميزانية"
	},
	"partnershipDLDSEjariTitle": {
		"en": "Printing offices to document leasing contracts (Ejari)",
		"ar": "مكاتب الطباعة لتوثيق عقود الإيجاري"
	},
	"alternate_mobile_number": {
		"en": "Alternate Mobile Number",
		"ar": "رقم الهاتف النقال البديل"
	},
	"auth_good_conduct": {
		"en": "There's no enforcement cases against the authority with the below license number",
		"ar": "لا يوجد اي قضايا ضد الجهة صاحبة الرخصة ادناه"
	},
	"mollak_system_info": {
		"en": "Mollak to regulate jointly owned properties, service charges.",
		"ar": "ملاك لتنظيم الممتلكات ذات الملكية المشتركة ورسوم الخدمات."
	},
	"complaint_submitted_msg": {
		"en": "Your complaint has been successfully submitted",
		"ar": "تم إرسال شكواك بنجاح"
	},
	"to_date": {
		"en": "To Date",
		"ar": "إلى تاريخ"
	},
	"procedure_number": {
		"en": "Procedure Number",
		"ar": "رقم الإجراء"
	},
	"news_photo_label": {
		"en": "Photo Gallery",
		"ar": "معرض الصور"
	},
	"contract_status": {
		"en": "Contract Status",
		"ar": "حالة التعاقد"
	},
	"book_visit_info": {
		"en": "Just submit your contact details and we will be in touch shortly.",
		"ar": "ما عليك سوى إرسال تفاصيل الاتصال بك وسنتواصل معك قريبًا."
	},
	"login_label": {
		"en": "Login",
		"ar": "تسجيل الدخول"
	},
	"good_conduct": {
		"en": "There's no enforcement cases against the person with the below Emirates ID",
		"ar": "لا يوجد قضايا ضد الشخص صاحب الهوية الاماراتية ادناه"
	},
	"Other Requests tooltip": {
		"en": "Other Requests",
		"ar": "خدمات اخرى"
	},
	"Home_Informative_badge": {
		"en": "Informative",
		"ar": "المعلوماتية"
	},
	"accessRentalIndexFromDubaiRestMobileTitle": {
		"en": "DUBAI REST Application",
		"ar": "تطبيق (Dubai REST)"
	},
	"RI-rent-amount-after-increase": {
		"en": "Rent Amount after Increase",
		"ar": "مبلغ الإيجار بعد الزيادة"
	},
	"sso_app_desc_emart": {
		"en": "eMart is an online portal for real estate professionals to list their properties for auction in Dubai.\n",
		"ar": "سوق دبي العقاري الإلكتروني هو بوابة الكترونية لعرض العقارات للبيع من خلال المزادات الإلكترونية في إمارة دبي"
	},
	"please_select": {
		"en": "Please Select",
		"ar": "الرجاء تحديد"
	},
	"files": {
		"en": "Files",
		"ar": "الملفات"
	},
	"Download_Unified_Ejari_Tenancy_Contract_title": {
		"en": "Download Unified Ejari Tenancy Contract",
		"ar": "تحميل عقد إيجار الموحد"
	},
	"one_time_registration_fee_of": {
		"ar": "رسوم التسجيل لمرة واحدة في",
		"en": "One-time registration fee of"
	},
	"privacy_policy": {
		"en": "Privacy Policy",
		"ar": "سياسة الخصوصية"
	},
	"sso_app_desc_dashboard": {
		"en": "View in-depth analysis of the transactions, performance and records from Land Department Systems.",
		"ar": "عرض تحليلي تفصيلي للتعاملات و الاداء بالاضافة لسجلات انظمه دبي للاراضي"
	},
	"registered_date": {
		"en": "Registered date",
		"ar": "تاريخ التسجيل"
	},
	"form_validate_usage": {
		"en": "Please select the usage",
		"ar": " يرجى إختيار الإستخدام"
	},
	"broker_search_not_record": {
		"en": "\u003Cstrong\u003EYour search did not return any result.\u003C/strong\u003E\u003Cbr /\u003E\n                    \u003Cb\u003ESuggestion\u003C/b\u003E: Make sure all words are spelt correctly Try different keyword",
		"ar": "\u003Cstrong\u003Eلم يتم العثور على اى نتيجة للبحث.\u003C/strong\u003E\u003Cbr /\u003E\n                    \u003Cb\u003Eاقتراح\u003C/b\u003E: تأكد من كتابة كل الكلمات بشكل صحيح إملائيًا حاول استخدام كلمات مختلفة"
	},
	"create_account": {
		"en": "Create Account",
		"ar": "إنشاء حساب"
	},
	"complainant_details": {
		"en": "Complainant Details",
		"ar": "بيانات المشتكى"
	},
	"home_good_conduct_certificate_text": {
		"en": "Provides parties with the capability to review the rental case history of the other party within the Rental Disputes Center system prior to drawing lease contract. ",
		"ar": "تمكن الأطراف قبل الشروع في تحرير عقد الإيجار من الاستعلام عن صحيفة الحالة الإيجارية للطرف الآخر في نظام مركز فض المنازعات الإيجارية."
	},
	"Dubai_Land_Department": {
		"en": "Dubai Land Department",
		"ar": "دائرة الأراضي والأملاك بدبي"
	},
	"bannerSurveyLinkText": {
		"en": "Proceed to Survey",
		"ar": "تعبئة  الاستبيان"
	},
	"read_about_this_index": {
		"en": "Read More",
		"ar": "اقرأ المزيد"
	},
	"Property_Auction_title": {
		"en": "Property Auction",
		"ar": "المزاد العقاري"
	},
	"dont_have_account": {
		"en": "Don't have an account?",
		"ar": "ليس لديك حساب؟"
	},
	"certificateExpiryAlert_text": {
		"en": "This Certificate is no longer valid as it exceeds 6 months from the date of valuation",
		"ar": "هذه الشهادة لم تعد صالحة بعد الان حيث ان تاريخ التقييم تخطى 6 أشهر."
	},
	"form_validate_enter_DLD_Reference_Number": {
		"en": "Please enter DLD Reference Number",
		"ar": "الرجاء إدخال الرقم المرجعي لدائرة الأراضي والأملاك"
	},
	"benifits_passcode": {
		"en": "Benefit of Passcode",
		"ar": "فائدة رمز المرور"
	},
	"invalid_account": {
		"en": "Invalid User Name or Password",
		"ar": "اسم المستخدم او كلمة الدخول غير صحيح"
	},
	"Try_Again": {
		"ar": "Try Again",
		"en": "Try Again"
	},
	"number_hash": {
		"en": "#",
		"ar": "#"
	},
	"approved_developers_description": {
		"ar": "تتيح هذه الخدمة للمتعامل الاطلاع على قائمة المطورين العقاريين المرخصين من قبل دائرة الأراضي والأملاك.",
		"en": "This service allows customers to browse the names of all real estate developers licensed by Dubai Land Department"
	},
	"indexes": {
		"en": "Indexes",
		"ar": "المؤشرات"
	},
	"Unit_Number_Label": {
		"en": "Unit Number",
		"ar": "رقم الوحدة"
	},
	"Current Index": {
		"en": "Current Index",
		"ar": "المؤشر الحالي"
	},
	"indexes_dashboard_link": {
		"en": "View indexes dashboard",
		"ar": "عرض لوحة المؤشرات"
	},
	"certificate_year": {
		"en": "Certificate Year",
		"ar": "سنة الشهادة"
	},
	"or_caps": {
		"en": "OR",
		"ar": "أو"
	},
	"crm-error-type": {
		"en": "Error Type",
		"ar": "نوع\nالخطأ"
	},
	"contact_information": {
		"en": "Contact Information",
		"ar": "بيانات التواصل"
	},
	"what_is_passcode": {
		"en": "What is Passcode ?",
		"ar": "ماهو رمز المرور ؟"
	},
	"detailed": {
		"en": "Detailed",
		"ar": "مفصل"
	},
	"more-project-type": {
		"en": "Project Type",
		"ar": "نوع المشروع"
	},
	"update_profile_note": {
		"en": "We will be sending OTP to given mobile number and/or email address for verification.",
		"ar": "سيتم ارسال كود التحقق الى الموبيل /البريد الاليكترونى"
	},
	"home_Project_Status_Enquiry": {
		"en": "Inquiry about a real estate project status",
		"ar": "الإستعلام عن حالة مشروع عقاري"
	},
	"e_g_municipality_number": {
		"ar": "e.g. 123456…",
		"en": "e.g. 123456…"
	},
	"create_new_request": {
		"en": "Create New Request",
		"ar": "إنشاء طلب جديد"
	},
	"dld_links_label": {
		"en": "DLD Links",
		"ar": "روابط دائرة الأراضي والأملاك"
	},
	"home_about_DLD": {
		"en": "About Land Department",
		"ar": "عن دائرة الاراضي والاملاك"
	},
	"proceed_login_signup": {
		"en": "Proceed to Login / Signup",
		"ar": "انتقل إلى تسجيل الدخول / التسجيل"
	},
	"real_estate_number": {
		"en": "Real Estate Number",
		"ar": "رقم العقار"
	},
	"action": {
		"en": "Action",
		"ar": "الإجراء"
	},
	"document_type": {
		"en": "Document Type",
		"ar": "نوع المستند"
	},
	"land_search_label": {
		"en": "Property Number",
		"ar": "رقم العقار"
	},
	"forgot_username_password": {
		"en": "Forgot your Username / Password?",
		"ar": "هل نسيت اسم المستخدم / كلمة المرور؟"
	},
	"service_description": {
		"en": "Description",
		"ar": "الوصف"
	},
	"researches": {
		"en": "Researches",
		"ar": "الابحاث"
	},
	"building_transactions_details": {
		"en": "Building Details",
		"ar": "معاملات المباني"
	},
	"ask_malik": {
		"en": "Ask Malik Virtual Assistant",
		"ar": "اسأل مالك"
	},
	"rt_parties_information": {
		"en": "Parties Information",
		"ar": "معلومات الأطراف"
	},
	"room_type": {
		"en": "Room Type",
		"ar": "نوع الغرفة"
	},
	"more-name-en": {
		"en": "Name (English) *",
		"ar": "الاسم (إنجليزي)*"
	},
	"paid_tabu_req": {
		"en": "This request already exists in the status of \"Paid\". Please wait for Completion, else contact to DLD support.",
		"ar": "هذا الطلب موجود بالفعل، حالة الطلب \"تم الدفع\". يرجى الانتظار حتى الانتهاء من الطلب، أو قم بالاتصال بقسم الدعم الفني في الدائرة."
	},
	"login": {
		"en": "Sign in",
		"ar": "دخول الى النظام"
	},
	"valuer_number": {
		"en": "Valuator Number",
		"ar": "رقم المقيِّم"
	},
	"cheque": {
		"en": "Cheque",
		"ar": "صورة عن الشيك"
	},
	"stage_label": {
		"en": "Stage",
		"ar": "مرحلة"
	},
	"partnershipDLDS_TrusteesCentersDes": {
		"en": "The real estate service trustee centres provide all services of the customer service centre in Dubai Land Department. It also allows customers to obtain the services of the Rental Disputes Center as well as the Ejari system.",
		"ar": "توفّر مراكز أمناء الخدمات العقارية كافة خدمات مركز خدمة المتعاملين في دائرة الأراضي والأملاك، كما تتيح للمتعاملين الحصول على خدمات مركز فض المنازعات الايجارية، وكافة خدمات نظام إيجاري."
	},
	"home_residence_service": {
		"ar": " خدمات الإقامة \u003Cbr\u003E العقارية (تسكين)",
		"en": "Residence Services\u003Cbr\u003E (Taskeen)"
	},
	"form_validate_arabic_name": {
		"en": "Please enter a valid Arabic name",
		"ar": "يرجى إدخال اسم الشركة (عربي) صحيح"
	},
	"english_name": {
		"ar": "الاسم (بالانجليزية)",
		"en": "Name (English)"
	},
	"auction_noti_msg_lini_1": {
		"en": "https://emart.dubailand.gov.ae/Listings/ListingAuctionDetails.aspx?WAVqnAVPb29lh7UtGXKJ%2fATVftHO3F3MtAtcICHz%2bYPPY0%2fSfZvdtJ3Zs%2fpQUsyr",
		"ar": "https://emart.dubailand.gov.ae/Listings/ListingAuctionDetails.aspx?WAVqnAVPb29lh7UtGXKJ%2fATVftHO3F3MtAtcICHz%2bYPPY0%2fSfZvdtJ3Zs%2fpQUsyr"
	},
	"update_your_personal_information_with_ICP_description": {
		"en": "Update your mobile number through Federal Authority For Identity, Citizenship, Customs & Port Security (ICP) portal",
		"ar": " تحديث رقم هاتفك المحمول من خلال بوابة الهيئة الاتحادية للهوية والجمارك و أمن المنافذ"
	},
	"emirati-program-doctorate": {
		"en": "Doctorate",
		"ar": "دكتوراه"
	},
	"e_g_mun_sub_number": {
		"en": "e.g. 123456…",
		"ar": "e.g. 123456…"
	},
	"elevators": {
		"en": "Elevators",
		"ar": "المصاعد"
	},
	"sso_app_desc_vault": {
		"en": "DLD Document Vault aims to digitize the document sharing process. This service enables to download the files based on Vault’s owner reference id",
		"ar": "تهدف الخزينة الرقمية لدائرة الأراضي إلى تخزين المستندات رقميا و تحميلها و مشاركتها عن طريق رقم مرجعي ينشأ من خلال الخزينة"
	},
	"Department of Economic Development": {
		"en": "Department of Economic Development",
		"ar": "دائرة التنمية الاقتصادية"
	},
	"download_complaint": {
		"en": "Download Complaint",
		"ar": "تحميل شكوى"
	},
	"e_g_company_name": {
		"ar": "e.g. xyz company",
		"en": "e.g. xyz company"
	},
	"form_validate_upload_file": {
		"en": "Please upload a file",
		"ar": "يرجى رفع الملف"
	},
	"tenant_type": {
		"en": "Tenant Type",
		"ar": "نوع المستأجر"
	},
	"green_list_participate_terms": {
		"en": "Terms and Conditions for participation in the (Green List)",
		"ar": "الاحكام والشروط الخاصة بالمشاركة في (Green List)"
	},
	"system_access": {
		"en": "System Access",
		"ar": "الدخول إلى النظام"
	},
	"vault_30day_note": {
		"en": "Please note that the files will be kept with us for a period of 30 days. You would be required to upload new documents after that period.",
		"ar": "يرجى ملاحظة أنه سيتم الاحتفاظ بالملفات معنا لمدة 30 يومًا. سيُطلب منك تحميل مستندات جديدة بعد تلك الفترة."
	},
	"form_validate_upload_bank_letter": {
		"en": "Please upload the bank letter",
		"ar": "يرجى رفع خطاب بنكي"
	},
	"dld_rvs_Inquiry_about_contractual_disputes": {
		"en": " Inquiries Concerning Contractual Disputes",
		"ar": "الاستفسار عن الخلافات التعاقدية "
	},
	"EXCELLENCEJOURNEY": {
		"en": "EXCELLENCE JOURNEY",
		"ar": "يسر دائرة الأراضي و الأملاك بدبي التعرف علي  رأيكم في\n أنشطة إدارة الاتصال المؤسسي لعام  2021 من خلال تعبئة\nالاستبيان المرفق أدناه "
	},
	"rental_index_inner_label": {
		"en": "How does\u003Cbr /\u003E\n                        Rental Calculator\u003Cbr /\u003E\n                        work ?",
		"ar": "كيف \u003Cbr /\u003E\n                         حاسبة الإيجار \u003Cbr /\u003E\n                         عمل ؟"
	},
	"rt_what_is_online_registration_for": {
		"en": "What is Online Registration for?",
		"ar": "ما هو التسجيل عبر الإنترنت؟"
	},
	"course_english_language": {
		"ar": "\u003Cspan\u003Eاللغة الإنجليزية\u003C/span\u003E\n\u003Cspan\u003Eالدورة متاحة باللغة الإنجليزيّة \u003C/span\u003E",
		"en": "\u003Cspan\u003EEnglish Language\u003C/span\u003E\n\u003Cspan\u003EThe course is offered in English language\u003C/span\u003E"
	},
	"confirm": {
		"en": "Confirm",
		"ar": "تؤكد"
	},
	"home_knowledge_bank_desc": {
		"en": "Want to pass your broker exam in first attempt?\nWant to stand out from the crowd? \nThen download this valuable resource which contains Q & A’s, real estate concepts, property management, best practices and many more..",
		"ar": "هل تريد اجتياز اختبار الوسيط من المحاولة الأولى؟\nهل تود أن تكون بارزا؟ \nقم بتنزيل هذا المصدر القيّم الذي يحتوي على أسئلة وأجوبة ومفاهيم العقارات وإدارة الممتلكات وأفضل الممارسات وغيرها الكثير .."
	},
	"home_Certification_Courses": {
		"en": "Certification Courses",
		"ar": "شهادات الدورات التدريبة"
	},
	"manzili_webLink": {
		"en": "https://www.manzili.ae/",
		"ar": "https://www.manzili.ae/ar/"
	},
	"completion": {
		"en": "Completion",
		"ar": "نسبة الإنجاز"
	},
	"existing_customers": {
		"en": "Existing Customers",
		"ar": "العملاء الحاليون"
	},
	"Home_Download_Ejari_Certificate": {
		"en": "Download Ejari Certificate",
		"ar": "تحميل شهادة تسجيل عقد ايجار"
	},
	"more-emirates-id": {
		"en": "Emirates ID *",
		"ar": "الهوية الإماراتية*"
	},
	"developer_transactions_details": {
		"en": "Developer Details",
		"ar": "معاملات المطورين العقاريين "
	},
	"title_deed_year": {
		"en": "Title Deed Year",
		"ar": "سنة الشهادة"
	},
	"dev_step_2": {
		"en": "Step 02",
		"ar": "الخطوة 02"
	},
	"rental_error": {
		"en": "Rental index data is not available for this period and will be updated later",
		"ar": "بيانات مؤشر الايجار غير متوفرة لهذه الفترة و سيتم تحديثها لاحقا"
	},
	"to_whom_it_may_concern_title": {
		"en": "To Whom It May Concern",
		"ar": "طلب إصدار شهادة بيان املاك العميل (لمن يهمه الامر)"
	},
	"with_gfa": {
		"en": "with a Gross Floor Area of",
		"ar": "بمساحة أرضية إجمالية تبلغ"
	},
	"rt_registration_success": {
		"en": "Your request has been submitted successfully.",
		"ar": "تم تقديم طلبك بنجاح."
	},
	"land_photo": {
		"ar": "خارطة الارض",
		"en": "Land Photo"
	},
	"Transfer": {
		"en": "Transfer",
		"ar": "تحويل"
	},
	"end_date": {
		"en": "End Date",
		"ar": "تاريخ الانتهاء"
	},
	"Call Us": {
		"en": "Call Us",
		"ar": "اتصل بنا"
	},
	"how_do_i_q1": {
		"en": "We have created a list of “How do I ?” which are the frequently asked questions by different users of the website and mobile app",
		"ar": "لقد أنشأنا قائمة \"كيف يمكنني؟\" وهي الأسئلة المتداولة من قبل مختلف المستخدمين لموقع الويب وتطبيق الجوال"
	},
	"real_estate_name": {
		"en": "Real Estate Name",
		"ar": "اسم العقار"
	},
	"upload_documents": {
		"en": "Upload Documents",
		"ar": "تحميل المستندات"
	},
	"search_for_license_details": {
		"ar": "بحث عن بيانات الرخصة",
		"en": "Search For License details"
	},
	"Transaction Report Archive": {
		"en": "Transaction Report Archive",
		"ar": "ارشيف تقارير المبيعات"
	},
	"home": {
		"en": "Home",
		"ar": "الصفحة الرئيسية"
	},
	"Two_Bedroom_Option": {
		"en": "Two Bedroom Set",
		"ar": "مجموعة غرفتي نوم"
	},
	"total_units": {
		"en": "Total Units",
		"ar": "إجمالي الوحدات"
	},
	"more-area-label": {
		"en": "Please chose the area/s where you would like to invest.",
		"ar": "يرجى اختيار المنطقة/المناطق التي ترغب في الاستثمار فيها."
	},
	"Home_DLD_Our_Partners_Description": {
		"en": "View all the associated partners with Dubai Land Department.",
		"ar": "عرض كل الشركاء المرتبطين بدائرة الأراضي والأملاك"
	},
	"SurveyCompanies_description": {
		"en": "View the list of certified survey companies in Dubai.",
		"ar": "اطلع على قائمة شركات المسح العقاري المعتمدة في إمارة دبي."
	},
	"file_not_selected": {
		"en": "File is empty, please select file",
		"ar": "الملف فارغ ، يرجى تحديد الملف"
	},
	"legal_type": {
		"en": "Legal Type",
		"ar": "الشكل القانوني"
	},
	"dld_systems": {
		"en": "Dubai Land Department Systems",
		"ar": "أنظمة دائرة الأراضي والأملاك"
	},
	"please_enter_your_pass_code": {
		"en": "Please enter your passcode to continue",
		"ar": "الرجاء إدخال رمز المرور الخاص بك للمتابعة"
	},
	"Roads and Transport Authority (RTA)": {
		"en": "Roads and Transport Authority (RTA)",
		"ar": "هيئة الطرق والمواصلات (RTA)"
	},
	"service_fees": {
		"en": "Service Fees",
		"ar": "رسوم الخدمة"
	},
	"complain_category": {
		"en": "Complain Category",
		"ar": "نوع الشكوى"
	},
	"emirati-program-what_are_you_looking_for": {
		"en": "Do you want to:",
		"ar": "هل ترغب"
	},
	"search_for_license_details_description": {
		"ar": "يمكنك البحث عن أي رخصة بإدخال رقم الرخصة أو الاسم التجاري باللغة العربية.",
		"en": "You can search for a company by license number or by English trade name."
	},
	"Dubai Maritime City": {
		"en": "Dubai Maritime City",
		"ar": "مدينة دبي الملاحية"
	},
	"Home_contractF_description": {
		"ar": "اتفاقية البيع من البائع إلى المشتري، التي تتضمن وسيطًا معتمدًا هي الوثيقة الأساسية التي تثبت الملكية، وتمنح حق الملكية بالضبط.",
		"en": "A sale agreement, for the seller to the buyer, involving an approved broker is the primary document that evidences ownership and vesting exact title to the property. "
	},
	"year": {
		"en": "Year",
		"ar": "السنة"
	},
	"comments": {
		"en": "Comments",
		"ar": "تعليقات"
	},
	"freq_used_srvcs": {
		"en": "\u003Cspan class=\"role-owner-title\"\u003E\n                                            Frequently Used\n                                            Services\n                                        \u003C/span\u003E\n                                        \u003Cspan class=\"role-owner-sub-title\"\u003ECant find your Service ?\u003C/span\u003E\n                                        \u003Cspan class=\"role-owner-des\"\u003E\n                                            Drop us an email and we will get back to you\n                                            as soon as possible. Alternatively you can\n                                            call us at 8004488\n                                        \u003C/span\u003E",
		"ar": "\u003Cspan class=\"role-owner-title\"\u003Eالخدمات الاكثر استخداما \u003C/span\u003E\n        \u003Cspan class=\"role-owner-sub-title\"\u003Eألا تجد خدمتك؟ \u003C/span\u003E\n        \u003Cspan class=\"role-owner-des\"\u003Eأرسل لنا بريدًا إلكترونيًا وسنعاود الاتصال بك في أقرب وقت ممكن. بدلا من ذلك يمكنك ذلك اتصل بنا على 8004488\u003C/span\u003E"
	},
	"Download_Templates": {
		"en": "Download Template",
		"ar": "تحميل الوثائق"
	},
	"RI-percentage-increase": {
		"en": "Percentage Increase",
		"ar": "نسبة الزيادة "
	},
	"webpage": {
		"en": "Website",
		"ar": "موقع الكتروني"
	},
	"Sales Price Index": {
		"en": "Residential Sales Price Index",
		"ar": "مؤشر أسعار البيع السكني"
	},
	"service_charge_arrears": {
		"ar": "رسوم الخدمات لا تتضمن المستحقات والرسوم المتأخرة",
		"en": "Service charge does not include arrears"
	},
	"choose_login_type": {
		"en": "Choose your Login Type",
		"ar": "اختر نوع تسجيل الدخول"
	},
	"select_area_details": {
		"en": "Select an area to view details",
		"ar": "حدد المنطقة لعرض التفاصيل"
	},
	"project_status_conditional_activating": {
		"en": "Conditional Activating",
		"ar": "التنشيط الشرطي"
	},
	"view_all_additional": {
		"en": "View All Additional Services",
		"ar": "عرض جميع الخدمات الإضافية"
	},
	"land_type": {
		"en": "Land Type",
		"ar": "نوع الأرض"
	},
	"more-land-count": {
		"en": "Lands Count",
		"ar": "عدد الأراضي"
	},
	"dld_rvs_case_tracking": {
		"en": "Real Estate Complaint Tracking",
		"ar": "تتبع الشكاوى العقارية"
	},
	"emirati-program-job": {
		"en": "Join Real Estate company as Broker",
		"ar": "الانضمام للعمل كوسيط في احدى الشركات القائمة"
	},
	"Important Links": {
		"en": "Important Links",
		"ar": "روابط مهمة"
	},
	"about_us_label": {
		"en": "About Us",
		"ar": "عن دائرة الاراضي والاملاك"
	},
	"get_started": {
		"en": "Get Started",
		"ar": "ابدأ"
	},
	"cheque_number": {
		"en": "Cheque number",
		"ar": "رقم الشيك"
	},
	"dsr_system_info": {
		"en": "System for Developer self-registration",
		"ar": "نظام للتسجيل الذاتي للمطور"
	},
	"parking": {
		"en": "Parking",
		"ar": "موقف سيارات"
	},
	"news_elec_gallery": {
		"en": "Electronic Publications",
		"ar": "الإصدارات الإلكترونية"
	},
	"nationality_en": {
		"en": "Nationality (English)",
		"ar": "الجنسية (بالأنجليزية)"
	},
	"show_areas": {
		"en": "Show Areas",
		"ar": "عرض المواقع"
	},
	"title_deed_initial_sale_contract": {
		"en": "Last Certificate",
		"ar": "أخر شهادة"
	},
	"training_not_required": {
		"en": "Training not required",
		"ar": "التدريب غير مطلوب"
	},
	"error_label": {
		"en": "Error",
		"ar": "خطاء"
	},
	"activity_desc": {
		"en": "Description",
		"ar": "الوصف"
	},
	"required_documents": {
		"en": "Required Documents",
		"ar": "الملفات المطلوبة"
	},
	"edit_property_details": {
		"en": "Edit Property Details",
		"ar": "تعديل تفاصيل العقار"
	},
	"home_jointly_owned_property_service": {
		"en": "Jointly Owned\u003Cbr/\u003E Property Services",
		"ar": "خدمات العقارات \u003Cbr/\u003E ذات الملكية المشتركة"
	},
	"file_size_less_then_2mb": {
		"en": "Allowed file types - jpg, png, xlsx, docx or pdf.\u003Cbr/\u003E\nYou can upload a maximum of three files, with a combined size not exceeding 6 MB.",
		"ar": "أنواع الملفات المسموح بها - jpg، png، xlsx، docx أو pdf.\u003Cbr/\u003E\nيمكنك تحميل ثلاثة ملفات كحد أقصى، بحجم لا يتجاوز 6 ميغابايت."
	},
	"validate_property": {
		"en": "Validate Property",
		"ar": "التحقق من صحة الممتلكات"
	},
	"ApprovedBrokers_description": {
		"ar": "تتيح هذه الخدمة للمتعامل الاطلاع على قائمة الوسطاء العقاريين المرخصين من قبل مؤسسة التنظيم العقاري في إمارة دبي.",
		"en": "This service allows customers to search for real estate brokers licensed by the Real Estate Regulatory Agency in Dubai."
	},
	"update": {
		"en": "Update",
		"ar": "تحديث"
	},
	"minimum_userid_length": {
		"en": "Minimum 4 character and a maximum of 30 characters are allowed",
		"ar": "يُسمح بـ 4 أحرف كحد أدنى و 30 حرفًا كحد أقصى"
	},
	"add_completed_project": {
		"en": "Add Completed Project",
		"ar": "إضافة مشروع مكتمل"
	},
	"step": {
		"en": "Step",
		"ar": "خطوة"
	},
	"land_details_transactions": {
		"en": "Land Details",
		"ar": "معاملات الأراضي"
	},
	"partnershipIPODescription": {
		"en": "This category includes international organizations as the primary objective is to represent the real estate system's of the Government of Dubai on an international level through partnerships and memberships. Also to exchange knowledge and experience with global best practices.",
		"ar": "تشمل هذه الفئة المنظمات الدولية و الهدف الأساسي من هذه الشراكات تمثيل المنظومة العقارية لحكومة دبي على المستوى الدولي من خلال الشراكات وعضويات الدائرة في المنظمات الدولية وضمان تبادل ونقل المعارف والخبرات مع أفضل الممارسات العالمية"
	},
	"add": {
		"en": "Add",
		"ar": "إضافة"
	},
	"Whats_New": {
		"ar": "ما هو الجديد ",
		"en": "Whats New"
	},
	"granted": {
		"en": "Granted",
		"ar": "منحت"
	},
	"change_password": {
		"en": "Change Password",
		"ar": "تغيير كلمة المرور"
	},
	"real_estate_ad_complain_result": {
		"en": "Thank you for reporting the violation on the real estate ad, the report will be forwarded to the desired department to take further action. ",
		"ar": "متعاملنا العزيز نشكرك على تقديم البلاغ بخصوص الإعلان العقاري والقسم المعني سوف يقوم بالتحقق من صحة البلاغ واتخاذ الإجراءات المتبعة"
	},
	"home_DLD_Document_Vault": {
		"en": "DLD \u003Cbr/\u003EDocument Vault",
		"ar": "مستودع مستندات\u003Cbr/\u003E دائرة الأراضي و الأملاك"
	},
	"feedback": {
		"en": "Feedback",
		"ar": "الآراء"
	},
	"more-project-value": {
		"en": "Project Value",
		"ar": "قيمة المشروع"
	},
	"plot_number": {
		"en": "Plot Number",
		"ar": "رقم الأرض"
	},
	"Home_Title_Deed_Verification_Proceed": {
		"en": "Proceed to Title Deed Verification",
		"ar": "انتقل إلى التحقق من شهادة الملكية"
	},
	"non_contractual_complaint_confirm": {
		"en": "Confirm- non-contractual complaint",
		"ar": "تاكيد  -   (شكوى غير تعاقدية)"
	},
	"vault_folders": {
		"en": "Vault Folders",
		"ar": "مجلدات الخزينة الرقمية"
	},
	"dash_ejari_properties_desc": {
		"en": "Property/ies that is/are owned by a lessor or landlord and rented to a lessee or tenant who receives rights of use and possession in accordance with the terms of a lease agreement.",
		"ar": "المكلية المملوكة لمؤجر او لصاحب المكان و تم تأجيرها لمستأجريملك حقوق الاستخدام و الاستحواذ بموجب عقد الايجار."
	},
	"open_chat": {
		"en": "Live Chat",
		"ar": "الدردشة المباشرة"
	},
	"platinum": {
		"en": "Platinum",
		"ar": "البلاتينية"
	},
	"vaultVideo": {
		"en": "https://www.youtube.com/watch?v=Kcy_tdqzTWU",
		"ar": "https://www.youtube.com/watch?v=uy8JwWfO9dk"
	},
	"dev_book_video": {
		"en": "https://www.youtube.com/embed/rltb19NuPhg",
		"ar": "https://www.youtube.com/embed/Y3k40Wytxao"
	},
	"open": {
		"en": "open",
		"ar": "افتح"
	},
	"Master Developers": {
		"en": "Master Developers",
		"ar": "المطورين الرئيسيين"
	},
	"webinar_registration_exists_msg": {
		"en": "You have already registered for this event",
		"ar": "لقد تم تسجيلك مسبقا للحدث"
	},
	"search": {
		"en": "Search",
		"ar": "بحث"
	},
	"confirm_cancel_procedure": {
		"en": "Are you sure you want to cancel this request?",
		"ar": "هل أنت متأكد من أنك تريد إلغاء هذا الطلب؟"
	},
	"request_to_add": {
		"en": "Request to Add",
		"ar": "طلب إضافة"
	},
	"vault_verification": {
		"en": "Vault Verification",
		"ar": "لتحقق من الخزينة الرقمية"
	},
	"please_select_error_type": {
		"en": "Please select error type",
		"ar": "الرجاء تحديد نوع الخطأ"
	},
	"passport_expiry": {
		"en": "Passport Expiry Date",
		"ar": "تاريخ انتهاء الجواز"
	},
	"list_view": {
		"en": "List",
		"ar": "القائمة"
	},
	"introStep3": {
		"en": "\u003Ch5 class='font-weight-bold'\u003EPrimary Navigation and Role Based Services\u003C/h5\u003E\u003Cp\u003EYou will have consistent access to our menu which includes DLD Services, Open Data and Media Centre. All DLD Services are structured based on your Role.\u003C/p\u003E",
		"ar": "\u003Ch5 class='font-weight-bold'\u003Eالقائمه الرئيسة و الخدمات\u003C/h5\u003E\u003Cp\u003Eستحظى بالقائمه التي تحتوي على خدمات هيئه دبي للاراضي, المركز الاعلامي , جميع خجمات الهئية مقدمه على حسب دورك\u003C/p\u003E"
	},
	"modal_reference_free_nonfree_hold": {
		"en": "\u003Cdiv\u003E\u003Cb\u003EReference:\u003C/b\u003E \u003Ca href=\"https://dubailand.gov.ae/media/3ighwsbj/legislation.pdf\" class=\"underline\"\u003EArticle (3), Regulation No. (3) of 2006\u003C/a\u003E\u003C/div\u003E",
		"ar": "\u003Cdiv\u003E\u003Cb\u003Eالمرجع:\u003C/b\u003E \u003Ca href=\"https://dubailand.gov.ae/media/5uxfzmzk/arb_legislation.pdf\" class=\"underline\"\u003Eالمادة (3) من اللائحة رقم (3) لسنة 2006\u003C/a\u003E\u003C/div\u003E"
	},
	"broker_training_FAQs_Q8": {
		"en": "\u003Cp class=\"fw-bold\"\u003E\n                                    Q. What are the documents to be submitted for Oqood Individual training?\n                                \u003C/p\u003E\n                                \u003Cp class=\"mb-0\"\u003E\n                                    \u003Cb\u003E A.\u003C/b\u003E Required documents for Oqood Individual training:\n                                \u003C/p\u003E",
		"ar": "\u003Cp class=\"fw-bold\"\u003E\n                                    Q. ما هي المستندات التي يجب تقديمها لتدريب عقد الفردي؟\n                                \u003C/p\u003E\n                                \u003Cp class=\"mb-0\"\u003E\n                                    \u003Cb\u003E A.\u003C/b\u003E المستندات المطلوبة لتدريب عقود الفردي:\n                                \u003C/p\u003E"
	},
	"JOP_approved_auditors": {
		"ar": "مدققي العقارات ذات الملكية المشتركة",
		"en": "JOP Approved Auditors"
	},
	"export_label": {
		"en": "Export",
		"ar": "تصدير"
	},
	"employee-Name": {
		"en": "Emp. Name",
		"ar": "اسم الموظف "
	},
	"form_validate_trade_license_expiry_date": {
		"en": "Please enter a valid trade license expiry date",
		"ar": "يرجى إدخال تاريخ انتهاء الرخصة التجارية صحيح"
	},
	"banner-btc-link-text": {
		"en": "View All Courses and Exams",
		"ar": "عرض جميع الدورات والامتحانات"
	},
	"more-selected": {
		"en": "Selected",
		"ar": "تم التحديد"
	},
	"Search_title_offices": {
		"en": "Offices",
		"ar": "مكاتب الوساطة العقارية"
	},
	"owner_committee_terms_val_9": {
		"en": "All Owners Committee members must comply with the laws and regulations of the Emirate of Dubai and the United Arab Emirates.",
		"ar": "على أعضاء لجنة الملاك الالتزام بالقوانين والنظم المعمول بها في إمارة دبي ودولة الإمارات العربية المتحدة."
	},
	"comp_desc": {
		"en": "Complaint Description",
		"ar": "وصف الشكوى"
	},
	"we_are_here_to_help_you": {
		"en": "We are here to help you",
		"ar": "نحن هنا لمساعدتك"
	},
	"broker_training_FAQs_Q5": {
		"ar": "\u003Cp class=\"fw-bold\"\u003E\n                                    Q. كيف أقوم بالدفع مقابل التدريب؟ \n                                \u003C/p\u003E\n                                \u003Cp\u003E\n                                    \u003Cb\u003E A.\u003C/b\u003E يمكن السداد عبر الإنترنت من خلال بوابة الدفع نقودي باستخدام محفظة نقودي أو عن طريق بطاقة الائتمان / الخصم.\n                                \u003C/p\u003E",
		"en": "\u003Cp class=\"fw-bold\"\u003E\n                                    Q. How do I pay for the training?\n                                \u003C/p\u003E\n                                \u003Cp\u003E\n                                    \u003Cb\u003E A.\u003C/b\u003E Payment can be made online via noqodi payment gateway with Noqodi wallet or by credit/debit card.\n                                \u003C/p\u003E"
	},
	"add_new_request": {
		"en": "Add New Request",
		"ar": "إضافة طلب جديد"
	},
	"resend_otp": {
		"en": "Resend OTP",
		"ar": "إعادة الإرسال"
	},
	"more-request-success-detail-msg": {
		"en": "Your request has been submitted successfully.",
		"ar": "لقد تم تقديم طلبك بنجاح."
	},
	"BarCodeNumber": {
		"en": "Tracking Number",
		"ar": "رقم المتابعة"
	},
	"emarati_call_support": {
		"ar": "للاستفسارات يرجى التواصل مع مركز الاتصال لدبي الرقمية ",
		"en": "For more information, contact our call center on"
	},
	"personal-details": {
		"en": "Personal Details",
		"ar": "البيانات الشخصية "
	},
	"view_property_laws": {
		"en": "Check the Laws",
		"ar": "عرض جميع قوانين الملكية"
	},
	"sale_sequence": {
		"en": "Sale Sequence",
		"ar": "عدد المرات"
	},
	"voucher_number": {
		"en": "Voucher No.",
		"ar": "رقم الإيصال"
	},
	"invalid_license_format": {
		"en": "License number format is not valid. Please enter as Transaction number/Year i.e. 11/2020",
		"ar": "رقم الرخصة غير صحيح. من فضلك ادخل رقم العملية/سنة مثال: 11/2020"
	},
	"transaction_processing": {
		"en": "We are processing your request, do not close or refresh this page.\nThis process may take 90 seconds, please wait.",
		"ar": "نقوم بمعالجة طلبك، لا تغلق هذه الصفحة أو تحدثها.\nقد تستغرق هذه العملية 90 ثانية، الرجاء الانتظار."
	},
	"average_fees": {
		"en": "Average Fees",
		"ar": "متوسط الرسوم"
	},
	"eid_expire_date": {
		"en": "Emirates ID Expiry Date",
		"ar": "تاريخ انتهاء بطاقة هوية الإمارات"
	},
	"contact_trakheesi": {
		"en": "04-2030778",
		"ar": "04-2030778"
	},
	"Gift": {
		"en": "Gift",
		"ar": "المنح"
	},
	"home_Studies_description": {
		"en": "Dubai Land Department (DLD), in cooperation with Property Finder, launched the fifth edition of Mo’asher, Dubai’s official sales-price index.",
		"ar": "دائرة الأراضي والأملاك في دبي، بالتعاون مع \"بروبرتي فايندر\"، الإصدار الخامس من المؤشر الرسمي لأسعار المبيعات في دبي."
	},
	"Re-Shield-Answer-Helpful": {
		"en": "Was this answer helpful?",
		"ar": "هل كانت هذه الإجابة مفيدة؟"
	},
	"Home_Land_Status_Description": {
		"en": "This service allows customers to inquire about the real land condition by entering the real land information, such as land number, or area number",
		"ar": "تتيح هذه الخدمة للمتعامل الاستعلام عن حالة الأرض من خلال ادخال بيانات تخص الأرض مثل المنطقة, ورقم الأرض."
	},
	"home_Connect_with_Us_text": {
		"en": "You can now reach us anytime to provide your feedback, ask questions and get your queries solved.",
		"ar": "يمكنك دائما التواصل معنا لتقديم رأيك او لعرض الاسئلة"
	},
	"insurance_value": {
		"en": "Insurance Value",
		"ar": "قيمة التأمين"
	},
	"unit_number": {
		"en": "Unit Number",
		"ar": "رقم الوحدة"
	},
	"rental_amount_to": {
		"en": "Rental Amount To",
		"ar": "مبلغ الإيجار إلى"
	},
	"annual_reports": {
		"en": "Annual Report",
		"ar": "التقرير السنوي"
	},
	"company_profile": {
		"en": "Company profile and previous work",
		"ar": "الملف  التعريفي للشركة وأعمالها السابقة"
	},
	"resend": {
		"en": "Resend",
		"ar": "إعادة إرسال"
	},
	"choose_your_role": {
		"en": "Choose your Role",
		"ar": "اختر دورك"
	},
	"type_here": {
		"en": "Type here",
		"ar": "اكتب هنا"
	},
	"submitted_successfully": {
		"en": "Submitted Successfully",
		"ar": "Submitted Successfully"
	},
	"broker_offices": {
		"en": "Broker Offices",
		"ar": "مكاتب الوساطة"
	},
	"accessRentalIndexFromDubaiRestStep3": {
		"en": "\u003Cstrong\u003EStep 3\u003C/strong\u003E\u003Cbr /\u003E\n                                Download the App from the opened screen",
		"ar": "\u003Cstrong\u003Eالخطوة 3\u003C/strong\u003E\u003Cbr /\u003E\n                                قم بتنزيل التطبيق من الشاشة المفتوحة"
	},
	"home_good_conduct_certificate": {
		"ar": "صحيفة الحالة الايجارية",
		"en": "Rental status sheet"
	},
	"partnershipDLDS_TrusteesCenters": {
		"en": "Real Estate Service Trustees Centers",
		"ar": "مراكز أمناء الخدمات العقارية"
	},
	"user_login": {
		"en": "Login",
		"ar": "تسجيل دخول"
	},
	"serial_number": {
		"en": "S.No.",
		"ar": "الرقم التسلسلي"
	},
	"license_start_date": {
		"en": "License Start Date",
		"ar": "تاريخ بدء الترخيص"
	},
	"Search_title_broker": {
		"en": "Brokers",
		"ar": "الوسطاء"
	},
	"banner-effective-date": {
		"en": "Effective April 29th, 2024",
		"ar": "اعتبارًا من 29 أبريل 2024"
	},
	"rvs-note": {
		"en": "Note: The expected time to respond to the complaint is 5 working days, and transactions that have legal obstacles are excluded from completing them on time.",
		"ar": "ملاحظة: الوقت المتوقع للرد على الشكوى 5 أيام عمل وتستثنى المعاملات التي فيها معوقات قانونية من إنجازها في الوقت المحدد. "
	},
	"Three_Bedroom_Option": {
		"en": "Three Bedroom Set",
		"ar": "مجموعة ثلاثة غرف نوم"
	},
	"accessRentalIndexFromDubaiRestMobileMSG": {
		"en": "Download Dubai REST Application from Play store / App Store to access the Rental Calculator",
		"ar": "قم بتنزيل تطبيق دبي ريست على الأجهزة الذكية من متاجر (Google Play / App Store)"
	},
	"Managed_By": {
		"en": "Managed By",
		"ar": "تدار من قبل"
	},
	"book_visit": {
		"en": "Book a Visit",
		"ar": "حـجـز  زيـارة"
	},
	"CollectedAmount": {
		"en": "Collected Amount",
		"ar": "المبلغ المجموع"
	},
	"mobile_number": {
		"en": "Mobile Number",
		"ar": "رقم الهاتف المتحرك"
	},
	"val_rental_amount_from_to": {
		"en": "Rental Amount From must be less than Rental Amount To",
		"ar": "Rental Amount From must be less than Rental Amount To"
	},
	"home_dubai_rest": {
		"en": "Dubai REST\u003Cbr/\u003EApplication",
		"ar": "تطبيق Dubai REST"
	},
	"Remove_from_Favorites": {
		"en": "Remove from Favorites",
		"ar": "إزالة من المفضلة"
	},
	"sso_profile_update_tc_3": {
		"en": "Updated phone and email is solely owned by you and OTP will be sent to verify the same.",
		"ar": "بيانات الهاتف و البريد الالكتروني المحدثة هي ملكيه فرديه لك ويتم التحقق عن طريق رمز المرور المرسل لك."
	},
	"Lease_Brokers_Option": {
		"en": "Lease Brokers",
		"ar": "وسطاء التأجير"
	},
	"accounts_linked_with_profile": {
		"en": "Following are the accounts which are linked to your Dubai Land Department Profile",
		"ar": "فيما يلي الحسابات المرتبطة بملفك الشخصي في دائرة الأراضي والأملاك في دبي"
	},
	"request_submitted_successfully": {
		"en": "Your request has been submitted successfully.",
		"ar": "تم تقديم طلبك بنجاح."
	},
	"valuation_transactions_details": {
		"en": "Valuation Transaction Details",
		"ar": "تفاصيل التقييم العقاري"
	},
	"Adjustment": {
		"en": "Adjustment",
		"ar": "تعديل"
	},
	"RDC_Publication": {
		"en": "Rental Disputes Center",
		"ar": "مركز فض المنازعات الإيجارية"
	},
	"success_subscribed": {
		"en": "Successfully Subscribed",
		"ar": "تم الاشتراك بنجاح"
	},
	"technical_support_desc": {
		"en": "For any technical support, kindly contact the given numbers respectively.",
		"ar": "لحصول على أي دعم تقني يرجى الاتصال بالأرقام المذكورة على التوالي."
	},
	"records": {
		"en": "Record/s",
		"ar": "السجلات"
	},
	"subscription_commitment": {
		"ar": "الالتزام بالاشتراك",
		"en": "Subscription Commitment"
	},
	"open_happiness_meter": {
		"en": "Open Happiness Meter",
		"ar": "فتح مؤشر السعادة"
	},
	"form_validate_upload_powerof_attorney": {
		"en": "Please upload the power of attorney ",
		"ar": "يرجى رفع توكيل مفوض بالتوقيع عن الشركة"
	},
	"sale_transactions_text": {
		"en": "Sale Transactions",
		"ar": "بيع المعاملات"
	},
	"download_title_deed": {
		"en": "Download Title Deed",
		"ar": "تحميل شهادة الملكية"
	},
	"not_available": {
		"en": "Not Available",
		"ar": "غير متوفر"
	},
	"form_validate_enter_company_name": {
		"en": "Please enter company name.",
		"ar": "يرجى إدخال اسم الشركة"
	},
	"owned_properties": {
		"en": "Owned Properties",
		"ar": "العقارات المملوكة"
	},
	"clear_btn": {
		"en": "Clear",
		"ar": "إعادة تعيين"
	},
	"quarterly": {
		"en": "Quarterly",
		"ar": "كل ثلاثة شهور"
	},
	"mobile_placeholder": {
		"en": "eg: +971 XX  XX XX XXX",
		"ar": "مثال: +971 XX XX XX XXX"
	},
	"request_details": {
		"en": "Request Details",
		"ar": "تفاصيل الطلب"
	},
	"home_innovation_incubator_desc_v1": {
		"en": "Where Incubator Accelerator meets Artificial Intelligence",
		"ar": "حيث تلتقي مسرعات الابتكار مع الذكاء الاصطناعي"
	},
	"important_emails": {
		"en": "Important Emails",
		"ar": "ايميلات مهمة"
	},
	"for_all_services": {
		"en": "For all Services",
		"ar": "لجميع الخدمات"
	},
	"Registered_in_Dubai_Land_Department": {
		"en": "Registered in Dubai Land Department",
		"ar": "مدرج في سجلات دائرة الأراضي و الأملاك"
	},
	"news_vid_gallery": {
		"en": "Video Gallery",
		"ar": "معرض الفيديو"
	},
	"land_select_on_map": {
		"en": "Select on Map",
		"ar": "اختر من الخريطة"
	},
	"m_square": {
		"en": "Square meter",
		"ar": "متر مربع"
	},
	"Instagram": {
		"en": "Instagram",
		"ar": "الإنستجرام"
	},
	"complaints_handling_process_steps2_title": {
		"en": "Complaint Administrator will receive the request and transfer it to the Sector Co-ordinator",
		"ar": "يقوم المسؤول عن الشكاوى باستلام الطلب ومن ثمّ إحالته إلى الشخص المعني حسب القطاع"
	},
	"register_to_download": {
		"en": "Register to download",
		"ar": "سجل للتحميل"
	},
	"vault_login_description": {
		"en": "Please enter your personal details which will be used for communication.",
		"ar": "الرجاء إدخال بياناتك الشخصية التي سيتم استخدامها للتواصل."
	},
	"if_issue_with_login": {
		"en": "If you have an issue with Login or Registration then contact us",
		"ar": "إذا كانت لديك مشكلة في تسجيل الدخول أو التسجيل يرجى التواصل معنا"
	},
	"more-property-type": {
		"en": "Property Type",
		"ar": "نوع العقار"
	},
	"total_amount": {
		"en": "Total Amount",
		"ar": "المبلغ الإجمالي"
	},
	"Dubai Silicon Oasis Authority": {
		"en": "Dubai Integrated Economic zone – DIEZ",
		"ar": "دبي للمناطق الصناعية المتكاملة"
	},
	"no_records_found": {
		"en": "No Records Found",
		"ar": "لم يتم العثور على نتائج"
	},
	"swimming_pool": {
		"en": "Swimming Pool",
		"ar": "حمام السباحة"
	},
	"broker_training_FAQs_Q7": {
		"en": "\u003Cp class=\"fw-bold\"\u003E\n                                    Q. What are the documents to be submitted for Oqood Master and Individual training?\n                                \u003C/p\u003E\n                                \u003Cp class=\"mb-0\"\u003E\n                                    \u003Cb\u003E A.\u003C/b\u003E Required documents for Oqood Master and Individual training:\n                                \u003C/p\u003E",
		"ar": "\u003Cp class=\"fw-bold\"\u003E\n                                    Q. ما هي المستندات التي يجب تقديمها لتدريب تدريب عقود الرئيسي و الفردي؟\n                                \u003C/p\u003E\n                                \u003Cp class=\"mb-0\"\u003E\n                                    \u003Cb\u003E A.\u003C/b\u003E المستندات المطلوبة لتدريب عقود الرئيسي و الفردي:\n                                \u003C/p\u003E"
	},
	"list": {
		"en": "List",
		"ar": "قائمة"
	},
	"no_favourites_msg": {
		"en": "To add Services to your favorites list, proceed to All Services and click on Star icon next to the Service Name.",
		"ar": "لإضافة خدمات إلى قائمة مفضلاتك ، انتقل إلى جميع الخدمات وانقر على أيقونة نجمة بجوار اسم الخدمة."
	},
	"emirati-program-upload-documents": {
		"en": "Upload your Documents",
		"ar": "قم بتحميل المستندات الخاصة بك"
	},
	"procedure_number_tabu": {
		"en": "Procedure Number",
		"ar": "رقم الاجراء"
	},
	"Download_Unified_Ejari_Tenancy_Contract_description": {
		"ar": "قم بتنزيل نموذج عقد إيجاري الموحد. بمجرد موافقتك على استئجار عقار في دبي، من الضروري تسجيل العقد مع إيجاري.",
		"en": "Download Unified Ejari Tenancy Contract template. Once you agree the rental of a property in Dubai it is mandatory to register the contract with Ejari."
	},
	"technical_problems_in_the_systems_only": {
		"en": "Please call the below numbers only if you are facing any technical problems while using the system.",
		"ar": "برجاء الاتصال على الأرقام أدناه فقط في حالة مواجهة أي مشاكل تقنية أثناء استخدام النظام."
	},
	"form_required_label": {
		"en": "You cannot leave this field blank",
		"ar": "لا يمكنك ترك هذا الحقل فارغًا"
	},
	"moasher_monthly": {
		"en": "M",
		"ar": "M"
	},
	"company_name_arabic": {
		"en": "Company Name Arabic",
		"ar": "اسم الرخصة عربى"
	},
	"View_All_News": {
		"en": "View All News",
		"ar": "عرض كل الأخبار"
	},
	"Home_Rules_and_Regulations_Description": {
		"en": "You can view / download all the Rules, Regulations and License Circulars related to Dubai Land Department",
		"ar": "يمكنك عرض / تنزيل جميع القواعد واللوائح ومنشورات التراخيص المتعلقة بدائرة الأراضي والأملاك في دبي"
	},
	"sso_access": {
		"en": "Access all Land Department websites with a Single Sign-on",
		"ar": "قم بالوصول إلى جميع أنظمة دائرة الأراضي باستخدام تسجيل الدخول الموحد"
	},
	"delete_file": {
		"en": "Delete File",
		"ar": "حذف ملف"
	},
	"customer_feedback": {
		"en": "Customer Feedback",
		"ar": "رأي المستخدم"
	},
	"projects": {
		"en": "Projects",
		"ar": "المشاريع"
	},
	"home_development_service": {
		"ar": "خدمات \u003Cbr/\u003E التطوير العقاري",
		"en": "Development\u003Cbr/\u003E Services"
	},
	"action-being-taken": {
		"en": "Action Being Taken",
		"ar": "تم اتخاذ الاجراء"
	},
	"emirati-program-higher-education": {
		"en": "Higher Education",
		"ar": "التعليم العالى"
	},
	"confirm_payment": {
		"en": "Confirm Payment",
		"ar": "تأكيد الدفع"
	},
	"Happiness_label": {
		"en": "Happiness",
		"ar": "السعادة"
	},
	"rt_exit_confirmation": {
		"en": "Are you sure you want to exit from this transaction?",
		"ar": "هل أنت متأكد أنك تريد الخروج من هذه المعاملة؟"
	},
	"form_validate_from_date": {
		"en": "Please enter the valid From Date",
		"ar": "يرجى إدخال تاريخ بداية صحيح"
	},
	"Additional_Services_Text": {
		"en": "Looking for Additional Services related to Real Estate Development process?",
		"ar": "Looking for Additional Services related to Real Estate Development process?"
	},
	"minimum_password_valid_chars": {
		"en": "Invalid characters. Only number,alphabets, special characters mentioned above is valid.",
		"ar": "أحرف غير صالحة. فقط الأرقام والحروف الأبجدية والأحرف الخاصة المذكورة أعلاه صالحة."
	},
	"tell_us_more_placeholder": {
		"en": "Type your experience here…",
		"ar": "اكتب تجربتك هنا..."
	},
	"Service Time": {
		"en": "Service Required Time",
		"ar": "الوقت المتوقع للخدمة"
	},
	"Property_Auction": {
		"en": "Property Auction",
		"ar": "المزاد العقاري"
	},
	"project_status_active": {
		"en": "Active",
		"ar": "نشيط"
	},
	"escrow": {
		"en": "Escrow",
		"ar": "حساب الضمان"
	},
	"golden_visa_retiree": {
		"en": "Golden Visa - Retiree",
		"ar": "الإقامة الذهبية - متقاعد"
	},
	"documents_sections": {
		"en": "4 - Documents",
		"ar": "4 - المستندات"
	},
	"more-selectCategory-label1": {
		"en": "What kind of property categories are you looking for?",
		"ar": "ما نوع فئات العقارات التي تبحث عنها؟"
	},
	"cu_Phone_text": {
		"en": "Please contact this number for any non-technical inquiries",
		"ar": "يرجى التواصل على هذا الرقم لاية استفسارات غير تقنية"
	},
	"Contact_Details_Text": {
		"en": "Contact Details",
		"ar": "بيانات المتصل"
	},
	"news_latest_label": {
		"en": "Latest News",
		"ar": "أخر الأخبار"
	},
	"emirates_id_front": {
		"en": "Emirates ID (Front Side)",
		"ar": "الهوية الإماراتية (الجهة الأمامية)"
	},
	"register": {
		"en": "Sign up",
		"ar": "مستخدم جديد"
	},
	"Cancellation": {
		"en": "Cancellation",
		"ar": "إلغاء"
	},
	"paid_amount_less_than_total": {
		"en": "Paid amount should be less than or equal to the purchase amount",
		"ar": "يجب أن يكون المبلغ المدفوع أقل من أو يساوي مبلغ الشراء"
	},
	"Project_Type_Label": {
		"en": "Project Type",
		"ar": "نوع المشروع"
	},
	"uae_pass_desc_1": {
		"en": "The UAE Pass app is the first national digital identity and signature solution that enables users to identify themselves to government service providers in all emirates through a smartphone-based authentication. It also enables users to sign documents digitally with a high level of security.",
		"ar": "الهوية الرقمية هي أول هوية وطنية رقمية لجميع المواطنين والمقيمين والزوار. باستخدام هاتفك الذكي تستطيع الدخول الى العديد من الخدمات الالكترونية عبر مختلف القطاعات في الدولة، بالإضافة الى التوقيع رقميا على المستندات."
	},
	"proceed_to_subscribe": {
		"en": "Proceed to Subscribe",
		"ar": "إجراءات الاشتراك"
	},
	"form_validate_square_feet": {
		"en": "Please enter square feet",
		"ar": "يرجى إختيار قدم مربع"
	},
	"Essential_Services": {
		"en": "Essential Services",
		"ar": "الخدمات الضرورية"
	},
	"home_Register_Complaint_text": {
		"en": "Distinct real estate service to record all notes and complaints in order to safeguard the rights of parties",
		"ar": "نظام المخالفات العقارية يقوم بتوفير خدمة عقارية متميزة وأسهل الطرق لتسجيل جميع الملاحظات و الشكاوى حفاظا على حقوق الاطراف"
	},
	"home_knowledge_bank_url": {
		"en": "https://dubailand.gov.ae/en/eservices/exam-registration/?tr-id=28881#/",
		"ar": "https://dubailand.gov.ae/ar/eservices/exam-registration/?tr-id=28881#/"
	},
	"more-collected-amount": {
		"en": "Collected Amount",
		"ar": "المبلغ المحصل"
	},
	"sq_ft": {
		"en": "Sq.Ft",
		"ar": "قدم مربع"
	},
	"dld_rvs": {
		"en": "Real Estate Company Violation Complaint",
		"ar": "شكاوي المخالفات العقارية"
	},
	"i_agree": {
		"en": "I Agree",
		"ar": "I Agree"
	},
	"case_requests": {
		"ar": "طلبات الدعوى",
		"en": "Case Requests"
	},
	"approved_developers": {
		"en": "Licensed\u003Cbr/\u003E Real Estate Developers",
		"ar": "المطورين العقاريين المرخصين"
	},
	"please_login_uid_update_password": {
		"en": "Please login with username and password to update password",
		"ar": "الرجاء تسجيل الدخول باسم المستخدم وكلمة المرور لتحديث كلمة المرور"
	},
	"archive_label": {
		"en": "View All",
		"ar": "شاهد الكل"
	},
	"mun_sub_number": {
		"en": "Sub Number",
		"ar": "الرقم الفرعي"
	},
	"nationality": {
		"en": "Nationality",
		"ar": "الجنسية"
	},
	"defendant_details": {
		"en": "Defendant Details",
		"ar": "بيانات المشتكى عليه"
	},
	"map": {
		"en": "Map",
		"ar": "خريطة"
	},
	"municipality_land_usage": {
		"en": "Municipality Land Usage",
		"ar": "استخدام الأرض - البلدية"
	},
	"land_no": {
		"en": "Land Number",
		"ar": "رقم الأرض"
	},
	"sso_app_desc_oqood": {
		"en": "Manage off-plan projects and initial sales contracts registration etc.",
		"ar": "إدارة المشاريع على الخارطة وتسجيل عقود البيع الأولية وما إلى ذلك."
	},
	"auction_noti_msg_3": {
		"en": "Land in Um Suqaim First for Sale, 668 Sq. Metres – Reserved Price AED 4,500,000",
		"ar": "أرض في أم سقيم الأولى للبيع ، مساحة 668 متر مربع - السعر الأساسي 4،500،000 درهم"
	},
	"more-express-interest": {
		"en": "Express Interest",
		"ar": "إبداء الاهتمام"
	},
	"training_and_program": {
		"en": "Trainings &\u003Cbr /\u003E Programs",
		"ar": "دورات\u003Cbr/\u003E تدريبية وبرامج"
	},
	"form_validate_swift_code": {
		"en": "Please enter a valid swift code",
		"ar": "يرجى إدخال كود السويفت صحيح"
	},
	"passport_issue_place_ar": {
		"en": "Passport Issue Place (AR)",
		"ar": "مكان اصدار الجواز (بالعربية)"
	},
	"Welcome-Re-Shield-Label": {
		"en": "Welcome to Re-Shield ",
		"ar": "أهلا بك في الدرع العقاري"
	},
	"agree_and_submit": {
		"en": "Agree and Submit",
		"ar": "الموافقة والإرسال"
	},
	"showing_entries": {
		"en": "Showing {0} to {1} of {2} entries",
		"ar": "إظهار {0} إلى {1} من {2} إدخالات"
	},
	"partnershipDLDS_AccountTrusteesTitle": {
		"en": "Certified Escrow Agents",
		"ar": "امناء حساب الضمان المعتمدين"
	},
	"mali_call_complainant_description": {
		"en": "Complain Description",
		"ar": "تفاصيل الشكوى"
	},
	"zone_code": {
		"ar": "رمز المنطقة",
		"en": "Zone Code"
	},
	"key_figures": {
		"en": "\u003Cspan\u003E\n                                    Key\n                                \u003C/span\u003E\n                                \u003Cspan\u003EFigures\u003C/span\u003E",
		"ar": "\u003Cspan\u003E\n                                    أهم \n                                \u003C/span\u003E\n                                \u003Cspan\u003Eالنتائج\u003C/span\u003E"
	},
	"ready": {
		"en": "Ready",
		"ar": "جاهز"
	},
	"agree_terms": {
		"en": "I confirm that i agree on the the terms & conditions",
		"ar": "تأكيد بالموافقة علي الشروط والأحكام"
	},
	"total_worth_aed": {
		"en": "Total worth (in AED)",
		"ar": "القيمة الإجمالية (بالدرهم)"
	},
	"how_do_i_title": {
		"en": "How do I...?",
		"ar": "كيف أفعل...؟"
	},
	"Mortgage_Brokers_Option": {
		"en": "Mortgage Brokers",
		"ar": "سماسرة الرهن العقاري"
	},
	"cppi-dcppi": {
		"en": "Dubai Commercial\u003Cbr /\u003E Property Price Indices",
		"ar": "Dubai Commercial\u003Cbr /\u003E Property Price Indices"
	},
	"cu_Location": {
		"en": "Know our Location",
		"ar": "العنوان"
	},
	"valuation_company": {
		"en": "Accredited Real Estate\u003Cbr/\u003E Valuation Companies",
		"ar": "شركات التقييم العقاري المعتمدة"
	},
	"broker_training_FAQs_Q8_a": {
		"ar": "\u003Cul class=\"arrow-list px-4\"\u003E\n                                    \u003Cli\u003Eصورة عن الرخصة التجارية للشركة\u003C/li\u003E\n                                    \u003Cli\u003Eخطاب تفويض (يجب أن تكون ورقة خطاب رسمية من الشركة، وموقعة ومختوم من قِبل الشخص المسؤول\u003C/li\u003E\n                                    \u003Cli\u003Eتوكيل رسمي (في حال لم يكن توقيع الشخص المسؤول موجوداً على رخصة الشركة التجارية)\u003C/li\u003E\n                                    \u003Cli\u003Eجواز السفر أو التأشيرة أو الهوية الإماراتية للشخص الموقع.\u003C/li\u003E\n                                    \u003Cli\u003Eصورة عن جواز السفر وصفحة التأشيرة للمستخدم المطلوب\u003C/li\u003E\n                                    \u003Cli\u003E إذا لم تكن تأشيرة المستخدم المطلوبة من نفس الشركة، فسيلزم شهادة عدم ممانعة من الكفيل.\u003C/li\u003E\n                                \u003C/ul\u003E",
		"en": "\u003Cul class=\"arrow-list px-4\"\u003E\n                                    \u003Cli\u003ECopy of company trade license\u003C/li\u003E\n                                    \u003Cli\u003EAuthorization Letter(must be on company letter head and signed  and stamped by authorized person and submitted in original)\u003C/li\u003E\n                                    \u003Cli\u003EPower of attorney (If authorized signature not part of trade license)\u003C/li\u003E\n                                    \u003Cli\u003EPassport/ Visa/ Emirates Id of the signatory person.\u003C/li\u003E\n                                    \u003Cli\u003EPassport Copy with Visa page for requested user\u003C/li\u003E\n                                    \u003Cli\u003EIf the requested user person visa is not from the same company then NOC from sponsor is required.\u003C/li\u003E\n                                \u003C/ul\u003E"
	},
	"size": {
		"en": "Size",
		"ar": "المساحة"
	},
	"form_validate_procedure_year": {
		"en": "Please enter a valid procedure year",
		"ar": "يرجى إدخال سنة الاجراء صحيح"
	},
	"expected_ROI": {
		"en": "Expected ROI (% Value)",
		"ar": "نسبة العائد أو المردود"
	},
	"rejected": {
		"en": "Rejected",
		"ar": "مرفوض"
	},
	"ElectronicSuggest": {
		"en": "e Suggest logo",
		"ar": "نظام الاقتراحات الالكترونية"
	},
	"request type": {
		"en": "Request Type",
		"ar": "نوع الطلب"
	},
	"awarded_to": {
		"en": "Awarded To",
		"ar": "منحت إلى"
	},
	"home_innovation_incubator_desc": {
		"ar": "تسعى هذه المبادرة إلى تطوير منظومة الابتكار في قطاع العقارات واستقطاب الشركات المتخصّصة في مجال تكنولوجيا العقار",
		"en": "The initiative aims to develop the innovation system in \u003Cbr/\u003Ereal estate sector and attract specialized real estate technology companies"
	},
	"modal_text_freehold": {
		"en": "\u003Cp\u003E\u003Cb\u003EFreehold\u003C/b\u003E\u003Cbr /\u003EPurchase is allowed for all Nationalities.\u003C/p\u003E",
		"ar": "\u003Cp\u003E\u003Cb\u003Eالتملك الحر\u003C/b\u003E\u003Cbr/\u003E يُسمح بالشراء لجميع الجنسيات\u003C/p\u003E"
	},
	"e_g_area_square": {
		"en": "e.g. 785 (Sq.Ft)",
		"ar": "e.g. 785 (Sq.Ft)"
	},
	"modal_text_nonfreehold": {
		"en": "\u003Cp\u003E\u003Cb\u003ENonFreehold\u003C/b\u003E\u003Cbr /\u003E Purchase is allowed for GCC Nationalities.\u003C/p\u003E",
		"ar": "\u003Cp\u003E\u003Cb\u003Eالتملك غير الحر\u003C/b\u003E\u003Cbr /\u003E يُسمح بالشراء لمواطني دول مجلس التعاون الخليجي.\u003C/p\u003E"
	},
	"service_charge_due_amount": {
		"ar": "المبلغ المستحق للدفع لرسوم الخدمات",
		"en": "Service charge due amount"
	},
	"form_validate_owner_name": {
		"en": "Please enter a valid owner name",
		"ar": "يرجى إدخال المالك صحيح"
	},
	"news_label": {
		"en": "News",
		"ar": "الأخبار"
	},
	"content_tag": {
		"en": "Content",
		"ar": "محتوى"
	},
	"dld_complain_desc": {
		"en": "For Complaints against Dubai Land\n                            Department Services or any other queries",
		"ar": "للشكاوى ضد خدمات دائرة الأراضي والأملاك بدبي أو أية استفسارات أخرى"
	},
	"home_Banner_DLD_Vault_Description": {
		"en": "\u003Cp\u003EA simpler way for user to manage your documents digitally\u003C/p\u003E\u003Cp\u003ESecured digital document storage where you can store files and share them with service partners as required.\u003C/p\u003E",
		"ar": "\u003Cp\u003Eطريقة أبسط للمستخدم لإدارة مستنداتك رقميًا\u003C/p\u003E\u003Cp\u003Eمستندات رقمي آمن حيث يمكنك تخزين الملفات ومشاركتها مع شركاء الخدمة حسب الحاجة\u003C/p\u003E"
	},
	"introStep4": {
		"en": "\u003Ch5 class='font-weight-bold'\u003EAccessibility and Feedback\u003C/h5\u003E\u003Cp\u003EEvery user is important to us and we strive to ensure that our services are accessible to people with special needs.\u003C/p\u003E",
		"ar": "\u003Ch5 class='font-weight-bold'\u003Eسهولة الوصول\u003C/h5\u003E\u003Cp\u003Eالمستخدمين جميعا مهمين لنا حيث اننا نبذل قصارى جهدنا لنتأكد من ان خدماتنا سهلة الاستخدام لذوي الاحتياجات الخاصة\u003C/p\u003E"
	},
	"Other Requests": {
		"en": "Other Requests",
		"ar": "خدمات أخرى"
	},
	"get_certified": {
		"ar": "احصل على شهادة",
		"en": "Get Certified"
	},
	"additional_charges": {
		"en": "Additional Charges",
		"ar": "رسوم إضافية"
	},
	"dm": {
		"en": "Municipality Number",
		"ar": "رقم البلدية"
	},
	"Residential_Text": {
		"en": "Residential",
		"ar": "سكني"
	},
	"invalid_birthdate": {
		"en": "Invalid Date of Birth",
		"ar": "Invalid Date of Birth"
	},
	"access_to_following_systems": {
		"en": "Access to following Systems",
		"ar": "الوصول إلى الأنظمة التالية"
	},
	"form_validate_project": {
		"en": "Please select the project",
		"ar": " يرجى إختيار المشروع"
	},
	"close_label": {
		"en": "Close",
		"ar": "إغلاق"
	},
	"company_details": {
		"en": "Company Details",
		"ar": "بيانات الشركة"
	},
	"select_area_view_details": {
		"en": "Please select an area on the map to view details",
		"ar": "الرجاء تحديد منطقة على الخريطة لعرض التفاصيل"
	},
	"home_latest_news_from_DLD": {
		"en": "Latest News",
		"ar": "آخر الاخبار"
	},
	"home_latest_news_from_DLD_text": {
		"en": "Get the latest updates on News and Events happening in and around Dubai Land Department",
		"ar": "احصل على احدث التحديثات للأخبار والاحداث في دائرة الأراضي والأملاك في دبي"
	},
	"file": {
		"en": "File",
		"ar": "ملف"
	},
	"sub_land_num_label": {
		"en": "Sub Land Number",
		"ar": "رقم الأرض الفرعية"
	},
	"tourist_facility": {
		"en": "Tourist Facility",
		"ar": "مؤسسة سياحية"
	},
	"num_of_cases": {
		"en": "Number of cases",
		"ar": "عدد القضايا"
	},
	"expiry_date": {
		"en": "Expiry Date",
		"ar": "تاريخ الانتهاء"
	},
	"NewOfficeTimingsTxt4": {
		"en": "Customer Service Timings",
		"ar": "أوقات خدمة العملاء"
	},
	"quick_links": {
		"en": "Quick Links",
		"ar": "روابط سريعة"
	},
	"minimum_password_lowecase": {
		"en": "One Lowercase character",
		"ar": "حرف صغير واحد"
	},
	"residen_no": {
		"en": "Residency Number",
		"ar": "رقم الاقامة"
	},
	"home_Studies": {
		"en": "Open Data",
		"ar": "البيانات المفتوحة"
	},
	"innovation_incubator_desc": {
		"en": "Real Estate Evolution Space",
		"ar": "مبادرة  ريس للابتكار العقاري"
	},
	"announcement": {
		"en": "Announcement",
		"ar": "اعلان"
	},
	"total_villas": {
		"en": "Total Villas",
		"ar": "مجموع الفلل"
	},
	"file_name": {
		"en": "File Name",
		"ar": "اسم الملف"
	},
	"api_information": {
		"ar": "معلومات واجهة برمجة",
		"en": "API Information"
	},
	"CaseTarget": {
		"ar": "إلى ",
		"en": "To"
	},
	"master_search_label": {
		"en": "What are you looking for…?",
		"ar": "ما الذي تبحث عنه ... ؟"
	},
	"land_mun_number": {
		"en": "Municipality Number",
		"ar": "رقم البلدية"
	},
	"your_feedback_has_been_submitted_successfully": {
		"en": "Your feedback has been submitted successfully.",
		"ar": "Your feedback has been submitted successfully."
	},
	"makani_search_label": {
		"en": "Makani Number",
		"ar": "رقم مكاني"
	},
	"calculate_again_label": {
		"en": "Calculate again",
		"ar": "حاول مرة أخرى"
	},
	"sso_app_desc_rdc": {
		"en": "Registration of Rental Dispute Cases (Rental cases, the Mediation cases, and Appeal cases)",
		"ar": "تسجيل قضايا المنازعات الإيجارية (الابتدائية، الصلح و الاستئناف)"
	},
	"compare": {
		"en": "Compare",
		"ar": "قارن"
	},
	"separated_reference": {
		"en": "Separated Reference",
		"ar": "مرجع منفصل"
	},
	"ip-wait-for-response": {
		"en": "Wait for the response",
		"ar": "بانتظار الرد"
	},
	"mnu_login_help": {
		"ar": "من هو مستخدم الأعمال والفرد؟",
		"en": "Who is a business user and individual?"
	},
	"project_developer_information": {
		"ar": "معلومات المشروع والمطور",
		"en": "Project & Developer Information"
	},
	"rvs-complaint-step-1": {
		"en": "Complaint Registered",
		"ar": "تسجيل الشكوى"
	},
	"master_community": {
		"en": "Master Community",
		"ar": "المجتمع الرئيسي"
	},
	"more-name-ar": {
		"en": "Name (Arabic) *",
		"ar": "الاسم (عربي)*"
	},
	"office_trade_license": {
		"en": "Office \u003Cbr/\u003ETrade License",
		"ar": "رخصة \u003Cbr/\u003Eتجارية مكتبية"
	},
	"trustee_centres_title": {
		"en": "Trustee Centres",
		"ar": "مراكز الأمناء"
	},
	"Live Assistance": {
		"en": "Live Assistance",
		"ar": "مساعدة مباشرة"
	},
	"developed_by": {
		"en": "Developed By",
		"ar": "طورت بواسطة"
	},
	"Read_More_about_Dubai_REST": {
		"en": "Read More about Dubai REST",
		"ar": "إقرأ المزيد حول دبي ريست"
	},
	"export_as": {
		"en": "Export",
		"ar": "تصدير"
	},
	"password_updated": {
		"en": "Password updated.",
		"ar": "تم تحديث كلمة المرور"
	},
	"Home_contractF_title": {
		"en": "Real Estate\u003Cbr/\u003ESale Agreement Template",
		"ar": "نموذج اتفاقية بيع عقار"
	},
	"Number_of_Attendees": {
		"en": "Number of Attendees",
		"ar": "عدد الحضور"
	},
	"pending": {
		"en": "Pending",
		"ar": "قيد الموافقة"
	},
	"case-number-validation": {
		"en": "Please enter case number",
		"ar": " يرجي إدخال رقم الدعوى"
	},
	"office": {
		"en": "Office",
		"ar": "مكتب"
	},
	"dld_faq": {
		"en": "Frequently Asked \u003Cbr\u003E\n                            Questions",
		"ar": "الأسئلة \u003Cbr/\u003E\nالأكثر تكراراً"
	},
	"accessRentalIndexFromDubaiRestStep1": {
		"en": "\u003Cstrong\u003EStep 1\u003C/strong\u003E\u003Cbr /\u003E\n                                Open your mobile camera",
		"ar": "\u003Cstrong\u003Eالخطوة 1\u003C/strong\u003E\u003Cbr /\u003E\n                                افتح كاميرا هاتفك المحمول"
	},
	"username_placeholder": {
		"en": "eg: John Doe",
		"ar": "مثال: جون دو"
	},
	"dld_faq_desc": {
		"en": "To provide you with the best possible services, we have create an extensive list of Q&As",
		"ar": "لتزويدك بأفضل الخدمات الممكنة ، قمنا بإنشاء قائمة شاملة من الأسئلة والأجوبة"
	},
	"rvs-case-tracking": {
		"en": "RVS Case Tracking",
		"ar": "تتبع دعوى RVS"
	},
	"review_the_compalint_and_respond": {
		"en": "Review the complaint\u003Cbr /\u003E and respond accordingly",
		"ar": "مراجعة الشكوى والرد\u003Cbr/\u003E عليها وفقاً لذلك"
	},
	"view_current_projects": {
		"en": "View Current Projects",
		"ar": "عرض المشاريع الحالية"
	},
	"Re-Shield-Content1": {
		"en": "The ultimate guide to real estate information in Dubai. Get to know the laws, regulations, requirements and general information.",
		"ar": "الدليل الأهم للمعلومات في القطاع العقاري في دبي. تعرف على القوانين، التشريعات، المتطلبات وغيرها."
	},
	"sso_app_desc_TABU": {
		"en": "TABU system is the legacy backend system for auditors and DLD employees",
		"ar": "نظام الطابو هو النظام الرسمي للمدققين وموظفي دائرة الأراضي و الأملاك"
	},
	"home_Connect_with_Us_description": {
		"en": "We’re here to help you. Find the answers and tell us how we could do better.",
		"ar": "نحن هنا لمساعدتك. اعثر على الإجابات لاستفساراتك، أخبرنا كيف يمكننا تحسين أدائنا."
	},
	"purchase_price": {
		"en": "Purchase Price",
		"ar": "سعر الشراء"
	},
	"total": {
		"en": "Total",
		"ar": "المجموع"
	},
	"share": {
		"en": "Share",
		"ar": "شارك"
	},
	"uae_pass_registration-video": {
		"en": "https://www.youtube.com/watch?v=M62taRz58f0",
		"ar": "https://www.youtube.com/watch?v=BKEZ_ydm_H8"
	},
	"transactions": {
		"en": "Transactions",
		"ar": "التصرفات"
	},
	"occupation": {
		"en": "Occupation",
		"ar": "مهنة"
	},
	"rt_registration_for": {
		"en": "Registration for",
		"ar": "التسجيل في"
	},
	"number": {
		"en": "Number",
		"ar": "رقم"
	},
	"RI-not-applicable": {
		"en": "Not Applicable",
		"ar": "لا ينطبق"
	},
	"emirati-program-otp-detail-msg-email": {
		"en": "Please enter the OTP which you have received on your mobile number and email.",
		"ar": "الرجاء إدخال رمز التحقيق لمرة واحدة (OTP) المرسل لرقم الهاتف والبريد الالكتروني"
	},
	"vault_rename_folder": {
		"en": "Rename Folder",
		"ar": "إعادة تسمية المجلد"
	},
	"rdc_contact_support_number": {
		"en": "04-2030579",
		"ar": "04-2030579"
	},
	"contract_num_sign": {
		"en": "Contract #",
		"ar": "تعليقات"
	},
	"rgc_request_not_found": {
		"en": "No data found for the entered request number",
		"ar": "لم يتم العثور على بيانات لرقم الطلب المدخل"
	},
	"moasher_quarterly": {
		"en": "Q",
		"ar": "Q"
	},
	"to_whom_it_may_concern": {
		"en": "To Whom It May Concern",
		"ar": "طلب إصدار شهادة بيان املاك العميل (لمن يهمه الامر)"
	},
	"please_enter_the_verification_code": {
		"en": "Please enter the Verification Code",
		"ar": "الرجاء إدخال رقم التحقق"
	},
	"rename_file": {
		"en": "Rename File",
		"ar": "إعادة تسمية الملف"
	},
	"Current_Progress": {
		"en": "Current Progress",
		"ar": "نسبة الأنجاز الحالية"
	},
	"mandatory_fields_note": {
		"en": "Note: All fields marked with an asterisk (*) are mandatory",
		"ar": "ملاحظة: جميع الحقول التي تحمل علامة النجمة (*) إلزامية"
	},
	"shopping_mall_type": {
		"en": "Shopping Mall Unit Type",
		"ar": "نوع وحدة مركز التسوق"
	},
	"dld_vault": {
		"en": "DLD Document Vault",
		"ar": "مستودع مستندات دائرة الأراضي و الأملاك"
	},
	"health_facility": {
		"en": "Health Facility",
		"ar": "مؤسسة صحية"
	},
	"sso_app_desc_trakheesi": {
		"en": "Provides licensing services; real estate permits services to real estate companies and e-cards to brokers",
		"ar": "توفير خدمات الترخيص ؛ خدمات التصاريح العقارية للشركات العقارية والبطاقات الإلكترونية للوسطاء"
	},
	"Ejari": {
		"en": "Ejari",
		"ar": "إيجاري"
	},
	"valuator_card": {
		"en": "Valuer Card",
		"ar": "بطاقة المقيم"
	},
	"no_of_transactions": {
		"en": "No. of Transactions",
		"ar": "عدد المعاملات"
	},
	"as_an_owner_you_can": {
		"en": "As an Owner you can",
		"ar": "بصفتك مالكًا ، يمكنك"
	},
	"land_use": {
		"en": "Land use",
		"ar": "استخدام الأراضي"
	},
	"property_location_on_floor": {
		"en": "Location on Floor",
		"ar": "الموقع فى الطابق"
	},
	"invalid_data": {
		"en": "Invalid Data",
		"ar": "البيانات غير صحيحة"
	},
	"price_breakdown": {
		"en": "Price Breakdown",
		"ar": "السعر التفصيلي"
	},
	"land_usage": {
		"en": "Land Usage",
		"ar": "استخدام الأراضي"
	},
	"form_validate_square_meter": {
		"en": "Please enter square meter",
		"ar": "يرجى إختيار متر مربع"
	},
	"view_all_services": {
		"en": "View All Services",
		"ar": "عرض جميع الخدمات"
	},
	"redirecting_to_application_reg": {
		"en": "Redirecting to Application Registration",
		"ar": "إعادة التوجيه إلى التسجيل"
	},
	"land_mort": {
		"en": "Mortgaged",
		"ar": "مرهون"
	},
	"Upload_Pledge_File_label": {
		"en": "Upload non-disclosure of confidentiality file",
		"ar": "رفع ملف عدم إفشاء السرية"
	},
	"cu_Phone_text_nav": {
		"en": "You can reach us via phone on the below number: \u003Cspan class=\"direction-ltr d-inline-block\"\u003E+971 - 8004488\u003C/span\u003E",
		"ar": "يمكنك التواصل معنا عبر الهاتف على الرقم أدناه : \u003Cspan class=\"direction-ltr d-inline-block\"\u003E+971 - 8004488\u003C/span\u003E"
	},
	"all": {
		"en": "All",
		"ar": "الكل"
	},
	"organization": {
		"en": "Organization",
		"ar": "مؤسسة"
	},
	"total_area_sqft": {
		"en": "Total area (Sq.Ft)",
		"ar": "المساحة الكلية (قدم مربع)"
	},
	"partnershipDLDSAODescription": {
		"en": "Auditors’ offices aim to audit the financial statements of real estate and oversee the management of the escrow account offices to ensure the preservation of the rights of all stakeholders in the Dubai real estate market.",
		"ar": "تهدف مكاتب التدقيق المعتمدة والمرخصة من دائرة الأراضي والأملاك مراجعة البيانات المالية الخاصة بالمشايع العقارية وتشرف على هذه المكاتب أدارة حساب الضمان العقاري لضمان حفظ حقوق جميع المعنيين في سوق دبي العقاري."
	},
	"Land_Status": {
		"en": "Land Status",
		"ar": " الإستعلام عن حالة أرض"
	},
	"Ask_Malik_Description": {
		"en": "Dubai Land Department’s Virtual Assistant \nAsk me any question related to DLD and its services",
		"ar": "المساعد الافتراضي لدائرة الأراضي والأملاك في دبي\nاطرح عليّ أي سؤال يتعلق بدائرة الأراضي و الأملاك وخدماتها"
	},
	"home_favorite_services_msg": {
		"en": "To add more Services to your favorites list, proceed to All Services and click on Star icon next to the Service Name.\n",
		"ar": "لإضافة المزيد من الخدمات إلى قائمة المفضلة لديك ، انتقل إلى جميع الخدمات وانقر على أيقونة النجمة بجوار اسم الخدمة."
	},
	"favorites_text": {
		"en": "My Favorites",
		"ar": "مفضلتي"
	},
	"mixed": {
		"en": "Mixed",
		"ar": "مختلط"
	},
	"form_valid_mobile_label": {
		"en": "Please enter a valid mobile number",
		"ar": "الرجاء إدخال رقم جوال صحيح"
	},
	"home_banner_webinar_title": {
		"en": "Real Estate Sector \u003Cbr/\u003EPerformance",
		"ar": "أداء القطاع العقاري"
	},
	"rental_price_index": {
		"en": "Commercial Properties Price Index (CPPI)",
		"ar": "مؤشر أسعار بيع العقارات التجارية"
	},
	"SalesPercentage": {
		"en": "Sales Percentage",
		"ar": "نسبة المبيعات"
	},
	"property_total_value": {
		"en": "Property Total Value",
		"ar": "القيمة الإجمالية للممتلكات"
	},
	"result": {
		"en": "Result",
		"ar": "النتيجة"
	},
	"auction_noti_msg_lini_3": {
		"en": "https://emart.dubailand.gov.ae/Listings/ListingAuctionDetails.aspx?krP4ldHWywXokc%2figL1q23PFLv3DAGt5W5zjUklkHyiy1Ay%2fgcSUtvx9%2f97zqZGM",
		"ar": "https://emart.dubailand.gov.ae/Listings/ListingAuctionDetails.aspx?krP4ldHWywXokc%2figL1q23PFLv3DAGt5W5zjUklkHyiy1Ay%2fgcSUtvx9%2f97zqZGM"
	},
	"notice": {
		"en": "Stay Home. Stay Safe",
		"ar": "خلكم فالبيت, مع تمنياتنا لكم السلامة"
	},
	"home_dev_guide_text": {
		"en": "The Real Estate Development Handbook, is prepared in co-operation with more than 23 governmental and non-governmental entities that provides services related to the real estate development.",
		"ar": "تم إعداد دليل التطوير العقاري بالتعاون مع أكثر من 23 جهة حكومية وغير حكومية تقدم خدمات تتعلق بالتطوير العقاري"
	},
	"vault_folders_name": {
		"en": "Folder's Name",
		"ar": "اسم المجلد"
	},
	"payment_method": {
		"en": "Payment Method",
		"ar": "طرق الدفع"
	},
	"emirati-program-self-employed": {
		"en": "Self Employed ",
		"ar": "تعمل لحسابك الخاص  "
	},
	"home_Raise_a_Complaint_proceed": {
		"en": "Proceed to e-Complaint",
		"ar": "انتقل إلى الشكاوى الإلكترونية"
	},
	"h_ramadan-time_title": {
		"en": "Office Timings during the holy month of Ramadan",
		"ar": "ساعات العمل خلال شهر رمضان المبارك"
	},
	"property_details": {
		"en": "Property Details",
		"ar": "تفاصيل العقار"
	},
	"cancel": {
		"en": "Cancel",
		"ar": "إلغاء"
	},
	"Training_Fee": {
		"ar": "رسوم التدريب",
		"en": "Training Fee"
	},
	"cu_dubai_rest_text": {
		"en": "You can access all e-Services via our Dubai REST Application.",
		"ar": "يمكن الوصول إلى جميع الخدمات الإلكترونية من خلال تطبيق دبي ريست"
	},
	"period": {
		"en": "Period",
		"ar": "الفترة"
	},
	"certificate_number": {
		"en": "Certificate No.",
		"ar": "رقم الشهادة"
	},
	"inspection_date": {
		"en": "Inspection Date",
		"ar": "تاريخ الفحص"
	},
	"query_label": {
		"en": "Query Regarding",
		"ar": "استفسار بخصوص"
	},
	"PropertyTrustee": {
		"en": "Real Estate\u003Cbr/\u003E Services Trustee Centers",
		"ar": "مراكز أمناء الخدمات العقارية"
	},
	"restrained": {
		"ar": "مقيد",
		"en": "Restrained"
	},
	"ejari_parties_information": {
		"ar": "معلومات أطراف إيجاري",
		"en": "Ejari Parties Information"
	},
	"home_transaction_service": {
		"en": "Real Estate\u003Cbr\u003E Transaction Services",
		"ar": "خدمات \u003Cbr\u003E التصرفات العقارية"
	},
	"emp_id": {
		"en": "Employee ID",
		"ar": "الرقم الوظيفي"
	},
	"partnershipDLDSEjariLink": {
		"en": "Ejari Offices",
		"ar": "قائمة مكاتب إيجاري"
	},
	"bad_conduct": {
		"en": "There's enforcement cases against the person with the below Emirates ID",
		"ar": "يوجد دعاوى قضائية ضد الشخص صاحب الهوية ادناه"
	},
	"rt_dld_fees": {
		"en": "DLD Fees",
		"ar": "رسوم الدائرة"
	},
	"Find_the_right_Training_Courses_for_you": {
		"en": "Find the right Training Courses for you",
		"ar": "اعثر على الدورات التدريبية المناسبة لك"
	},
	"location_map": {
		"en": "Location Map",
		"ar": "عرض الخريطة"
	},
	"additional_details": {
		"en": "Additional Details",
		"ar": "تفاصيل اضافية"
	},
	"project_under_label": {
		"en": "Project is under",
		"ar": "المشروع تحت"
	},
	"more-budget-label": {
		"en": "What is your approximate budget ?",
		"ar": "ما هي ميزانيتك التقريبية؟"
	},
	"more-next": {
		"en": "Next",
		"ar": " التالي"
	},
	"login_ind": {
		"en": "As an Individual, you can...",
		"ar": "كفرد ، يمكنك ..."
	},
	"day": {
		"en": "Day",
		"ar": "اليوم"
	},
	"requestor-role": {
		"en": "Requestor Role",
		"ar": "دور مقدم الطلب "
	},
	"rental_index": {
		"ar": "الإستعلام عن مؤشر بدل الايجار ",
		"en": "Inquiry about the rental index"
	},
	"partnershipParagraph1": {
		"en": "Dubai Land Department works through the directives of His Highness Sheikh Mohammed bin Rashid Al Maktoum, as he said: “Providing excellent services to customers mean building genuine partnerships with them. As it is one of the objectives of which we are keen to achieve and excel in. The government is committed to its customers by providing fast and excellent services, and we will not be satisfied with what has been achieved so far in the field of customer service, but we will provide even better services and faster than now”. Consistent with the vision of the department: (To be the global leading real estate environment to attract investments), Partnerships has been a successful field in DLD at its local and regional levels and exceeded the limits to international real estate leading organization.",
		"ar": "\n                            تعمل دائرة الأراضي والأملاك بدبي من خلال توجيهات صاحب السمو الشيخ محمد بن راشد آل مكتوم التي بها ما يكفي من الوضوح عندما قال (إن الاهتمام بالمتعاملين والتميز في خدمتهم وبناء شراكة حقيقية معهم، هو أحد الأهداف الرئيسية التي نحرص على تحقيقها والتفوق فيها، فالحكومة ملتزمة بالمتعاملين معها من أن يحصلوا على خدمة سريعة ومتميزةة  وبالأسلوب اللائق وفي الوقت الملائم، وأننا لن نكتفي بما تحقق حتى الآن في مجال خدمة المتعاملين، بل سنقدم لهم خدمات أفضل وأسرع مما هي عليها الآن.\n        \n                            وانسجاما مع رؤية الدائرة (بأن نكون الوجهة العقارية الأولى عالميا في الإبتكار والثقة والسعادة) فإن شراكات الدائرة الناجحة على المستوى المحلي والاقليمي تعدت هذه الحدود إلى شراكات دولية مع أبرز المنظمات العقارية العالمية المتخصصة من خلال العضويات وأبرام الاتفاقيات التي رسمة حدود الشراكة ضمن أهداف مخططة تحقق أهداف الدائرة وشركائها على حد سواء."
	},
	"Portal_dev_desc": {
		"en": "The real estate development in the Emirate of Dubai is one of the leading pillars in the real estate sector and significantly contributing in the growth of the real estate market in Dubai as the cornerstone of the Emirate’s expansion and development.",
		"ar": "The real estate development in the Emirate of Dubai is one of the leading pillars in the real estate sector and significantly contributing in the growth of the real estate market in Dubai as the cornerstone of the Emirate’s expansion and development."
	},
	"new": {
		"en": "New",
		"ar": "جديد"
	},
	"entities_desc": {
		"en": "Find the list of all Licensing Authorities and\n                            Entities which are involved in the process",
		"ar": "ابحث عن قائمة جميع سلطات الترخيص و\n                             الكيانات المشاركة في العملية"
	},
	"no_of_seller": {
		"en": "No. of Seller",
		"ar": "إجمالي البائعين"
	},
	"rental_transactions_details": {
		"en": "Rent Transaction Details",
		"ar": "تفاصيل عقود الإيجار"
	},
	"calculate": {
		"en": "Calculate",
		"ar": "احسب"
	},
	"Offices / Consultants": {
		"en": "Real Estate Partners",
		"ar": "الشركاء العقاريين"
	},
	"violation_date": {
		"en": "Violation Date",
		"ar": "تاريخ الانتهاك"
	},
	"building_age": {
		"en": "Building Age",
		"ar": "عمر البناء"
	},
	"Customer_Happiness_Charter": {
		"en": "Customer Happiness Charter",
		"ar": "ميثاق إسعاد المتعاملين"
	},
	"customer_support_desc": {
		"en": "We offer dedicated customer support to assist you with any inquiries, ensuring a smooth and efficient experience.",
		"ar": " نقدم لكم دعم متعاملين مخصصًا لمساعدتكم في أي استفسارات، لضمان تجربة سلسة وفعالة."
	},
	"home_banner_webinar_detail_title": {
		"en": "Event Details",
		"ar": "تفاصيل الملتقي"
	},
	"select": {
		"en": "Select",
		"ar": "اختر"
	},
	"locate_us": {
		"en": "Direction",
		"ar": "اتجاه"
	},
	"dev_step_3": {
		"en": "Step 03",
		"ar": "الخطوة 03"
	},
	"please_select_requestor_role": {
		"en": "Please select requestor role",
		"ar": "الرجاء تحديد دور مقدم الطلب"
	},
	"NewOfficeTimingsTxt5": {
		"en": "Customer Service is available through phone, email and chat from 7:30 am to 4:30 pm (Monday to Friday)",
		"ar": "خدمة العملاء متاحة عبر الهاتف والبريد الإلكتروني والدردشة من الساعة 7:30 صباحًا حتى 4:30 مساءً (من الاثنين إلى الجمعة)"
	},
	"non_contractual_complaint_msg_2": {
		"en": "\u003Cli\u003E\n                        Supporting documents must be attached to the complaint and proof of the violation\n                    \u003C/li\u003E\n                    \u003Cli\u003E\n                        This system is not concerned with considering complaints related to rental issues, as the competent authority is the (Rental Dispute Center)\n                    \u003C/li\u003E\n                    \u003Cli\u003E\n                        This system is not concerned with considering complaints related to the cancellation of contracts, reservations, or any financial compensation.\n                    \u003C/li\u003E\n                    \u003Cli\u003E\n                        The expected time to respond to the complaint is 5 working days, and transactions that have legal obstacles are excluded from completing them on time\n                    \u003C/li\u003E",
		"ar": "\u003Cli\u003E\n                       يجب ارفاق المستندات الداعمة للشكوى واثبات ارتكاب المخالفة                     \u003C/li\u003E\n                    \u003Cli\u003E\n                        هذا النظام ليس معني بالنظر في الشكاوي المتعلقة بالقضايا الايجارية حيث ان الجهة المختصة هي ( مركز فض المنازعات الايجارية )\n                    \u003C/li\u003E\n                    \u003Cli\u003E\n                       هذا النظام ليس معني بالنظر في الشكاوي المتعلقة بإلغاء العقود او الحجوزات او أي تعويضات مالية \n                    \u003C/li\u003E\n                    \u003Cli\u003E\n                       الوقت المتوقع للرد على الشكوى 5 أيام عمل وتستثنى المعاملات التي فيها معوقات قانونية من إنجازها في الوقت المحدد\n                    \u003C/li\u003E"
	},
	"speak_select_label": {
		"en": "To proceed to a specific result, please speak out the corresponding number",
		"ar": "للمضي قدما في نتيجة معينة، يرجى التحدث بالرقم المقابل"
	},
	"form_validate_enter_representative_name": {
		"en": "Please enter representative name",
		"ar": "يرجى إدخال اسم ممثل "
	},
	"renewal_fee_of": {
		"ar": "تجديد رسوم",
		"en": "Renewal fee of"
	},
	"max_num_files": {
		"en": "Maximum number of files",
		"ar": "عدد الملف يجب ان لا يتجاوز"
	},
	"home_validate_e_card": {
		"en": "Validate E-Card",
		"ar": "التحقق من صحة البطاقة الإلكترونية"
	},
	"innvestment_details": {
		"en": "Investment Details",
		"ar": "بيانات الاستثمار"
	},
	"cancelled": {
		"en": "Cancelled",
		"ar": "ملغى"
	},
	"Service Documents": {
		"en": "Service Documents",
		"ar": "المستندات المطلوبة"
	},
	"one_account_desc": {
		"en": "Now you don't need to login to different applications. Access your frequently used websites and services with just one login.",
		"ar": "الآن لا تحتاج إلى تسجيل الدخول إلى تطبيقات مختلفة. قم بالوصول إلى مواقع الويب والخدمات المستخدمة بكثرة بتسجيل دخول واحد فقط."
	},
	"read_more_services_view_faqs_page": {
		"en": "Having any queries ? Kindly visit our \u003Ca href=\"/en/faq/\" class=\"fw-bold underline mx-2\"\u003EFrequently Asked Questions\u003C/a\u003E to know more.",
		"ar": "هل لديك أي استفسار؟ يرجى التوجة الى \u003Ca href=\"/ar/faq/\" class=\"fw-bold underline mx-2\"\u003Eالأسئلة الشائعة\u003C/a\u003E لمعرفة المزيد"
	},
	"zip_code": {
		"en": "Zip Code",
		"ar": "الرمز البريدي"
	},
	"emarati_citizens": {
		"ar": "منصــة",
		"en": "CITIZENS'"
	},
	"available_apis": {
		"en": "Available APIs",
		"ar": "واجهات برمجة التطبيقات المتوفّرة"
	},
	"Statistics": {
		"en": "Statistics",
		"ar": "إحصائيات"
	},
	"analysis_real_estate_transactions": {
		"en": "Analysis of Real Estate Transactions in Dubai",
		"ar": "تحليل التصرفات العقارية في دبي"
	},
	"ownership": {
		"en": "Ownership",
		"ar": "الملكية"
	},
	"procedure_type": {
		"en": "Procedure Type",
		"ar": "نوع الإجراء"
	},
	"Dubai Electricity and Water Authority (DEWA)": {
		"en": "Dubai Electricity and Water Authority (DEWA)",
		"ar": "هيئة كهرباء ومياه دبي (ديوا)"
	},
	"birth_place_arabic": {
		"en": "Birth Place(Arabic)",
		"ar": "مكان الميلاد (العربية)"
	},
	"please_select_request": {
		"en": "Please select your Request",
		"ar": "الرجاء تحديد طلبك"
	},
	"following": {
		"en": "Following",
		"ar": "المتابعات"
	},
	"emirates_id": {
		"en": "Emirates ID",
		"ar": "رقم الهوية"
	},
	"Download_Transaction_Summary_report_link": {
		"en": "https://dubailand.gov.ae/media/tfghdjyx/transaction_report_2015-2021.pdf",
		"ar": "https://dubailand.gov.ae/media/tfghdjyx/transaction_report_2015-2021.pdf"
	},
	"property_valuation_type": {
		"en": "Valuation Type",
		"ar": "نوع التقييم"
	},
	"Fee_Break_Down": {
		"ar": "تفاصيل الرسوم",
		"en": "Fee Breakdown"
	},
	"quick_registration": {
		"ar": "التسجيل السريع",
		"en": "Quick Registration"
	},
	"property_value_Label": {
		"en": "Property Value (AED)",
		"ar": "قيمة العقار (درهم)"
	},
	"view_all_partners": {
		"en": "View All Partners",
		"ar": "عرض جميع الشركاء"
	},
	"pending_payment": {
		"en": "Pending Payment",
		"ar": "بانتظار الدفع"
	},
	"emirati-program-your-cv": {
		"en": "Your CV",
		"ar": "السيرة الذاتية "
	},
	"zone_information": {
		"ar": "معلومات المنطقة",
		"en": "Zone Information"
	},
	"save_success": {
		"en": "Changes saved successfully!",
		"ar": "تم حفظ البيانات بنجاح"
	},
	"Ras_al_Khaimah_Option_label": {
		"en": "Ras al-Khaimah",
		"ar": "راس الخيمه"
	},
	"date_and_time": {
		"en": "Date and Time",
		"ar": "التاريخ و الوقت"
	},
	"deira": {
		"en": "Deira",
		"ar": "ديرة"
	},
	"download_contract": {
		"ar": "تنزيل عقد الإيجار",
		"en": "Download contract"
	},
	"property_type_label": {
		"en": "Property Type",
		"ar": "نوع العقار"
	},
	"sso_profile_update_tc_1": {
		"en": "In case of contact information modification, this will be modified only in user profile database of Land Department, and therefore user is fully responsible for updating other records related to various transactions such as RVS, Ejari, RDC, Mollak and so on.",
		"ar": "في حالة تعديل بيانات الاتصال فهذا التعديل سيتم على قاعدة بيانات قسم  دبي للاراضي و لهذا فالمستخدام مسؤول عن تحديث البيانات الاخرى المرتبطه بباقلي المعاملات  مثل انظمه RVS, Ejari, RDC, Mollak وهكذا."
	},
	"generate_case_request": {
		"en": "Generate Case Request",
		"ar": "إنشاء طلبات الدعوى"
	},
	"home_Share_Your_Feedback_text": {
		"en": "Your feedback is highly appreciated and will help us to improve our ability to serve you and other users of our web sites.",
		"ar": "إن ملاحظاتك محل تقدير كبير وستساعدنا على تحسين قدرتنا على خدمتك أنت والمستخدمين الآخرين لمواقع الويب الخاصة بنا. يمكنك مراسلتنا على"
	},
	"password": {
		"en": "Password",
		"ar": "كلمه السر"
	},
	"birthdate": {
		"en": "Birth Date",
		"ar": "تاريخ الميلاد"
	},
	"cheque_date_of_return": {
		"ar": "تاريخ الارجاع",
		"en": "Date of return"
	},
	"partnershipGovernmentalPartners": {
		"en": "Governmental Partners",
		"ar": "الشركاء المحليين"
	},
	"more-confirmation": {
		"en": "Confirmation",
		"ar": "التأكيد"
	},
	"valuer": {
		"en": "Valuer",
		"ar": "مقيم"
	},
	"Investor_Count": {
		"en": "Investor Count",
		"ar": "عدد المستثمرين"
	},
	"land_map_text": {
		"en": "Please select land from the map to show it's details",
		"ar": "من فضلك قم بأختيار ارض بأستخدام الخارطة ليتم عرض البيانات الخاصة بها"
	},
	"download_label": {
		"en": "Download",
		"ar": "تحميل الملف"
	},
	"more-area": {
		"en": "Area",
		"ar": "المنطقة"
	},
	"service_charge_calculation": {
		"en": "Service Charge Index Calculation",
		"ar": "حساب مؤشر رسوم الخدمة"
	},
	"rgc_success": {
		"en": "Rental Good Conduct Certificate has been sent to the provided email",
		"ar": "تم إرسال صحيفة الحالة الايجارية إلى البريد الالكتروني المقدم"
	},
	"bussiness_users": {
		"en": "Business Users",
		"ar": "كمستخدمو الأعمال"
	},
	"rt_party_share_exceed_validation": {
		"en": "The total parties share should not exceed 100%.",
		"ar": "يجب ألا يتجاوز إجمالي حصة الأطراف 100٪."
	},
	"emirati-program-otp-detail-msg": {
		"en": "Please enter the OTP which you have received on your registered mobile number and email",
		"ar": "الرجاء إدخال كلمة المرور لمرة واحدة التي تلقيتها على  رقم هاتفك المحمول المسجل أو البريد الإلكتروني المسجل\n"
	},
	"more-sumbit-interest": {
		"en": "Submit your interest",
		"ar": "أرسل اهتمامك"
	},
	"form_validate_birthdate": {
		"ar": "يرجى إدخال تاريخ الميلاد",
		"en": "Please enter birth date"
	},
	"NOT_VALID_FOR_EXECUTIVE_WRIT": {
		"en": "You are not eligible for issuing the Execution Writ for this case",
		"ar": "لا يمكنك الحصول على السند التنفيذي لهذه الدعوى"
	},
	"Coming soon": {
		"en": "Coming soon",
		"ar": "قريباً"
	},
	"home_Frequently_Used_Services_description": {
		"en": "Based on usage, we have noted down frequently used services for quick access.",
		"ar": "بناءً على الاستخدام سيتم ملاحظة الخدمات الأكثر استخداماً وذلك للوصول السريع"
	},
	"edit_profile": {
		"en": "Edit Profile",
		"ar": "تعديل الملف الشخصي"
	},
	"transaction_size": {
		"en": "Transaction Size (sq.m)",
		"ar": "حجم الصفقة (sq.m)"
	},
	"support-form-message": {
		"en": "Kindly use this form if you are facing any technical issues. For all other general inquiries, please email to",
		"ar": "في حال واجهتك أي مشاكل تقنية؛ يرجى استخدام هذا النموذج. للاستفسارات الأخرى الرجاء إرسال بريد إلكتروني إلى"
	},
	"download_verdict": {
		"en": "Download Verdict",
		"ar": "تحميل الحكم"
	},
	"Training_Time": {
		"en": "Training Time",
		"ar": "وقت التدريب"
	},
	"mali_call_complaint_detail": {
		"en": "Complainant Details",
		"ar": "بيانات المشتكى"
	},
	"project_status_finished": {
		"en": "Finished",
		"ar": "منجز"
	},
	"bedrooms_label": {
		"en": "Bedrooms",
		"ar": "عدد الغرف"
	},
	"experience_outside_dubai": {
		"en": "Experience Outside Dubai",
		"ar": "الخبرة خارج دبي"
	},
	"owner_committee_terms_val_8": {
		"en": "If a conflict of interest or potential conflict of interest arises at any time, then a Committee member must, before any debate or vote is taken on the matter to which the conflict relates: \n\n\ta) Disclose that conflict to the Committee; and \n\n\tb) Abide by the decision of the Committee as to whether they are to be permitted to participate in any debate or vote in respect of the matter.",
		"ar": "في حالة نشوء أي تعارض مصالح فعلي أو محتمل في أي وقت من الأوقات، بجب على عضو لجنة الملاك القيام بما يلي قبل إجراء أية مناقشات أو التصويت بخصوص المسألة التي يتعلق بها التعارض: \\n\\n\\t(أ‌)الكشف عن ذلك التعارض إلى أعضاء اللجنة، \\n\\n\\t(ب‌)الالتزام بقرارات لجنة الملاك فيما إذا كان من المسموح لأعضاء المجلس المشاركة في أية مناقشات أو التصويت بخصوص تلك المسألة"
	},
	"Training_Location": {
		"ar": "موقع التدريب",
		"en": "Training Location"
	},
	"title_deed_no": {
		"en": "Title Deed No",
		"ar": "رقم شهادة"
	},
	"contact_your_account_manager": {
		"en": "Contact your Account Manager",
		"ar": "اتصل بمدير حسابك"
	},
	"dld_rvs_Inquiry_about_contractual_disputes_description": {
		"en": "An automated responses to inquiries concerning contractual disputes or instances of unwillingness to fulfill the contract.",
		"ar": "تتيح هذه الخدمة للمتعامل الحصول على رد الي على الاستفسارات عن الخلافات التعاقدية أو عدم الرغبة في استكمال التعاقد."
	},
	"form_validate_contract_end_date": {
		"en": "Please enter the valid contract end date",
		"ar": "يرجى إدخال تاريخ انتهاء العقد صحيح"
	},
	"Abu_Dhabi_Option_label": {
		"en": "Abu Dhabi",
		"ar": "أبو ظبي"
	},
	"form_validate_upload_passport_copy": {
		"en": "Please upload the passport copy",
		"ar": "يرجى رفع نسخة جواز السفر"
	},
	"home_banner_Download_it_Now": {
		"en": "Download it Now",
		"ar": "تحميل الان"
	},
	"contract_amount_aed": {
		"en": "Contract Amount (AED)",
		"ar": "قيمة العقد (درهم)"
	},
	"partnershipDLDSP": {
		"en": "Dubai Land Services Partners",
		"ar": "شركاء خدمات الدائرة"
	},
	"heritage": {
		"en": "Heritage",
		"ar": "مناطق تاريخية"
	},
	"file_size_big": {
		"en": "File size is too big. Max. allowed file size: {{fi-maxSize}}MB",
		"ar": "حجم الملف كبير جدا ماكس. حجم الملف المسموح به: {{fi-maxSize}} ميغابايت"
	},
	"post_dev_title": {
		"en": "Post Development Stage",
		"ar": "مرحلة ما بعد التطوير العقاري"
	},
	"birth_place_english": {
		"en": "Birth Place(English)",
		"ar": "مكان الميلاد (الإنجليزية)"
	},
	"our_partners": {
		"en": "Our Partners",
		"ar": "شركائنا"
	},
	"judicial_warning_certificate": {
		"ar": "إفادة الإنذار العدلي",
		"en": "Judicial Warning Certificate"
	},
	"indexes_dashboard_description": {
		"en": "Comprehensive dashboard for the real estate official indexes providing insights and deep analysis for each market performance index.",
		"ar": "لوحة تحكم شاملة للمؤشرات العقارية الرسمية، تقدم رؤى وتحليلات عميقة لكل مؤشر أداء سوقي."
	},
	"investment_type": {
		"en": "Investment Type",
		"ar": "نوع الإستثمار"
	},
	"create_vault": {
		"en": "Create Vault",
		"ar": "قم بإنشاء الخزينة الرقمية"
	},
	"all_activities": {
		"en": "View All Activities",
		"ar": "عرض جميع الأنشطة"
	},
	"project_value": {
		"en": "Project Value",
		"ar": "قيمة المشروع"
	},
	"sub_area_label": {
		"en": "Sub Area",
		"ar": "المنطقة الفرعية"
	},
	"home_jointly_owned_property_in_emirate_of_Dubai": {
		"en": "Jointly Owned Property \u003Cbr/\u003Ein the Emirate of Dubai",
		"ar": "ملكية العقارات المشتركة \u003Cbr/\u003Eفي إمارة دبي"
	},
	"emirati-program-broker_license": {
		"en": "Get National Broker License",
		"ar": "الحصول على رخصة الوسيط الوطني"
	},
	"search_label": {
		"en": "Search",
		"ar": "بحث"
	},
	"add_owner": {
		"en": "Add Owner",
		"ar": "إضافة مالك"
	},
	"Knowledge_Fee": {
		"en": "Knowledge Fee",
		"ar": "رسوم المعرفة"
	},
	"male": {
		"en": "Male",
		"ar": "الذكر"
	},
	"Services": {
		"en": "Services",
		"ar": "الخدمات"
	},
	"owner_service": {
		"en": "Owner\u003Cbr /\u003E Services",
		"ar": "خدمات \u003Cbr /\u003E المالك"
	},
	"Licensed_Brokers_And_Developers_title": {
		"en": "Licensed Brokers And Developers",
		"ar": "الوسطاء والمطورين المرخصين"
	},
	"main_area_label": {
		"en": "Main Area",
		"ar": "المنطقة الرئيسية"
	},
	"find_us_via_google_map": {
		"en": "Find us via google map",
		"ar": "موقعنا علي خريطة جوجل"
	},
	"green_list_tc_2": {
		"en": "I release the Dubai Land Department from any legal responsibility regarding the use of brokers from the data available to them through the system.",
		"ar": "أخلي مسؤولية دائرة الأراضي والأملاك من أي مسؤولية قانونية بخصوص استخدام الوسطاء من البيانات المتوفرة لهم من خلال النظام."
	},
	"add_service_desc": {
		"en": "We have listed down multiple services which you might require during the development process.",
		"ar": "لقد قمنا بإدراج العديد من الخدمات التي قد تحتاجها أثناء عملية التطوير."
	},
	"view_port": {
		"en": "Login to View your Portfolio & Manage your Profile, request for whomsoever it may concern, manage Ejari and conduct Property Services such as \"Download Title Deed Certificate\"",
		"ar": "تسجيل الدخول لعرض محفظتك وإدارة ملفك التعريفي ، وطلب لمن يهمه الأمر ، وإدارة برنامج إيجاري وإجراء خدمات عقارية مثل \"تنزيل شهادة سند الملكية\""
	},
	"apply_now": {
		"en": "Apply Now",
		"ar": "قدم الآن"
	},
	"download_service_documents": {
		"en": "Download Service Document",
		"ar": "تحميل ملفات الخدمة"
	},
	"property_expenses": {
		"en": "Property Expenses",
		"ar": "نفقات العقار"
	},
	"makani_inp_label": {
		"en": "Makani Number",
		"ar": "رقم مكاني"
	},
	"valuation_company_description": {
		"ar": "ابحث عن قائمة شركات التقييم العقاري المعتمدة والمرخصة من قبل مؤسسة التنظيم العقاري في إمارة دبي.",
		"en": "Search for valuation companies licensed by the Real Estate Regulatory Agency in Dubai."
	},
	"ejari_unified_tenancy_contract_URL": {
		"en": "https://dubailand.gov.ae/media/ivuhfjxa/ejari_unified_tenancy_contract_v3.pdf",
		"ar": "https://dubailand.gov.ae/media/ivuhfjxa/ejari_unified_tenancy_contract_v3.pdf"
	},
	"choose_your_case_type": {
		"ar": "اختر نوع الدعوى",
		"en": "Choose your case type"
	},
	"auction_noti_msg_lini_1_1": {
		"en": "https://emart.dubailand.gov.ae/Listings/ListingAuctionDetails.aspx?WAVqnAVPb29lh7UtGXKJ%2fF5TTDcYvNfmEXovUqKyqFdBtkj4AzgSfjGLXll1P8nA",
		"ar": "https://emart.dubailand.gov.ae/Listings/ListingAuctionDetails.aspx?WAVqnAVPb29lh7UtGXKJ%2fF5TTDcYvNfmEXovUqKyqFdBtkj4AzgSfjGLXll1P8nA"
	},
	"vacant": {
		"en": "Vacant",
		"ar": "شاغر"
	},
	"standard": {
		"en": "Standard",
		"ar": "اساسي"
	},
	"ex_label": {
		"en": "For example",
		"ar": "على سبيل المثال"
	},
	"validate_owner": {
		"en": "Validate Owner and Property",
		"ar": "التحقق من صحة المالك والممتلكات"
	},
	"home_madmoun_desc": {
		"ar": "تأكد من صحة تصريح الإعلان العقاري الصادر عن مؤسسة التنظيم العقاري، وذلك عبر مسح رمز الاستجابة السريعة QR المرفق مع الإعلان، والذي يُتيح لك التحقق مما إذا كان التصريح معتمداً من دائرة الأراضي والأملاك في دبي",
		"en": "Validate the property advertisement permit given by RERA. The validation will be through the QR Code, authentic and approved by Dubai Land Department"
	},
	"service_terms": {
		"en": "Service Terms",
		"ar": "شروط الخدمة"
	},
	"steps_board_members": {
		"en": "Here are the steps to register as a member of the Owner Committee :",
		"ar": "فيما يلي خطوات التسجيل كعضو في لجنة الملاك:"
	},
	"studies": {
		"en": "Studies",
		"ar": "الدراسات"
	},
	"size_mb": {
		"en": "MB",
		"ar": "ميغا بايت"
	},
	"real_estate_broker": {
		"en": "Real Estate \u003Cbr/\u003EBrokers Application",
		"ar": "الوسطاء \u003Cbr/\u003Eالعقاريين"
	},
	"Add_to_Favorite": {
		"en": "Add to Favorites",
		"ar": "إضافة إلى المفضلة "
	},
	"with_survey": {
		"en": "With Survey",
		"ar": "مع المسح"
	},
	"community-name": {
		"en": "Community Name",
		"ar": "اسم المجتمع"
	},
	"your_email": {
		"en": "Your Email",
		"ar": "بريدك الالكتروني"
	},
	"supplier_charter": {
		"en": "Supplier Charter",
		"ar": "ميثاق المورد"
	},
	"Trade_License_Source": {
		"en": "Trade License Source",
		"ar": "مصدر رخصة التدريب"
	},
	"please_enter_otp": {
		"en": "Please enter the OTP",
		"ar": "يرجى ادخال رمز المرور للمرة الواحدة"
	},
	"e_g_community": {
		"ar": "e.g. Palm Jumeirah",
		"en": "e.g. Palm Jumeirah"
	},
	"other": {
		"en": "Other",
		"ar": "أخرى"
	},
	"form_validate_company_name": {
		"en": "Please select a company name",
		"ar": "يرجى إختيار اسم الشركة / رقم الرخصة"
	},
	"did_you_know": {
		"en": "Did you Know ?",
		"ar": "هل تعلم؟"
	},
	"contactus_label": {
		"en": "Contact Us",
		"ar": "اتصل بنا"
	},
	"ejari_system_info": {
		"en": "Ejari system to regulate and facilitate property leasing.",
		"ar": "نظام إيجاري لتنظيم وتسهيل تأجير العقارات."
	},
	"form_valid_email_label": {
		"en": "Please enter a valid email address",
		"ar": "رجاء قم بإدخال بريد الكتروني صحيح"
	},
	"leaser_type": {
		"en": "Leaser Type",
		"ar": "نوع المؤجر"
	},
	"real_estate_project_status": {
		"en": "Real Estate Project Status",
		"ar": "حالة مشروع عقاري"
	},
	"Registration tooltip": {
		"en": "Registration",
		"ar": "خدمات التسجيل"
	},
	"dev_book_read_more": {
		"en": "More info about Handbook",
		"ar": "اقرأ المزيد حول دليل المطور"
	},
	"Fujairah_Option_label": {
		"en": "Fujairah",
		"ar": "الفجيرة"
	},
	"UAE Telecommunications Company (Etisalat)": {
		"en": "UAE Telecommunications Company (Etisalat)",
		"ar": "شركة الإمارات للاتصالات (اتصالات)"
	},
	"version": {
		"en": "Version",
		"ar": "الإصدار"
	},
	"news_show_more": {
		"en": "View all News",
		"ar": "عرض المزيد من الأخبار"
	},
	"transaction_details": {
		"en": "Transaction Details",
		"ar": "تفاصيل المعاملة"
	},
	"activity_date": {
		"en": "Activity Date",
		"ar": "التاريخ"
	},
	"help": {
		"en": "Help",
		"ar": "مساعدة"
	},
	"introStep2": {
		"en": "\u003Ch5 class='font-weight-bold'\u003EYour Account with Land Department\u003C/h5\u003E\u003Cp\u003EYou can now access DLD website in English and Arabic, access your profile, manage your properties and perform transactions.\u003C/p\u003E",
		"ar": "\u003Ch5 class='font-weight-bold'\u003Eملفك مع دائرة الارضي\u003C/h5\u003E\u003Cp\u003Eيمكنك الان استخدام الموقع بالانجليزيه و العربيه,الوصول لحسابك.اداره ممتلكاتك و عمل المعاملات.\u003C/p\u003E"
	},
	"form_validate_reference_number": {
		"en": "Please enter a valid reference number",
		"ar": "يرجى إدخال رقم مرجعي صحيح"
	},
	"property_blocking": {
		"en": "Property Blocking",
		"ar": "ايقافات العقار"
	},
	"faq_choose_question_category": {
		"en": "Choose Question Category",
		"ar": "اختر فئة السؤال"
	},
	"case_registration_date": {
		"en": "Case Registration Date",
		"ar": "تاريخ تسجيل القضية"
	},
	"rt_procedure_details": {
		"en": "Procedure Details",
		"ar": "تفاصيل الإجراءات"
	},
	"passcode_desc": {
		"en": "Passcode is a 4- to 6-digit password used to grant access to the application, similar to the code you use for an ATM bank card or a debit card.",
		"ar": "رمز المرور هو كلمة مرور مكونه من 4 حتى 6 ارقام تستخدم للدخول اللتطبيقاتمثل الرمز المستخدم في بطاقات الصراف الالي"
	},
	"eid_help": {
		"en": "You can find your Emirates ID number on the front side of the card, labeled as ID Number and starting with 784",
		"ar": "يمكنك العثور على رقم الهوية الإماراتية الخاص بك على الجانب الأمامي للبطاقة ، المسمى برقم الهوية والبدء بـ 784"
	},
	"rvs_transaction_completed_msg": {
		"en": "Your process has been completed",
		"ar": "Your process has been completed"
	},
	"all_projects": {
		"en": "All Projects",
		"ar": "كل المشاريع"
	},
	"vault_verify_mobile": {
		"en": "We have sent an OTP to the following Number",
		"ar": "لقد أرسلنا الرمز التعريفي إلى الرقم التالي"
	},
	"remember_me": {
		"en": "Remember me",
		"ar": "تذكرنى"
	},
	"developer_service": {
		"ar": "خدمات \u003Cbr /\u003E المطور",
		"en": "Developer\u003Cbr /\u003E Services"
	},
	"Re-Shield-Ask_Question": {
		"en": "Ask a Question",
		"ar": "اسأل سؤال"
	},
	"project_status_freezed": {
		"en": "Freezed",
		"ar": "مجمدة"
	},
	"forgot_password": {
		"en": "Forgot Password",
		"ar": "نسيت كلمة المرور"
	},
	"home_title_deed_service": {
		"ar": "خدمات بيانات \u003Cbr\u003E الملكية العقارية",
		"en": "Title Deed\u003Cbr\u003E Data Services"
	},
	"login_as": {
		"en": "Sign in as",
		"ar": "دخول الى النظام"
	},
	"request_number": {
		"en": "Request Number",
		"ar": "رقم الطلب"
	},
	"pay": {
		"en": "Pay",
		"ar": "دفع"
	},
	"complain_desc": {
		"en": "Complain Description",
		"ar": "تفاصيل الشكوى"
	},
	"tabu_upload_documents_note": {
		"en": "Note: Maximum file size allowed is 2mb. Allowed files type are .jpg, .png and .pdf",
		"ar": "ملاحظة: أقصى حجم مسموح به للملف هو 2 ميجابايت. نوع الملفات المسموح بها هي .jpg و .png و .pdf"
	},
	"subscribe_msg": {
		"en": "You have successfully subscribed to Dubai Land Department’s \u003Cb\u003EDeveloper Portal\u003C/b\u003E\u003Cbr /\u003E\u003Cbr /\u003E\n                        You will receive occasional newsletter from Dubai Land Department that will provide you latest updates regarding Developer Portal.",
		"ar": "لقد اشتركت بنجاح في \u003Cb\u003E دليل التطوير العقاري \u003C/b\u003E التابع لدائرة الأراضي والأملاك \u003Cbr /\u003E \u003Cbr /\u003E\n                         ستتلقى من حين لآخر نشرة إخبارية من دائرة الأراضي والأملاك في دبي تزودك بآخر التحديثات المتعلقة بدليل التطوير العقاري."
	},
	"partnershipDLDSAOTitle": {
		"en": "Certified Auditors",
		"ar": "المدققين الماليين المعتمدين"
	},
	"approved_developers_title": {
		"en": "Approved Real Estate Developers",
		"ar": "المطورين العقاريين المرخصين"
	},
	"registred_apps": {
		"en": "Websites for which you have successfully registered",
		"ar": "مواقع الويب التي قمت بالتسجيل فيها بنجاح"
	},
	"rdc_system_info": {
		"en": "RDC to manage rental dispute cases",
		"ar": "مركز فض المنازعات لإدارة قضايا المنازعات الإيجارية"
	},
	"home_Manage_Your_Co_occupants": {
		"en": "Manage\u003Cbr/\u003EYour Co-occupants",
		"ar": "إدارة بيانات\u003Cbr/\u003E القاطنين"
	},
	"committee_status": {
		"en": "Committee Status",
		"ar": "حالة اللجنة"
	},
	"Ask_Malik_title": {
		"en": "Ask Malik",
		"ar": "اسأل مالك"
	},
	"service_third_party": {
		"en": "Third Parties / Partners",
		"ar": "الشركاء  الخارجيين"
	},
	"rt_proceed_parties_information": {
		"en": "Proceed to Parties Information",
		"ar": "انتقل إلى معلومات الأطراف"
	},
	"no_properties_owned": {
		"en": "No. of properties owned",
		"ar": "عدد العقارات المملوكة"
	},
	"ejari_request_received": {
		"en": "Request Received",
		"ar": "Request Received"
	},
	"propertyAuction_Participate": {
		"en": "Participate",
		"ar": "المشاركة"
	},
	"about_the_training": {
		"ar": "نبذة عن التدريب",
		"en": "About the Training"
	},
	"ApprovedBrokers": {
		"en": "Licensed \u003Cbr/\u003EReal Estate Brokers",
		"ar": "الوسطاء العقاريين المرخصين"
	},
	"view_all_activities": {
		"en": "View All Services",
		"ar": "عرض كل الأنشطة"
	},
	"top_mortgaged": {
		"en": "Top Mortgaged",
		"ar": "أعلى الرهونات"
	},
	"passport_copy": {
		"en": "Passport copy of the authorized signature",
		"ar": "نسخة من جواز السفر للتوقيع المعتمد"
	},
	"curr_project": {
		"en": "Current Project/ Contract",
		"ar": "المشروع الحالي / العقد"
	},
	"call_us": {
		"en": "Call Us",
		"ar": "اتصل بنا"
	},
	"partnershipDLDS_AccountTrusteesDescription": {
		"en": "Account trustees are financial institutions or banks approved for the management of escrow account for real estate projects, which is filed by the mortgage payments from buyers of units on the map or the financiers of the project.",
		"ar": "هي المؤسسات المالية أو المصرفية المعتمدة لادارة حساب الضمان الخاصة بالمشروع العقاري الذي يودع فيه المبالغ المدفوعة من المشترين لوحدات على الخارطة أو من الممولين للمشروع"
	},
	"back_to_home": {
		"en": "Back to Homepage",
		"ar": "العودة للصفحة الرئيسية"
	},
	"property_view": {
		"en": "View",
		"ar": "الواجهة"
	},
	"enter_your_message": {
		"en": "Enter your Message",
		"ar": "أدخل رسالتك"
	},
	"owned": {
		"en": "Owned",
		"ar": "مملوكة"
	},
	"Home_training_Course": {
		"en": "Training Courses \u003Cbr/\u003Eand Exams ",
		"ar": "الدورات \u003Cbr/\u003Eالتدريبية و الاختبارات"
	},
	"total_buildings": {
		"en": "Total Buildings ",
		"ar": "مجموع المباني"
	},
	"Previous_Inspection": {
		"en": "Previous Inspection",
		"ar": "الفحص السابق"
	},
	"Speak Now": {
		"en": "Speak now...",
		"ar": "تكلم الأن..."
	},
	"form_validate_claimant_type": {
		"en": "Please select the claimant type",
		"ar": "يرجى إختيار صفة المشتكى"
	},
	"Active Projects": {
		"en": "Active Projects",
		"ar": "مشاريع نشطة"
	},
	"error_title": {
		"en": "Page not found",
		"ar": "الصفحة غير موجودة"
	},
	"license_activities": {
		"en": "License Activities",
		"ar": "أنشطة الترخيص"
	},
	"pic_file_picker_help": {
		"en": "Drag 'n' drop photo here, or click to select files",
		"ar": "اسحب وأفلت الصورة هنا ، أو انقر لتحديد الملفات"
	},
	"flexible_timings": {
		"en": "Flexible Timings",
		"ar": "الأوقات المرنة"
	},
	"mali_call_documents": {
		"en": "Documents",
		"ar": "المستندات"
	},
	"bc_dld_object_text": {
		"en": "DLD seeks to achieve the objectives of Dubai Government's strategy in the real estate sector, and improve land registration procedures according to latest international systems and practices in the real estate sector.",
		"ar": "تعمل دائرة الأراضي والأملاك في دبي على تحقيق الأهداف الاستراتيجية للحكومة في القطاع العقاري، وتطوير أنظمة التسجيل لمواكبة أحدث النظم العالمية من خلال تطوير استراتيجية متكاملة للتنمية العقارية في الإمارة، وصولاً إلى أرقى المستويات العالمية"
	},
	"notice_date": {
		"en": "Notice Date",
		"ar": "تاريخ"
	},
	"print": {
		"en": "Print",
		"ar": "طباعة"
	},
	"property_description": {
		"en": "Property Description",
		"ar": "وصف العقار"
	},
	"commercial_license": {
		"en": "Commercial License",
		"ar": "رخصة تجارية"
	},
	"login_to_account_as": {
		"en": "Login to your account as",
		"ar": "تسجيل الدخول إلى حسابك"
	},
	"owned_area": {
		"en": "Owned Area",
		"ar": "المساحة المملوكة"
	},
	"more-escrow-account-balance": {
		"en": "Escrow Account Balance",
		"ar": "رصيد حساب الضمان"
	},
	"form_validate_building_number": {
		"en": "Please enter a valid building number",
		"ar": "يرجى إدخال رقم المبنى صحيح"
	},
	"annual-rental-value": {
		"en": "Annual Rental Value (AED)",
		"ar": "القيمة الايجارية السنوية بالدرهم"
	},
	"important_note": {
		"en": "Important Note",
		"ar": "ملاحظة مهمة"
	},
	"form_validate_name": {
		"en": "Please enter a valid name",
		"ar": "يرجى إدخال الإسم صحيح"
	},
	"PropertyTrusteeOffices": {
		"en": "Property Trustee Offices",
		"ar": "مكاتب أمناء الخدمات العقارية"
	},
	"Home_Download_Ejari_Certificate_text": {
		"en": "The Ejari certificate, an official PDF document generated by the Ejari system, will be available to download by entering the Contract Information. The Ejari certificate can be used with other government bodies as proof of tenancy contract attestation.",
		"ar": "وثيقة ايجاري هي وثيقة رسمية انتجت عن طريق نظام ايجاري و ستكون جاهزة للتحميل بعد ادخال بيانات العقد.وثيقة ايجاري تستخدم مع الهيئات الحكوميه الاخري كدليل على اعتماد عقد الايجار"
	},
	"accessRentalIndexFromDubaiRest": {
		"en": "To access the Rental Calculator, download Dubai REST Application",
		"ar": "لاستعمال الحاسبة الايجارية  الرجاء تحميل تطبيق دبى ريست"
	},
	"sso_app_desc_rvs": {
		"en": "The real estate violation system aims to record all notes and complaints in order to safeguard the rights of parties.",
		"ar": "يهدف نظام المخالفات العقارية لتسجيل جميع الملاحظات و الشكاوى حفاظا على حقوق الأطراف."
	},
	"form_validate_area_square": {
		"en": "Please select an area (Sq.Ft)",
		"ar": "يرجى إختيار المنطقة (قدم مربع)"
	},
	"track_request": {
		"en": "You can track your request in \n 'My Requests'.",
		"ar": "يمكنك تتبع طلبك في \n طلباتي."
	},
	"more-stage-of-completion1": {
		"en": "At what stage of completion are you looking for?",
		"ar": "ما هي مرحلة الإنجاز التي تبحث عنها؟"
	},
	"security_deposit": {
		"en": "Security Deposit",
		"ar": "مبلغ التأمين"
	},
	"jop_management_company": {
		"en": "Mollak Management Company",
		"ar": "شركة جمعية الملاك"
	},
	"tittle_deed_login_label": {
		"en": "Title Deed",
		"ar": "ملكية العقار"
	},
	"shops": {
		"en": "Shops",
		"ar": "محلات"
	},
	"Important_Links": {
		"en": "Important Links",
		"ar": "روابط هامة"
	},
	"dld_account_coming_soon_account": {
		"en": "Following are the accounts which will be coming soon.",
		"ar": "فيما يلي الحسابات التي ستصدر قريبًا."
	},
	"rvs-case-no-validation-msg": {
		"en": "Please enter the correct Complaint number in the specified format (e.g., XXX/YYYY)",
		"ar": "يرجى ادخال رقم الشكوى حسب التنسيق المحدد (على سبيل المثال: XXX/YYYY) "
	},
	"rvs_company_search_val_msg": {
		"en": "Please select Complain Type & Complain Category to search Company.",
		"ar": "يرجى تحديد نوع الشكوى وفئة الشكوى للبحث عن شركة"
	},
	"accept": {
		"en": "Accept",
		"ar": "موافق"
	},
	"Re-Shield-Share-Q-A": {
		"en": "Share this Q & A",
		"ar": "شارك هذه الأسئلة والأجوبة"
	},
	"to_whom_it_may_concern_description": {
		"ar": "تقدم بطلب للحصول على بيان أملاك المتعامل أو شهادة استيفاء بالمتطلبات الخاصة بإدارة العقارات.",
		"en": "Apply for a Statement of customer property or a Certificate of Satisfaction of property management Requirements."
	},
	"update_diff_mobile_email": {
		"en": "Please enter different Mobile number/Email",
		"ar": "من فضلك ادخل رقم جوال/بريد اليكترونى مختلف"
	},
	"annual_rent_label": {
		"en": "Current Annual Rent",
		"ar": "الأيجار السنوي حالياً"
	},
	"claimant_type": {
		"en": "Claimant Type",
		"ar": "صفة المشتكى"
	},
	"valuation_company_title": {
		"en": "Approved Valuation Companies",
		"ar": "شركات التقييم العقاري المعتمدة"
	},
	"form_validate_inquiry_type": {
		"en": "Please select an inquiry type",
		"ar": "يرجى إختيار نوع الإستفسار"
	},
	"footer_noqodi_payment_text": {
		"en": " Payment\u003Cbr/\u003E Support",
		"ar": "دعم \u003Cbr/\u003E خدمة"
	},
	"form_validate_nationality": {
		"en": "Please select nationality",
		"ar": "يرجى إختيار الجنسية"
	},
	"parcel_id": {
		"en": "Parcel Id",
		"ar": "معرف الطرد"
	},
	"Re-Shield-Form-Name": {
		"en": "What's your Name? *",
		"ar": "اسمك؟*"
	},
	"home_licensing_service": {
		"en": "Real Estate\u003Cbr\u003E Licensing Services",
		"ar": "خدمات \u003Cbr\u003E الترخيص العقاري"
	},
	"uploaded_success": {
		"en": "File uploaded Successfully, you will be redirect to Search page..",
		"ar": "تم تحميل الملف بنجاح ، ستتم إعادة توجيهك إلى صفحة البحث .."
	},
	"register_ejari_contract": {
		"ar": "طلب تسجيل وتجديد عقد الإيجار",
		"en": "Registration and renewal of lease application"
	},
	"login_again": {
		"en": "Sign in again",
		"ar": "تسجيل الدخول مرة أخرى"
	},
	"subject-placeholder": {
		"en": "Please enter subject",
		"ar": "الرجاء إدخال الموضوع"
	},
	"land_title_deed": {
		"en": "Last Title Deed",
		"ar": "أخر ملكية"
	},
	"e_g_date": {
		"en": "e.g. 01/01/2000",
		"ar": "e.g. 01/01/2000"
	},
	"DubaiPlan": {
		"en": "Dubai plan 2021",
		"ar": "خطة دبي 2021"
	},
	"inactive": {
		"ar": "غير نشط",
		"en": "Inactive"
	},
	"reset": {
		"en": "Reset",
		"ar": "إعادة تعيين"
	},
	"emirati-program-passport-issue-place": {
		"en": "Passport Issue Place",
		"ar": "مكان اصدار الجواز"
	},
	"Initial_Sales_Contract": {
		"en": "Initial Sales Contract",
		"ar": "عقد البيع المبدئي"
	},
	"adoption_date": {
		"en": "Adoption Date",
		"ar": "تاريخ الاعتماد"
	},
	"daily": {
		"en": "Daily",
		"ar": "يومياً"
	},
	"working_day_three": {
		"en": "1 working day",
		"ar": "1 يوم عمل"
	},
	"creation_date": {
		"en": "Creation Date",
		"ar": "تاريخ الإنشاء"
	},
	"DLD": {
		"en": "DLD",
		"ar": "دائرة الأراضي والاملاك"
	},
	"transaction_by_area": {
		"en": "View All Transactions",
		"ar": "عرض جميع المعاملات العقارية"
	},
	"banner-btc-title": {
		"en": "Official Courses for Broker Training & Certification",
		"ar": "الدورات الرسمية لتدريب الوسطاء العقاريين\u003Cbr/\u003E والحصول على الاعتماد من الدائرة"
	},
	"footer_connect_desc": {
		"en": "We're here to help you. Find the answers and while you're at it, tell us how we could do better.",
		"ar": "نحن هنا لمساعدتك. ابحث عن اجابات لأسئلتك, واخبرنا كيف يمكن ان نخدمك بشكل أفضل."
	},
	"service_charge_index": {
		"en": "Service Charge Index",
		"ar": "مؤشر رسوم الخدمة"
	},
	"minimum_password_number": {
		"en": "One Number",
		"ar": "رقم واحد"
	},
	"party_name": {
		"en": "Party Name",
		"ar": "اسم الطرف"
	},
	"Home_DLD_Partners_Services": {
		"en": "Land Department Partners",
		"ar": "شركاء دائرة الاراضي والاملاك"
	},
	"max_characters": {
		"en": "Max ~ characters",
		"ar": "~ حرف كحد أقصى"
	},
	"form_validate_fax_number": {
		"en": "Please enter a valid fax number",
		"ar": "يرجى إدخال رقم فاكس صحيح"
	},
	"email_sent_msg": {
		"en": "Email is sent successfully",
		"ar": "تم ارسال الرسالة للبريد الالكتروني"
	},
	"more-mobile": {
		"en": "Mobile *",
		"ar": "الهاتف المتحرك*"
	},
	"Total_text": {
		"en": "Total",
		"ar": "مجموع"
	},
	"contact_developer": {
		"ar": "اتصل بالمطور",
		"en": "Contact Developer"
	},
	"rt_register_transaction_at_rt_office": {
		"en": "Register Transaction at RT Office",
		"ar": "تسجيل المعاملات في مكتب أمين التسجيل العقاري"
	},
	"comp_establish_contract": {
		"en": "Company Establishment Contract",
		"ar": "عقد تأسيس الشركة"
	},
	"awareness_description": {
		"en": "Stay in constant contact with the Land Department to increase your real estate knowledge through the 24/7 awareness service, as this service allows access to the \nmost important laws and questions related to the real estate sector.",
		"ar": "ابقى على تواصل دائم  مع دائرة الاراضي والاملاك لزيادة معرفتك العقارية من خلال خدمة توعية 24/7 حيث تتيح هذه الخدمة الاطلاع على اهم القوانين والاسئلة المتعلقة بالقطاع العقاري "
	},
	"bank_information": {
		"en": "Bank Information",
		"ar": "معلومات البنك"
	},
	"headTitle": {
		"en": "Dubai Land Department",
		"ar": "دائرة الأراضي والأملاك"
	},
	"form_validate_sub_land_number": {
		"en": "Please enter a valid sub land number",
		"ar": "يرجى إدخال رقم الأرض الفرعية صحيح"
	},
	"cppi-dcppi-date": {
		"en": "United Arab Emirates | November 2021",
		"ar": "United Arab Emirates | November 2021"
	},
	"sale_Second_Means": {
		"en": "means Resale",
		"ar": "الثاني بمعنى إعادة البيع"
	},
	"email_verification_code": {
		"en": "Email verification code",
		"ar": "رمز التحقق من البريد الإلكتروني"
	},
	"Section": {
		"en": "Section",
		"ar": "القسم"
	},
	"login_via_uae_pass": {
		"en": "Login via UAE PASS Only",
		"ar": "تسجيل الدخول بالهوية الرقمية فقط"
	},
	"form_validate_bank_address": {
		"en": "Please enter a bank address",
		"ar": "يرجى إدخال عنوان البنك صحيح"
	},
	"FAQs_on_all_services": {
		"en": "FAQs on all services from DLD",
		"ar": "شاهد كل الاسئلة في دائرة الأراضي"
	},
	"methodology": {
		"en": "Methodology",
		"ar": "حساب المؤشر"
	},
	"dld_rvs_desc": {
		"en": "Record all notes and complaints in order to safeguard the rights of parties",
		"ar": "تسجيل جميع الملاحظات والشكاوى من أجل حماية حقوق الأطراف"
	},
	"e_g_building": {
		"ar": "e.g. Building",
		"en": "e.g. Building"
	},
	"real_estate_broker_text": {
		"en": "Dubai Brokers is a smart application launched for the real estate agents, investors, and real estate brokers to provide accurate, real time information about Dubai Brokers.",
		"ar": "تم إطلاق تطبيق وسطاء دبي مستهدفا شريحة كبيرة من المستفيدين كشركات العقارات، المستثمرين والوسطاء العقاريين حيث يوفر التطبيق معلومات دقيقة ومحدثة آنيا عن وسطاء دبي."
	},
	"register_as_an_owner_register_label": {
		"en": "Sign up as an Individual",
		"ar": "سجل كفرد"
	},
	"rvs_system_info": {
		"en": "Real Estate Violation System (RVS) to manage complaints.",
		"ar": "نظام المخالفات العقارية لإدارة الشكاوى العقارية."
	},
	"reach_us_via_phone": {
		"en": "Reach us via Phone",
		"ar": "تواصل معنا عبر الهاتف"
	},
	"transaction_type": {
		"en": "Transaction Type",
		"ar": "نوع المعاملة"
	},
	"business_user": {
		"en": "As a Business User you can..",
		"ar": "بصفتك مستخدمًا تجاريًا ، يمكنك .."
	},
	"company_owners": {
		"en": "Company Owners",
		"ar": "ملاك الشركة"
	},
	"service_label": {
		"en": "Services",
		"ar": "الخدمات"
	},
	"address2": {
		"en": "Address 2",
		"ar": "العنوان 2"
	},
	"RDC": {
		"en": "RDC",
		"ar": "مركز فض المنازعات الايجارية"
	},
	"company_name_english": {
		"en": "Company Name English",
		"ar": "اسم الرخصة انجليزى"
	},
	"email": {
		"en": "Email Address",
		"ar": "البريد الالكتروني"
	},
	"e_g_year": {
		"ar": "e.g. 2010",
		"en": "e.g. 2010"
	},
	"retail_sub_type": {
		"en": "Retail Sub Type",
		"ar": "نوع العقار الفرعية"
	},
	"email_placeholder": {
		"en": "eg: john.doe@gmail.com",
		"ar": "مثال: john.doe@gmail.com"
	},
	"rt_disclaimer": {
		"en": "By submitting this request, I confirm that procedure has no broker(s).",
		"ar": "من خلال تقديم هذا الطلب ، أؤكد أن المعاملة ليس لها وسيط."
	},
	"cheque_return_reason_description": {
		"ar": "الوصف",
		"en": "Description"
	},
	"more-residential-categories": {
		"en": "Residential Categories",
		"ar": " الفئات السكنية"
	},
	"contact_twitter": {
		"en": "Contact Us on Twitter",
		"ar": "تابعنا علي تويتر"
	},
	"go_to_dubai_court": {
		"en": "Dubai Court, Case No:",
		"ar": "محاكم دبي، قضية رقم:"
	},
	"technical_support_modal_title": {
		"en": "Technical Support",
		"ar": "دعم تقني"
	},
	"Chat_label": {
		"en": "Chat",
		"ar": "التواصل"
	},
	"more-filters": {
		"en": "Filters",
		"ar": "محدد البحث"
	},
	"register_as_bussiness_users": {
		"en": "Sign up as Business User",
		"ar": "سجل كمستخدم أعمال"
	},
	"report": {
		"en": "Report",
		"ar": "تقرير"
	},
	"Home_Project_Status_Proceed": {
		"en": "Track Project Status",
		"ar": "تابع حالة مشروعك"
	},
	"client_name": {
		"en": "Client Name",
		"ar": "اسم العميل"
	},
	"form_validation_group": {
		"en": "form validation group",
		"ar": "form validation group"
	},
	"rt_system_info": {
		"en": "System for RT offices to register the key real estate procedures",
		"ar": "نظام مكاتب أمناء التسجيل لتسجيل الإجراءات العقارية الرئيسية"
	},
	"lic_issue_date": {
		"en": "License Issue Date",
		"ar": "تاريخ إصدار الرخصة"
	},
	"partnershipDLDS_OwnersAssociationsDes": {
		"en": "Owner associations are financial institutions or banks approved for the management of the escrow account of owners’ associations, these associations are entrusted by a Board of Directors elected by the owners to manage the building with a joint ownerships",
		"ar": "هي المؤسسات المالية أو المصرفية المعتمدة لادارة حساب ضمان جمعيات الملاك التى يناط بها إدارة المبنى ذو الملكلية المشتركة من مجلس إدارة منتخب من قبل الملاك"
	},
	"arabic": {
		"en": "Arabic",
		"ar": "عربي"
	},
	"city": {
		"en": "City",
		"ar": "مدينة"
	},
	"claimant_defendant_details_same_msg": {
		"en": "Claimant and Defendant details should not be the same.",
		"ar": "بيانات المشتكى و المشتكي عليه يجب ان تكون مختلفة."
	},
	"renew": {
		"en": "Renew",
		"ar": "تجديد"
	},
	"participant_own_props": {
		"en": "Participant Status",
		"ar": "حالة الطرف"
	},
	"location": {
		"ar": "الموقع",
		"en": "Location"
	},
	"form_validate_land_number": {
		"en": "Please enter a valid land number",
		"ar": "يرجى إدخال رقم الأرض صحيح"
	},
	"sign_out": {
		"en": "Logout",
		"ar": "خروج"
	},
	"Facebook": {
		"en": "Facebook",
		"ar": "فيس بوك"
	},
	"ind_reg": {
		"en": "Register as an Individual",
		"ar": "تسجيل كمستخدم عادي"
	},
	"All Services": {
		"en": "All Services",
		"ar": "جميع الخدمات"
	},
	"company_search_filter_required_msg": {
		"en": "Please fill in at least one of the fields from search criteria",
		"ar": "يرجى ادخال احد بيانات البحث على الاقل"
	},
	"total_rent_payable": {
		"en": "Total Rent Payable",
		"ar": "إجمالي الإيجار المستحق"
	},
	"municipality_map_issue_data": {
		"en": "Municipality Map Issue Date",
		"ar": "تاريخ الإصدار الخريطة - البلدية"
	},
	"notes_label": {
		"en": "Notes",
		"ar": "ملاحظات"
	},
	"customer_support": {
		"en": "Customer\u003Cbr/\u003ESupport",
		"ar": "خدمة \u003Cbr/\u003Eالمتعاملين "
	},
	"dev_step_4": {
		"en": "Step 04",
		"ar": "الخطوة 04"
	},
	"invalid_mobile_number": {
		"en": "Invalid mobile number",
		"ar": "رقم الهاتف الجوال غير صحيح"
	},
	"rt_procedure_details_desc": {
		"en": "Select your transaction and registration trustee office.",
		"ar": "حدد مكتب أمين التسجيل والإجراء المطلوب."
	},
	"attachment": {
		"en": "Attachment",
		"ar": "المرفقات"
	},
	"home_Connect": {
		"en": "Connect",
		"ar": "اتصل بنا"
	},
	"home_favorite_services": {
		"en": "My Favorite Services",
		"ar": "خدماتي المفضلة"
	},
	"Complaints_Suggestions": {
		"en": "Complaints & Suggestions",
		"ar": "الشكاوي والاقتراحات"
	},
	"request_sent_date": {
		"en": "Request Sent Date",
		"ar": "تاريخ ارسال الطلب"
	},
	"party_type": {
		"en": "Party Type",
		"ar": "نوع الطرف"
	},
	"non_contractual_complaint_exit": {
		"en": "Exit",
		"ar": "خروج"
	},
	"suggestions_complains": {
		"en": "Suggestions and Complaints",
		"ar": "الاقتراحات و الشكاوي"
	},
	"license_information": {
		"en": "License Information",
		"ar": "تفاصيل الترخيص"
	},
	"home_dev_guide_title": {
		"en": "Real Estate Development Guide",
		"ar": "دليل التطوير العقاري"
	},
	"emarati_service_platform": {
		"en": "SERVICES PLATFORM",
		"ar": "خدمــات المواطنيــن"
	},
	"search_by_id": {
		"en": "Search By UAE ID No",
		"ar": "البحث عن طريق رقم الهوية الإماراتية"
	},
	"matching-with": {
		"en": "matching with",
		"ar": "البحث عن"
	},
	"UAE_Nation_Brand": {
		"en": "UAE Nation Brand",
		"ar": "الهوية الإعلامية المرئية للإمارات"
	},
	"join": {
		"en": "Join",
		"ar": "انضمام"
	},
	"home_Register_Complaint": {
		"en": "Register Complaint",
		"ar": "تسجيل شكوى"
	},
	"real_estate_brokerage_practice_guide": {
		"ar": "Real Estate Brokerage Practice Guide",
		"en": "Real Estate Brokerage Practice Guide"
	},
	"total_area": {
		"en": "Total Area",
		"ar": "المساحة الكلية"
	},
	"false": {
		"en": "No",
		"ar": "لا"
	},
	"Verify_Valuation_Certificate": {
		"en": "Verify Valuation Certificate",
		"ar": "التحقق من شهادة تقييم دائرة الأراضي"
	},
	"home_Executive_Courses": {
		"en": "Executive Courses",
		"ar": "الدورات التدريبة التنفيذة"
	},
	"propertyAuctionStartDate": {
		"en": "Starting 31/10/2021 to 11/11/2021",
		"ar": "من تاريخ 31/10/2021 إلى 11/11/2021"
	},
	"create_user_name_pwd": {
		"en": "Create username and password",
		"ar": "تسجيل اسم مستخدم و كلمة مرور"
	},
	"social_responsibility_in_state": {
		"en": "Commitment to social responsibility within the state.",
		"ar": "مدى التزامه بالمسؤوليّة المُجتمعيّة داخل الدولة."
	},
	"no_result_EjariCertificate": {
		"en": "We could not find any data based on the information which you had provided.",
		"ar": "لم نتمكن من العثور على أي بيانات بناءً على المعلومات التي قدمتها."
	},
	"escrow_agent": {
		"en": "Escrow Agent",
		"ar": "وكيل الضمان"
	},
	"Dubai_Commercial_Property_Price_Index_CPPI": {
		"en": "Dubai Commercial Property Price Index (CPPI)",
		"ar": "مؤشر أسعار البيع للعقارات التجارية في إمارة دبي"
	},
	"card_type": {
		"en": "Card Type",
		"ar": "نوع البطاقة"
	},
	"property": {
		"ar": "ملكية",
		"en": "Property"
	},
	"grace_date_validation": {
		"en": "Grace Period should be either from a Contract Start Date or end of the Contract.",
		"ar": "يجب أن تكون فترة السماح إما من تاريخ بدء العقد أو نهاية العقد."
	},
	"ip-access-request1": {
		"en": "has been sent to User Profiling Project Portal",
		"ar": "تم الارسال الى بوابة تصنيف المستثمر"
	},
	"e_g_job_title": {
		"ar": "e.g. Manager",
		"en": "e.g. Manager"
	},
	"annual_amount": {
		"en": "Annual Amount",
		"ar": "القيمة السنوية"
	},
	"required": {
		"en": "Required",
		"ar": "مطلوب"
	},
	"emirates_id_backside": {
		"en": "Emirates ID (Backside)",
		"ar": "الهوية الإماراتية (الجهة الخلفية)"
	},
	"Department": {
		"en": "Department",
		"ar": "الادارة"
	},
	"nationallity_label": {
		"en": "Nationallity",
		"ar": "الجنسية"
	},
	"retech_desc": {
		"en": "Dubai RE-Tech, a platform that provides a unique view of the Dubai real estate market by leveraging advanced machine learning technology",
		"ar": "Dubai RE-Tech ، منصة توفر رؤية فريدة لسوق العقارات في دبي من خلال الاستفادة من تكنولوجيا التعلم الآلي المتقدمة"
	},
	"otp_verification_msg": {
		"en": "We will be sending an One Time Password (OTP) to your mobile number for verification.",
		"ar": "سنرسل لك  رمز مرور يستخدم لمرة واحدة على رقم هاتفك للتحقق منه"
	},
	"vip_requests": {
		"en": "VIP Requests",
		"ar": "طلبات كبار الشخصيات"
	},
	"blocking_date": {
		"en": "Blocking Date",
		"ar": "تاريخ الإيقاف"
	},
	"general_info": {
		"en": "General Information",
		"ar": "معلومات عامة"
	},
	"contact_the_customer_and_inform_solution": {
		"en": "Contact the customer\u003Cbr /\u003E and inform the solution",
		"ar": "التواصل مع المتعامل وتزويده\u003Cbr/\u003E بإجراءات الحلّ"
	},
	"service_fee": {
		"en": "Service Fees",
		"ar": "رسوم الخدمة"
	},
	"request_sub_type": {
		"en": "Request Sub Type",
		"ar": "الطلب  الفرعي"
	},
	"real_estate_experience": {
		"en": "Real Estate Experience",
		"ar": "خبرة مكتب الوسيط العقارى"
	},
	"start": {
		"en": "Start",
		"ar": "ابدأ"
	},
	"click_here": {
		"en": "Click here",
		"ar": "اضغط هنا"
	},
	"form_validate_trade_license_number": {
		"en": "Please enter a valid trade license number",
		"ar": "يرجى إدخال رقم الرخصة التجارية صحيح"
	},
	"Procedure_Label": {
		"en": "Procedure",
		"ar": "الإجراء"
	},
	"Participating Entities": {
		"en": "Participating Entities",
		"ar": "الكيانات المشاركة"
	},
	"yes_cancel_reg": {
		"en": "Yes",
		"ar": "نعم"
	},
	"Inquiry on Request Status": {
		"en": "Inquiry on Request Status",
		"ar": "الاستعلام عن حالة الطلب"
	},
	"cu_Working_hours": {
		"en": "Check our Hours",
		"ar": "ساعات العمل"
	},
	"vault_delete_folder": {
		"en": "Delete Folder",
		"ar": "احذف المجلد"
	},
	"offplan_properties": {
		"en": "Off-Plan Properties",
		"ar": "العقارات على الخارطة"
	},
	"rvs_login": {
		"en": "Login to RVS, RT, eMortgage, Ejari, RDC, Mollak and so on.",
		"ar": "تسجيل الدخول إلى RVS و RT و eMortgage و Ejari و RDC و Mollak وما إلى ذلك."
	},
	"freehold": {
		"en": "Freehold",
		"ar": "التملك الحر"
	},
	"owner_committee_terms_val_4": {
		"en": "Not to cause any nuisance on the common area of the Jointly Owned Property.",
		"ar": "عدم التسبب بأي إزعاج في المناطق العقار المشترك."
	},
	"Transactions Property Data Development Services": {
		"en": "Transaction Services",
		"ar": "خدمات التصرفات العقارية"
	},
	"project_number": {
		"en": "Project Number",
		"ar": "رقم المشروع"
	},
	"green_list_tc_3": {
		"en": "In the event the person withdraws from the old system, data should be used by the brokers who obtained it when he was on the list.",
		"ar": "في حال انسحاب الشخص من النظام القديم استخدام بيانات من قبل الوسطاء الذين حصلوا عليها عند وجوده في القائمة."
	},
	"partnershipDLDS_OwnersAssociationsTitle": {
		"en": "Jointly Owned Property Management Companies",
		"ar": "شركات إدارة العقارات ذات الملكية المشتركة"
	},
	"dewa": {
		"en": "DEWA Premise Number",
		"ar": "رقم العقار – هيئة كهرباء ومياه دبي"
	},
	"similar_label": {
		"en": "Related Content",
		"ar": "محتوي مشابه"
	},
	"validate": {
		"en": "Validate",
		"ar": "يدقق"
	},
	"company_information": {
		"ar": "بيانات الشركة",
		"en": "Company Information"
	},
	"indexes_dashboard": {
		"en": "Indexes\u003Cbr /\u003E Dashboard",
		"ar": "لوحة المؤشرات"
	},
	"form_validate_enter_trade_license_source": {
		"en": "Please enter Trade License Source",
		"ar": "الرجاء إدخال مصدر الرخصة التجارية"
	},
	"login_via_uae_pass_text": {
		"en": "Starting 1st January 2024, you will need to login to the following systems via UAE PASS only \u003Cbr/\u003E Oqood, Registration Trustee, Property Trustee, Ejari, Trakheesi and Mollak.",
		"ar": "ابتداءً من الأول من يناير 2024، سيكون تسجيل الدخول للأنظمة التالية عبر الهوية الرقمية فقط : عقود، أمين التسجيل، الأمين العقاري، تراخيصي، ملاك"
	},
	"home_Education_All_Course": {
		"en": "View All Courses",
		"ar": "عرض جميع الدورات التدريبة"
	},
	"dev_title": {
		"en": "Development Stage",
		"ar": "مرحلة التطوير"
	},
	"manager_details": {
		"en": "Manager Details",
		"ar": "تفاصيل مدير"
	},
	"broker_number_text": {
		"en": "Broker Number",
		"ar": "رقم الوسيط"
	},
	"vault_no_folders": {
		"en": "No Folders",
		"ar": "لا توجد مجلدات"
	},
	"emirati-program-eid-expiry": {
		"en": "Emirates ID Expiry",
		"ar": "تاريخ انتهاء الهوية"
	},
	"partnershipGovernmentalPartnersDescription": {
		"en": "This category includes partners in the government and private sector in the United Arab Emirates. These are mostly strategic partners, as they are working with DLD with a plan to achieve a goal or to provide services.",
		"ar": "تشمل هذه الفئة الشركاء في القطاع الحكومي والخاص في دولة الإمارات العربية المتحدة ويغلب عليها في الأغلب الطابع الاستراتيجي حيث أنها تتشارك مع الدائرة في تحقيق هدف ما أو يتم العمل معه من خلال العمليات التشغيلية في تقديم الخدمات"
	},
	"picked_up": {
		"en": "Picked Up",
		"ar": "التقط"
	},
	"online_payment_e_pay": {
		"en": "Online Payment (E-Pay)",
		"ar": "الدفع الإلكتروني"
	},
	"Re-Shield-Form-UserType": {
		"en": "You are a/an *",
		"ar": "هل انت؟*"
	},
	"sale_First_Means": {
		"en": "means First Sale of Property",
		"ar": "الأول بمعنى المبايعة الأولى"
	},
	"trustee_centres": {
		"en": "Trustee\u003Cbr /\u003E Centres",
		"ar": "مراكز الأمناء "
	},
	"Real Estate Price index for 2nd quarter": {
		"en": "Real Estate Price index for 2nd quarter",
		"ar": "المؤشر لأسعار العقارات للربع الثاني"
	},
	"Download_Unified_Ejari_Tenancy_Contract": {
		"en": "Download Unified\u003Cbr/\u003EEjari Tenancy Contract",
		"ar": "تحميل عقد إيجار الموحد"
	},
	"view_on_map": {
		"en": "View on map",
		"ar": "العرض على الخارطة"
	},
	"auditor_remarks": {
		"ar": "ملاحظات المدقق",
		"en": "Auditor Remarks"
	},
	"bank_letter": {
		"en": "Bank Letter",
		"ar": "خطاب بنكي"
	},
	"villa": {
		"en": "Villa",
		"ar": "فيلا"
	},
	"power_of_att": {
		"en": "Power of attorney authorized to sign for the company",
		"ar": "توكيل المخول بالتوقيع عن الشركة"
	},
	"please_contact_support": {
		"en": "Please contact Dubai Land Department at",
		"ar": "يرجى الاتصال بدائرة الأراضي والأملاك في دبي على"
	},
	"sale": {
		"en": "Sale",
		"ar": "بيع"
	},
	"eid_validation_error": {
		"en": "Your Emirates ID record already exists in the system.",
		"ar": "رقم الهوية مسجل في النظام مسبقا."
	},
	"form_validate_SME_certificate": {
		"en": "Please upload SME member certificate",
		"ar": "يرجى رفع عضو مؤسسة محمد بن راشد لدعم المشاريع الصغيرة والمتوسطة"
	},
	"ip-access-request": {
		"en": "Access Request",
		"ar": "عذرًا ليس لديك الصلاحية للوصول لهذه الصفحة"
	},
	"public_facility": {
		"en": "Public Facilities",
		"ar": "مرافق عامة"
	},
	"enable_green_list": {
		"en": "I pledge ~ the property owner to abide by all the terms and conditions for participation in the system as described below:",
		"ar": "أتعهد انا ~ مالك العقار بأن ألتزم بجميع الأحكام والشروط الخاصة بالمشاركة في النظام حسب الموضح ادناه:"
	},
	"passport_details": {
		"en": "Emirates ID and Passport Details",
		"ar": "بطاقة الهوية الإماراتية وبيانات جواز السفر"
	},
	"search_for _other_service": {
		"en": "Search for any other service",
		"ar": "ابحث عن أي خدمة أخرى"
	},
	"otp_invalid": {
		"en": "Invalid OTP",
		"ar": "كود التحقق غير صحيح"
	},
	"Ajman_Option_label": {
		"en": "Ajman",
		"ar": "عجمان"
	},
	"Twitter": {
		"en": "Twitter",
		"ar": "تويتر"
	},
	"Verdict_Publications": {
		"en": "Verdict Publications",
		"ar": "نشر الأحكام"
	},
	"DLD_Reference_Number": {
		"ar": "الرقم المرجعي لدائرة الأراضي والأملاك",
		"en": "DLD Reference Number"
	},
	"rt_parties_information_desc": {
		"en": "Add buyer details and update owner details.",
		"ar": "قم بإضافة تفاصيل المشتري ثم قم بتحديث تفاصيل المالك."
	},
	"home_banner_webinar_description_text": {
		"en": "This webinar will highlight the main results of Dubai real estate sector annual report 2020, and will provide an analysis for the recent trends in the real estate market.",
		"ar": "سيقدم هذا الملتقي تحليلا شاملا للنتائج الرئيسية في تقرير أداء القطاع العقاري في إمارة دبي 2020، كما سيسلط الضوء على اهم النتائج والاتجاهات المتوقعة في أداء القطاع."
	},
	"contract_start_date": {
		"en": "Contract Start Date",
		"ar": "تاريخ بداية العقد"
	},
	"download-PDF": {
		"en": "Download PDF",
		"ar": "تحميل ملف PDF"
	},
	"building_levels": {
		"en": "Buidling Levels",
		"ar": "مستويات البناء"
	},
	"dld_map_issue_data": {
		"en": "DLD Map Issue Date",
		"ar": "تاريخ الإصدار الخريطة - دائرة الأراضي"
	},
	"real_estate_brokerage_practice_guide_ar": {
		"en": "دليل ممارسة مهنة الوساطة العقارية",
		"ar": "دليل ممارسة مهنة الوساطة العقارية"
	},
	"Inquiry on Tenant": {
		"en": "Inquiry on Tenant",
		"ar": "استعلام عن المستأجر"
	},
	"capital_value": {
		"en": "Capital Value",
		"ar": "رأس المال"
	},
	"villa_name": {
		"en": "Villa Name",
		"ar": "اسم فيلا"
	},
	"ManagementCompanies": {
		"en": "Management Companies",
		"ar": "البحث عن شركات إدارة العقارات"
	},
	"description": {
		"en": "Description",
		"ar": "وصف"
	},
	"sso_app_desc_api": {
		"en": "API-enabled ecosystems are at the forefront of the digital era and changing the digital business landscape at a rapid pace. Elevate your customer experience by integrating your apps with DLD systems like Ejari, Mollak, and Trakheesi.",
		"ar": "تحتل النظم البيئية التي تدعم واجهة برمجة التطبيقات موقع الصدارة في العصر الرقمي وتغير مشهد الأعمال الرقمية بوتيرة سريعة. ارتقِ بتجربة عملائك من خلال دمج تطبيقاتك مع أنظمة دائرة الأراضي والأملاك في دبي مثل إيجاري وملاك وتراخيصي."
	},
	"Dubai Civil Aviation Authority": {
		"en": "Dubai Civil Aviation Authority",
		"ar": "هيئة دبي للطيران المدني"
	},
	"form_validate_mobile_number": {
		"en": "Please enter a valid mobile number",
		"ar": "يرجى إدخال رقم الهاتف المحمول صحيح"
	},
	"lease_management_company": {
		"en": "Lease Management Company",
		"ar": "شركة الإدارة"
	},
	"sme_member_certificate": {
		"en": "SME Member Certificate",
		"ar": "يرجي رفع شهادة العضوية"
	},
	"Land Department Approved": {
		"en": "Land Department Approved",
		"ar": "المعتمدة من دائرة الأراضي"
	},
	"back_to_list": {
		"en": "Back To List",
		"ar": "عودة الي القائمة"
	},
	"please_enter_the_otp_on": {
		"en": "Please enter the OTP received on",
		"ar": "من فضلك ادخل كود التحقق"
	},
	"vault_current_folder_name": {
		"en": "Current Folder Name",
		"ar": "اسم المجلد الحالي"
	},
	"download_certificate": {
		"en": "Download Certificate",
		"ar": "تحميل شهادة الملكية"
	},
	"villa_number": {
		"en": "Villa Number",
		"ar": "رقم الفيلا"
	},
	"leased_amount": {
		"en": "Leased Amount",
		"ar": "المبلغ الإيجار"
	},
	"municipality_number": {
		"en": "Municipality Number",
		"ar": "رقم البلدية"
	},
	"company": {
		"en": "Company",
		"ar": "شركة"
	},
	"indus_label": {
		"en": "Industrial",
		"ar": "صناعي"
	},
	"Government_of_Dubai": {
		"en": "Government of Dubai",
		"ar": "حكومة دبي "
	},
	"number_of_transactions": {
		"en": "Number of Transactions",
		"ar": "عدد المعاملات"
	},
	"cases_details": {
		"en": "Now you can download enforcement cases details",
		"ar": "يمكنك الان تحميل صحيفة الحالة الايجارية"
	},
	"request_sent_msg": {
		"en": "Your request has been submitted successfully. \u003Cbr /\u003EYou will be notified via Email.",
		"ar": "لقد تم تقديم طلبكم بنجاح \u003Cbr /\u003Eسيتم إرسال بريد الكتروني"
	},
	"Expo2020": {
		"en": "Expo 2020",
		"ar": "إكسبو 2020"
	},
	"more-financial-information": {
		"en": "Financial Information",
		"ar": "المعلومات المالية"
	},
	"export_as_pdf": {
		"en": "Export as PDF",
		"ar": "تصدير إلي PDF"
	},
	"agricultural": {
		"en": "Agricultural",
		"ar": "زراعي"
	},
	"name_arabic": {
		"en": "Name (Arabic)",
		"ar": "الإسم (بالعربية)"
	},
	"Sector": {
		"en": "Sector",
		"ar": "القطاع"
	},
	"nearest_metro": {
		"en": "Nearest Metro",
		"ar": "أقرب مترو"
	},
	"company_name": {
		"en": "Company Name",
		"ar": "اسم الشركة"
	},
	"property_status_inquiry": {
		"en": "Inquiry about a property status",
		"ar": "الإستعلام عن حالة عقار "
	},
	"read_more": {
		"en": "Read More",
		"ar": "اقرأ المزيد"
	},
	"Property_Location": {
		"ar": "موقع العقار",
		"en": "Property Location"
	},
	"project_status_cancelled": {
		"en": "Cancelled",
		"ar": "ألغيت"
	},
	"person_search": {
		"en": "Person Search",
		"ar": "بحث عن الاشخاص"
	},
	"update_profile_agreement": {
		"en": "Please read the Terms and Conditions:\nIn case of owner's data modification, whether mobile number or e-mail, it will be modified in the records of Dubai Land Department database only, and therefore the owner is fully responsible for updating other records related to the property such as developers, brokers, escrow account, or banks",
		"ar": "يرجى قراءة الشروط والاحكام في حال تعديل بيانات المالك سواء رقم الهاتف المتحرك او البريد الالكتروني فانه سيتم التعديل على بيانات سجلات دائرة الأراضي والاملاك فقط وعليه فان المالك يتحمل المسؤولية الكاملة في تحديث السجلات الأخرى المتعلقة بالعقار مثل المطورين ،الوسطاء حساب الضمان البنوك"
	},
	"form_validate_request_type": {
		"en": "Please select the request type",
		"ar": "يرجى إختيار نوع الطلب"
	},
	"total_price": {
		"en": "Total Price",
		"ar": "السعر الإجمالي"
	},
	"more-request-success-msg": {
		"en": "Request Submit Successfully!",
		"ar": "تم إرسال الطلب بنجاح!"
	},
	"From_label": {
		"en": "From",
		"ar": "من"
	},
	"i_am_tenant": {
		"en": "I'm a Tenant",
		"ar": "أنا مستأجر"
	},
	"MortgageConsultancy": {
		"en": "Mortgage Consultancy",
		"ar": "استشارات الرهن العقاري"
	},
	"Nationals_Option": {
		"en": "Nationals",
		"ar": "المواطنين"
	},
	"date": {
		"en": "Date",
		"ar": "التاريخ"
	},
	"form_validate_select_country": {
		"en": "Please select a country",
		"ar": "يرجى إختيار اسم بلد"
	},
	"ranking": {
		"en": "Ranking",
		"ar": "التصنيف"
	},
	"rt_select_procedure_type": {
		"en": "Select Procedure Type",
		"ar": "حدد نوع الإجراء"
	},
	"request_type": {
		"en": "Request Type",
		"ar": "نوع الطلب"
	},
	"Course_Video": {
		"en": "Course Video",
		"ar": "فيديو الدورة"
	},
	"finished_projects": {
		"en": "Finished Projects",
		"ar": "المشاريع المكتملة"
	},
	"h_Raise_a_Complaint": {
		"en": "04 Unified interactive platform",
		"ar": "منصة \"04\" الموحدة للتواصل"
	},
	"ValuationCompanies": {
		"en": "Valuation Companies",
		"ar": "شركات التقييم العقاري"
	},
	"defendant": {
		"ar": "المدعى عليه",
		"en": "Defendant"
	},
	"Value_Amount_Label": {
		"en": "Purchase Amount (AED)",
		"ar": "قيمة البيع للعقار (درهم)"
	},
	"Unable_to_Process": {
		"ar": "Unable to Process",
		"en": "Unable to Process"
	},
	"Home_rental_calculator_text": {
		"en": "The Rental Calculator helps to determine the average rent in their area and whether they are entitled to any increase in the annual rent based on the current rent index.",
		"ar": "الاله الحاسبة العقارية تساعدك في تحديد متوسط القيمة الايجارية في المنطقه المحددة و ايضا ان كانت القيمه قابلة للزياده بناء على مؤشر الايجاري الحالي"
	},
	"rvs-case-number": {
		"en": "RVS Complaint Number",
		"ar": "رقم الشكوى العقارية"
	},
	"rt_upload_documents_and_submit_desc": {
		"en": "Upload required procedure documents for RT office review and submit the transaction to RT office. Track the procedure status from My Requests.",
		"ar": "قم بتحميل المستندات المطلوبة وإرسال الطلب للمراجعة من قبل مكتب أمين التسجيل. تتبع حالة الإجراء من قسم طلباتي."
	},
	"home_dubai_rest_desc": {
		"en": "World's smartest real estate platform!!!",
		"ar": "أذكي منصة عقارية في العالم!!!"
	},
	"cheque_drawn_on_bank": {
		"ar": "البنك",
		"en": "Bank "
	}
}
